/**
 * 统一监控平台相关action
 */
// import oData from '../server/odataEquipment';
import oData from '../server/odata_equipment_client';
import * as ofbiz from '../server/ofbiz';
import { adaptMonitorTreeToLegacy, adaptEquipmentDetailToLegacy, normalizeDisabled } from '../server/ofbiz/adapters';
import { equipmentTypeToClassEnum, classEnumToEquipmentType } from '../server/ofbiz/equipmentTypeMap';
import ResourceUtils from '../script/resourceUtils';
import TreeUtil from '../script/treeUtil.js';
import Util from '../script/utils.js';
import ServerEquipment from '../server/serverEquipment';

import * as createMonitorModalTexts from '../script/createMonitorModal_i18n_zh';
import * as requestDataActions from './requestData_action';
import { getTreeNodeAssociation } from './deviceMonitor_action';
import { openResourcePanel } from './deviceMonitorTree_action';
import { createOperationAudit } from './operationAudit_action';
//var AddMonitorModel = require('./common/createResourceView_addMonitorModel');

// 常用监测器类型
var commonMonitorNames = ["Ping", "CPU", "Memory", "Port", "DiskSpace", "Process", "SnmpCpu", "SnmpMemory", "SnmpDisk", "SnmpProcess", "NetworkCpu", "NetworkMemory"];

export const SET_ERRORALARM = 'SET_ERRORALARM'
export const SET_GOODALARM = 'SET_GOODALARM'
export const SET_WARNINGALARM = 'SET_WARNINGALARM'
export const SET_LOGGOOD = 'SET_LOGGOOD'
export const SET_LOGERROR = 'SET_LOGERROR'
export const SET_LOGDANGER = 'SET_LOGDANGER'
export const SET_LOGBAN = 'SET_LOGBAN'
export const SET_FUNCTIONVALUE = 'SET_FUNCTIONVALUE'
export const SET_MONITORS = 'SET_MONITORS'
// export const SET_CURFUNCVALNAME = 'SET_CURFUNCVALNAME'
// export const SET_CURFUNCVALAVG = 'SET_CURFUNCVALAVG'
// export const SET_CURFUNCVALMAX = 'SET_CURFUNCVALMAX'
// export const SET_CURFUNCVALMIN = 'SET_CURFUNCVALMIN'
// export const SET_CURFUNCVALNEW = 'SET_CURFUNCVALNEW'
export const SET_FUNCVALUE = 'SET_FUNCVALUE'
export const SET_CURTOWHOURNAME = 'SET_CURTOWHOURNAME'
export const SET_CURTOWHOURVALUE = 'SET_CURTOWHOURVALUE'
export const SET_TWOHOURSREPORT = 'SET_TWOHOURSREPORT'
export const SET_MONITORTABLEDATA = 'SET_MONITORTABLEDATA'
export const SET_MONITORSSTATUS = 'SET_MONITORSSTATUS'
export const SET_MONITORFILTERSTATUS = 'SET_MONITORFILTERSTATUS'
export const SET_GROUPID = 'SET_GROUPID'
export const SET_EQUIPMENTS = 'SET_EQUIPMENTS'
export const SET_SUBGROUPS = 'SET_SUBGROUPS'
export const SET_STATUS = 'SET_STATUS'
export const SET_GROUPINFOFILTERSTATUS = 'SET_GROUPINFOFILTERSTATUS'
export const SET_MONITORTABLESELECTFIRSTFLAG = 'SET_MONITORTABLESELECTFIRSTFLAG'
export const SET_SELECTEDMONITORNAME = 'SET_SELECTEDMONITORNAME'
export const SET_RESOURCESETTREE = 'SET_RESOURCESETTREE'
export const SET_EQUIPMENTIDNTZ = 'SET_EQUIPMENTIDNTZ'
export const SET_ALARMRULESARRAY = 'SET_ALARMRULESARRAY'
export const SET_EQUIPMENTID = 'SET_EQUIPMENTID'
export const SET_BCLICKTREENODE = 'SET_BCLICKTREENODE'
export const SET_ONTREENODECLICK = 'SET_ONTREENODECLICK'
export const SET_BCLICKDESVIEWMONITORTABLEROW = 'SET_BCLICKDESVIEWMONITORTABLEROW'
export const SET_GETMONITORDATAFILTER = 'SET_GETMONITORDATAFILTER'
export const SET_TREEIDS = 'SET_TREEIDS'
export const SET_OLDTREE = 'SET_OLDTREE'
export const SET_ASSETIDNTZ = 'SET_ASSETIDNTZ'
export const SET_CREATERESOURCEVIEWID = 'SET_CREATERESOURCEVIEWID'
export const SET_SELECTEDRESOURCE = 'SET_SELECTEDRESOURCE'
export const SET_BACKUPRESOURCE = 'SET_BACKUPRESOURCE'
export const SET_CREATEMONITORVIEWID = 'SET_CREATEMONITORVIEWID'
export const SET_SELECTEDMONITOR = 'SET_SELECTEDMONITOR'
export const SET_CREATERESOURCESTABLEDATA = 'SET_CREATERESOURCESTABLEDATA'
export const SET_CREATEMONITORSTABLEDATA = 'SET_CREATEMONITORSTABLEDATA'
export const SET_SELECTEDNODE = 'SET_SELECTEDNODE'
export const SET_SELECTEDNODE_ID = 'SET_SELECTEDNODE_ID'
export const SET_BACKUPTREENODE = 'SET_BACKUPTREENODE'

export const SET_RESOURCETYPES = 'SET_RESOURCETYPES'
export const SET_COMMONMONITORS = 'SET_COMMONMONITORS'
export const SET_MONITORALARMCONDITIONNAMEDATA = 'SET_MONITORALARMCONDITIONNAMEDATA'
export const SET_MONITORERRORALARMTEXT = 'SET_MONITORERRORALARMTEXT'
export const SET_MONITORWARNINGALARMTEXT = 'SET_MONITORWARNINGALARMTEXT'
export const SET_MONITORGOODALARMTEXT = 'SET_MONITORGOODALARMTEXT'
export const SET_MONITORERRORCONDITIONSDATA = 'SET_MONITORERRORCONDITIONSDATA'
export const SET_MONITORSETTINGERRORCONDITIONSDATA = 'SET_MONITORSETTINGERRORCONDITIONSDATA'
export const SET_MONITORWARNINGCONDITIONSDATA = 'SET_MONITORWARNINGCONDITIONSDATA'
export const SET_MONITORSETTINGWARNINGCONDITIONSDATA = 'SET_MONITORSETTINGWARNINGCONDITIONSDATA'
export const SET_MONITORGOODCONDITIONSDATA = 'SET_MONITORGOODCONDITIONSDATA'
export const SET_MONITORSETTINGGOODCONDITIONSDATA = 'SET_MONITORSETTINGGOODCONDITIONSDATA'
export const SET_DELETEMONITORALARMCONDITIONSDATA = 'SET_DELETEMONITORALARMCONDITIONSDATA'
export const SET_EQUIPMENTSERVERADDRESS = 'SET_EQUIPMENTSERVERADDRESS'
export const SET_EQUIPMENTMODEL = 'SET_EQUIPMENTMODEL'
export const SET_NAVIGATEFROMCREATEMONITORVIEWFLAG = 'SET_NAVIGATEFROMCREATEMONITORVIEWFLAG'
export const SET_MONITORDISKS = 'SET_MONITORDISKS'
export const SET_MONITORHASDISKS = 'SET_MONITORHASDISKS'
export const SET_SELECTEDMONITORDISK = 'SET_SELECTEDMONITORDISK'
export const SET_MONITORDISKINODES = 'SET_MONITORDISKINODES'
export const SET_MONITORHASDISKINODES = 'SET_MONITORHASDISKINODES'
export const SET_SELECTEDMONITORDISKINODES = 'SET_SELECTEDMONITORDISKINODES'
export const SET_MONITORDISKIONAMES = 'SET_MONITORDISKIONAMES'
export const SET_MONITORHASDISKIONAMES = 'SET_MONITORHASDISKIONAMES'
export const SET_SELECTEDMONITORDISKIONAME = 'SET_SELECTEDMONITORDISKIONAME'
export const SET_NETWORKS = 'SET_NETWORKS'
export const SET_HASNETWORKS = 'SET_HASNETWORKS'
export const SET_SELECTEDNETWORK = 'SET_SELECTEDNETWORK'
export const SET_MONITORNETWORKS = 'SET_MONITORNETWORKS'
export const SET_MONITORHASNETWORKS = 'SET_MONITORHASNETWORKS'
export const SET_SELECTEDMONITORNETWORK = 'SET_SELECTEDMONITORNETWORK'
export const SET_MONITORPROCESSES = 'SET_MONITORPROCESSES'
export const SET_MONITORHASPROCESSES = 'SET_MONITORHASPROCESSES'
export const SET_SELECTEDMONITORPROCESS = 'SET_SELECTEDMONITORPROCESS'
export const SET_MONITORSERVICES = 'SET_MONITORSERVICES'
export const SET_MONITORHASSERVICES = 'SET_MONITORHASSERVICES'
export const SET_SELECTEDMONITORSERVICE = 'SET_SELECTEDMONITORSERVICE'
export const SET_MONITORNTEVENTLOGS = 'SET_MONITORNTEVENTLOGS'
export const SET_SELECTEDMONITORNTEVENTLOG = 'SET_SELECTEDMONITORNTEVENTLOG'
export const SET_MONITORSCRIPTS = 'SET_MONITORSCRIPTS'
export const SET_SELECTEDMONITORSCRIPT = 'SET_SELECTEDMONITORSCRIPT'
export const SET_GETMONITORSPROPERTYDATADONEFLAG = 'SET_GETMONITORSPROPERTYDATADONEFLAG'
export const SET_GETALARMCONDITIONDATADONEFLAG = 'SET_GETALARMCONDITIONDATADONEFLAG'
export const SET_GETMYSQLMONITORCOUNTERDATADONEFLAG = 'SET_GETMYSQLMONITORCOUNTERDATADONEFLAG'
export const SET_GETSQLSERVERMONITORCOUNTERDATADONEFLAG = 'SET_GETSQLSERVERMONITORCOUNTERDATADONEFLAG'
export const SET_MONITORS_PROPERTY_DATA = 'SET_MONITORS_PROPERTY_DATA'
export const SET_MONITORS_PROPERTY_EDIT = 'SET_MONITORS_PROPERTY_EDIT'
export const SET_MONITORS_MYSQL_COUNTERDATA = 'SET_MONITORS_MYSQL_COUNTERDATA'
export const SET_MONITORS_MYSQL_PROPERTYCOUNTERDATA = 'SET_MONITORS_MYSQL_PROPERTYCOUNTERDATA'
export const SET_MONITORS_MYSQL_CURRENTCOUNTER = 'SET_MONITORS_MYSQL_CURRENTCOUNTER'
export const SET_MONITORSCRIPTS_ENTRYALIAS= 'SET_MONITORSCRIPTS_ENTRYALIAS'
export const SET_GETMONITORSENTRYALIASDATADONEFLAG= 'SET_GETMONITORSENTRYALIASDATADONEFLAG'
export const SET_GETMONITORSSNMPMIBFILEDATADONEFLAG= 'SET_GETMONITORSSNMPMIBFILEDATADONEFLAG'
export const SET_MONITORS_ORACLE_COUNTERDATA = 'SET_MONITORS_ORACLE_COUNTERDATA'
export const SET_MONITORS_ORACLE_PROPERTYCOUNTERDATA = 'SET_MONITORS_ORACLE_PROPERTYCOUNTERDATA'
export const SET_MONITORS_ORACLE_CURRENTCOUNTER = 'SET_MONITORS_ORACLE_CURRENTCOUNTER'
export const SET_GETOracleMONITORCOUNTERDATADONEFLAG = 'SET_GETOracleMONITORCOUNTERDATADONEFLAG'
export const SET_MONITORSNMPMIBFILE= 'SET_MONITORSNMPMIBFILE'
export const SET_SELECTEDMONITORSNMPMIBCOUNTER= 'SET_SELECTEDMONITORSNMPMIBCOUNTER'
export const SET_MONITORSNMPMIBCOUNTER= 'SET_MONITORSNMPMIBCOUNTER'
export const SET_SELECTEDMONITORMONGOQUERY= 'SET_SELECTEDMONITORMONGOQUERY'
export const SET_MONITORSTORAGEDISKS= 'SET_MONITORSTORAGEDISKS'
export const SET_SELECTEDMONITORSTORAGEDISK= 'SET_SELECTEDMONITORSTORAGEDISK'
export const SET_MONITORSTORAGECACHES= 'SET_MONITORSTORAGECACHES'
export const SET_MONITORIPMISENSORCOUNTERS= 'SET_MONITORIPMISENSORCOUNTERS'
export const SET_SELECTEDMONITORIPMISENSORCOUNTER= 'SET_SELECTEDMONITORIPMISENSORCOUNTER'
export const SET_MONITORSTORAGEPROCESSORS= 'SET_MONITORSTORAGEPROCESSORS'
export const SET_SELECTEDMONITORSTORAGEPROCESSOR= 'SET_SELECTEDMONITORSTORAGEPROCESSOR'
export const SET_MONITORFIBRECHANNELSTATUSNODES= 'SET_MONITORFIBRECHANNELSTATUSNODES'
export const SET_SELECTEDMONITORFIBRECHANNELSTATUSNODES= 'SET_SELECTEDMONITORFIBRECHANNELSTATUSNODES'
export const SET_MONITORSTORAGEVOLUMEFILES= 'SET_MONITORSTORAGEVOLUMEFILES'
export const SET_SELECTEDMONITORSTORAGEVOLUMEFILE= 'SET_SELECTEDMONITORSTORAGEVOLUMEFILE'
export const SET_MONITORSQLSERVERCOUNTERS= 'SET_MONITORSQLSERVERCOUNTERS'
export const SET_MONITORS_SQLSERVER_PROPERTYCOUNTERDATA= 'SET_MONITORS_SQLSERVER_PROPERTYCOUNTERDATA'
export const SET_SELECTEDMONITORSQLSERVERCOUNTER= 'SET_SELECTEDMONITORSQLSERVERCOUNTER'
export const SET_MONITORROOMENVIRONMENTOBJECTS= 'SET_MONITORROOMENVIRONMENTOBJECTS'
export const SET_SELECTEDMONITORROOMENVIRONMENTOBJECT= 'SET_SELECTEDMONITORROOMENVIRONMENTOBJECT'
export const SET_MONITORWEBLOGICEXECUTEQUEUES= 'SET_MONITORWEBLOGICEXECUTEQUEUES'
export const SET_SELECTEDMONITORWEBLOGICEXECUTEQUEUE= 'SET_SELECTEDMONITORWEBLOGICEXECUTEQUEUE'
export const SET_MONITORWEBLOGICWEBAPPS= 'SET_MONITORWEBLOGICWEBAPPS'
export const SET_SELECTEDMONITORWEBLOGICWEBAPP= 'SET_SELECTEDMONITORWEBLOGICWEBAPP'
export const SET_MONITORWEBLOGICCONNPOOLS= 'SET_MONITORWEBLOGICCONNPOOLS'
export const SET_SELECTEDMONITORWEBLOGICCONNPOOL= 'SET_SELECTEDMONITORWEBLOGICCONNPOOL'
export const SET_MONITORVMWAREHOSTNETWORKS= 'SET_MONITORVMWAREHOSTNETWORKS'
export const SET_SELECTEDMONITORVMWAREHOSTNETWORK= 'SET_SELECTEDMONITORVMWAREHOSTNETWORK'
export const SET_MONITORVMWAREPERFORMANCESS= 'SET_MONITORVMWAREPERFORMANCESS'
export const SET_SELECTEDMONITORVMWAREPERFORMANCES= 'SET_SELECTEDMONITORVMWAREPERFORMANCES'
export const SET_MONITORWEBLOGICCLUSTERS= 'SET_MONITORWEBLOGICCLUSTERS'
export const SET_SELECTEDMONITORWEBLOGICCLUSTER= 'SET_SELECTEDMONITORWEBLOGICCLUSTER'
export const SET_MONITORWEBLOGICSERVERS= 'SET_MONITORWEBLOGICSERVERS'
export const SET_SELECTEDMONITORWEBLOGICSERVER= 'SET_SELECTEDMONITORWEBLOGICSERVER'
export const SET_MONITORWEBLOGICHEAPS= 'SET_MONITORWEBLOGICHEAPS'
export const SET_SELECTEDMONITORWEBLOGICHEAP= 'SET_SELECTEDMONITORWEBLOGICHEAP'
export const SET_MONITORAGENTDISKSPACEDISKNAMES= 'SET_MONITORAGENTDISKSPACEDISKNAMES'
export const SET_SELECTEDMONITORAGENTDISKSPACEDISKNAME= 'SET_SELECTEDMONITORAGENTDISKSPACEDISKNAME'
export const SET_MONITORAGENTPROCESSS= 'SET_MONITORAGENTPROCESSS'
export const SET_SELECTEDMONITORAGENTPROCESS= 'SET_SELECTEDMONITORAGENTPROCESS'
export const SET_MONITORAGENTSERVICES= 'SET_MONITORAGENTSERVICES'
export const SET_SELECTEDMONITORAGENTSERVICE= 'SET_SELECTEDMONITORAGENTSERVICE'
export const SET_MONITORAGENTNETIFS= 'SET_MONITORAGENTNETIFS'
export const SET_SELECTEDMONITORAGENTNETIF= 'SET_SELECTEDMONITORAGENTNETIF'
export const SET_MONITORAGENTDISKIONAMES= 'SET_MONITORAGENTDISKIONAMES'
export const SET_SELECTEDMONITORAGENTDISKIONAME= 'SET_SELECTEDMONITORAGENTDISKIONAME'
export const SET_MONITORAGENTDISKINODESNAMES= 'SET_MONITORAGENTDISKINODESNAMES'
export const SET_SELECTEDMONITORAGENTDISKINODESNAME= 'SET_SELECTEDMONITORAGENTDISKINODESNAME'
export const SET_MONITORAGENTSCRIPTS= 'SET_MONITORAGENTSCRIPTS'
export const SET_SELECTEDMONITORAGENTSCRIPT= 'SET_SELECTEDMONITORAGENTSCRIPT'
export const SET_MONITORORACLETABLESPACE= 'SET_MONITORORACLETABLESPACE'
export const SET_SELECTEDMONITORORACLETABLESPACE= 'SET_SELECTEDMONITORORACLETABLESPACE'
export const SET_RESOURCES_PROPERTY_DATA= 'SET_RESOURCES_PROPERTY_DATA'
export const SET_GETRESOURCESPROPERTYDATADONEFLAG= 'SET_GETRESOURCESPROPERTYDATADONEFLAG'
export const SET_RESOURCES_PROPERTY_EDIT= 'SET_RESOURCES_PROPERTY_EDIT'
export const SET_EQUIPMENT_MONITOR_PAGE= 'SET_EQUIPMENT_MONITOR_PAGE'
export const SET_DEPEND= 'SET_DEPEND'
export const SET_ALERTDEPEND= 'SET_ALERTDEPEND'
export const SET_RESOURCESALARMCONFIG= 'SET_RESOURCESALARMCONFIG'
export const SET_RESOURCESSELECTEDALARMCONFIG= 'SET_RESOURCESSELECTEDALARMCONFIG'
export const SET_RESOURCE_EQUIPMENTMODEL= 'SET_RESOURCE_EQUIPMENTMODEL'
export const SET_RESOURCEMODAL= 'SET_RESOURCEMODAL'
export const SET_TEST_PROPERTY_DATA= 'SET_TEST_PROPERTY_DATA'
export const SAVE_CREATEMONITORS= 'SAVE_CREATEMONITORS'
export const SET_EQUIPMENT_ACCESSORYINFOS= 'SET_EQUIPMENT_ACCESSORYINFOS'
export const SAVE_RESOURCEDATA= 'SAVE_RESOURCEDATA'
export const SET_OPERATEMONITOR= 'SET_OPERATEMONITOR'
export const SET_EQUIPMENTGROUPID= 'SET_EQUIPMENTGROUPID'
export const PERCENT_GOOD='PERCENT_GOOD';
export const SET_EQUIPMENTWINDOWSTORE='SET_EQUIPMENTWINDOWSTORE';

// add by qing.zhu
export const SET_REFRESH_RESOURCE_MONITORS ='SET_REFRESH_RESOURCE_MONITORS';
export const SET_LOADING_MONITOR_LIST ='SET_LOADING_MONITOR_LIST';
export const SET_SELECTED_CLICK_NODE ='SET_SELECTED_CLICK_NODE';
export const SET_RESOURCE_VIEW_ACTIVE_TAB ='SET_RESOURCE_VIEW_ACTIVE_TAB';
export const SET_MONITOR_STATUS_REPORT_DATA ='SET_MONITOR_STATUS_REPORT_DATA';
export const SET_BATCH_MONITOR_STATUS_REPORT_DATA = 'SET_BATCH_MONITOR_STATUS_REPORT_DATA';
export const SET_SAFE_GROUP_LIST ='SET_SAFE_GROUP_LIST';
export const SET_TASK_SCHEDULER_LIST ='SET_TASK_SCHEDULER_LIST';

export const SET_NETWORK_NODE_TYPE ='SET_NETWORK_NODE_TYPE';
export const SET_EQUIPMENT_NODE_TYPE ='SET_EQUIPMENT_NODE_TYPE';
export const SET_NETWORK_RELATIONS ='SET_NETWORK_RELATIONS';
export const SET_SELECTEDLEVEL ='SET_SELECTEDLEVEL';
export const SET_MONITORDETAILVIEWACTIVETAB = 'SET_MONITORDETAILVIEWACTIVETAB';
export const SET_DRAGGEDNODE = 'SET_DRAGGEDNODE';
export const SET_SELECTED_MONITOR_FROM_3D = 'SET_SELECTED_MONITOR_FROM_3D';
export const SET_BEADDMONITORSNODE = 'SET_BEADDMONITORSNODE';
export const SET_EQUIPMENTINFOMAINTENANCEDATA = 'SET_EQUIPMENTINFOMAINTENANCEDATA';
export const SET_MONITORDETAILVIEWTIMERANGE = 'SET_MONITORDETAILVIEWTIMERANGE';

export const SET_VMWARE_NAMES = 'SET_VMWARE_NAMES';
export const SET_HAS_VMWARE_NAMES = 'SET_HAS_VMWARE_NAMES';
export const SET_SELECTED_VMWARE_NAMES = 'SET_SELECTED_VMWARE_NAMES';

export function setMonitorDetailViewActiveTab(monitorDetailViewActiveTab){
  return {
    type: SET_MONITORDETAILVIEWACTIVETAB,
    monitorDetailViewActiveTab
  }
}

export function setMonitorDetailViewTimeRange(monitorDetailViewTimeRange){
  return {
    type: SET_MONITORDETAILVIEWTIMERANGE,
    monitorDetailViewTimeRange
  }
}

export function setEquipmentInfoMaintenanceData(equipmentInfoMaintenanceData){
  return {
    type: SET_EQUIPMENTINFOMAINTENANCEDATA,
    equipmentInfoMaintenanceData
  }
}

export function setBeAddMonitorsNode(beAddMonitorsNode) {
  return {
    type: SET_BEADDMONITORSNODE,
    beAddMonitorsNode
  }
}

function setEquipmentWindowStore(equipmentWindowStore) {
    return {
        type: SET_EQUIPMENTWINDOWSTORE,
        equipmentWindowStore
    }
}

export function setEquipmentMonitorUrl(equipmentMonitorUrl) {
    return {
        type: SET_EQUIPMENT_MONITOR_PAGE,
        equipmentMonitorUrl
    }
}

export function setErrorAlarm(errorAlarm) {
    return {
        type: SET_ERRORALARM,
        errorAlarm
    }
}

export function setGoodAlarm(goodAlarm) {
    return {
        type: SET_GOODALARM,
        goodAlarm
    }
}

export function setWarningAlarm(warningAlarm) {
    return {
        type: SET_WARNINGALARM,
        warningAlarm
    }
}

export function setLogGood(logGood) {
    return {
        type: SET_LOGGOOD,
        logGood
    }
}

export function setLogError(logError) {
    return {
        type: SET_LOGERROR,
        logError
    }
}

export function setLogDanger(logDanger) {
    return {
        type: SET_LOGDANGER,
        logDanger
    }
}

export function setLogBan(logBan) {
    return {
        type: SET_LOGBAN,
        logBan
    }
}

export function setFunctionValue(functionValue) {
    return {
        type: SET_FUNCTIONVALUE,
        functionValue
    }
}

export function setMonitors(monitors) {
    return {
        type: SET_MONITORS,
        monitors
    }
}

// export function setCurFuncValName(curFuncValName) {
//     return {
//         type: SET_CURFUNCVALNAME,
//         curFuncValName
//     }
// }
//
// export function setCurFuncValAvg(curFuncValAvg) {
//     return {
//         type: SET_CURFUNCVALAVG,
//         curFuncValAvg
//     }
// }
//
// export function setCurFuncValMax(curFuncValMax) {
//     return {
//         type: SET_CURFUNCVALMAX,
//         curFuncValMax
//     }
// }
//
// export function setCurFuncValMin(curFuncValMin) {
//     return {
//         type: SET_CURFUNCVALMIN,
//         curFuncValMin
//     }
// }
//
// export function setCurFuncValNew(curFuncValNew) {
//     return {
//         type: SET_CURFUNCVALNEW,
//         curFuncValNew
//     }
// }

export function setFuncValue(funcValue) {
    return {
        type: SET_FUNCVALUE,
        funcValue
    }
}

export function setCurTowHourName(curTowHourName) {
    return {
        type: SET_CURTOWHOURNAME,
        curTowHourName
    }
}

export function setCurTowHourValue(curTowHourValue) {
    return {
        type: SET_CURTOWHOURVALUE,
        curTowHourValue
    }
}

export function setTwoHoursReport(twoHoursReport) {
    return {
        type: SET_TWOHOURSREPORT,
        twoHoursReport
    }
}

export function setMonitorTableData(monitorTableData) {
    return {
        type: SET_MONITORTABLEDATA,
        monitorTableData
    }
}

export function setMonitorsStatus(monitorsStatus) {
    return {
        type: SET_MONITORSSTATUS,
        monitorsStatus
    }
}

export function setMonitorFilterStatus(monitorFilterStatus) {
    return {
        type: SET_MONITORFILTERSTATUS,
        monitorFilterStatus
    }
}

export function setGroupId(groupId) {
    return {
        type: SET_GROUPID,
        groupId
    }
}

export function setEquipments(equipments) {
    return {
        type: SET_EQUIPMENTS,
        equipments
    }
}

export function setSubGroups(subGroups) {
    return {
        type: SET_SUBGROUPS,
        subGroups
    }
}

export function setStatus(status) {
    return {
        type: SET_STATUS,
        status
    }
}

export function setGroupInfoFilterStatus(groupInfoFilterStatus) {
    return {
        type: SET_GROUPINFOFILTERSTATUS,
        groupInfoFilterStatus
    }
}

export function setMonitorTableSelectFirstFlag(monitorTableSelectFirstFlag) {
    return {
        type: SET_MONITORTABLESELECTFIRSTFLAG,
        monitorTableSelectFirstFlag
    }
}

export function setSelectedMonitorName(selectedMonitorName) {
    return {
        type: SET_SELECTEDMONITORNAME,
        selectedMonitorName
    }
}

export function setResourceSetTree(resourceSetTree) {
    return {
        type: SET_RESOURCESETTREE,
        resourceSetTree
    }
}

export function setEquipmentIdNtz(equipmentIdNtz) {
    return {
        type: SET_EQUIPMENTIDNTZ,
        equipmentIdNtz
    }
}

export function setAlarmRulesArray(alarmRulesArray) {
    return {
        type: SET_ALARMRULESARRAY,
        alarmRulesArray
    }
}

export function setEquipmentId(equipmentId) {
    return {
        type: SET_EQUIPMENTID,
        equipmentId
    }
}

export function setbClickTreeNode(bClickTreeNode) {
    return {
        type: SET_BCLICKTREENODE,
        bClickTreeNode
    }
}

export function setOnTreeNodeClick(onTreeNodeClick) {
    return {
        type: SET_ONTREENODECLICK,
        onTreeNodeClick
    }
}

export function setbClickDesViewMonitorTableRow(bClickDesViewMonitorTableRow) {
    return {
        type: SET_BCLICKDESVIEWMONITORTABLEROW,
        bClickDesViewMonitorTableRow
    }
}

export function setGetMonitorDataFilter(getMonitorDataFilter) {
    return {
        type: SET_GETMONITORDATAFILTER,
        getMonitorDataFilter
    }
}

export function setTreeIds(treeIds) {
    return {
        type: SET_TREEIDS,
        treeIds
    }
}

export function setOldTree(oldTree) {
    return {
        type: SET_OLDTREE,
        oldTree
    }
}

export function setAssetIdNtz(assetIdNtz) {
    return {
        type: SET_ASSETIDNTZ,
        assetIdNtz
    }
}

export function setSelectedResource(selectedResource) {
    return {
        type: SET_SELECTEDRESOURCE,
        selectedResource
    }
}

export function setBackupResource(backupResource) {
  return {
      type: SET_BACKUPRESOURCE,
      backupResource
  }
}

export function setCreateMonitorViewId(createMonitorViewId) {
    return {
        type: SET_CREATEMONITORVIEWID,
        createMonitorViewId
    }
}
export function setSelectedMonitor(selectedMonitor) {
    return {
        type: SET_SELECTEDMONITOR,
        selectedMonitor
    }
}

export function setCreateResourcesTableData(createResourcesTableData) {
    return {
        type: SET_CREATERESOURCESTABLEDATA,
        createResourcesTableData
    }
}

export function setCreateMonitorsTableData(createMonitorsTableData) {
    return {
        type: SET_CREATEMONITORSTABLEDATA,
        createMonitorsTableData
    }
}

export function setSelectedNode(selectedNode) {
    return {
        type: SET_SELECTEDNODE,
        selectedNode
    }
}
export function setSelectedNodeId(selectedNodeId) {
    return {
        type: SET_SELECTEDNODE_ID,
        selectedNodeId
    }
}
export function setBackupTreeNode(backupTreeNode) {
    return {
        type: SET_BACKUPTREENODE,
        backupTreeNode
    }
}

export function setResourceTypes(resourceTypes) {
    return {
        type: SET_RESOURCETYPES,
        resourceTypes
    }
}

export function setCommonMonitors(commonMonitors) {
    return {
        type: SET_COMMONMONITORS,
        commonMonitors
    }
}

export function setMonitorAlarmConditionNameData(monitorAlarmConditionNameData) {
    return {
        type: SET_MONITORALARMCONDITIONNAMEDATA,
        monitorAlarmConditionNameData
    }
}

export function setMonitorErrorAlarmText(monitorErrorAlarmText) {
    return {
        type: SET_MONITORERRORALARMTEXT,
        monitorErrorAlarmText
    }
}

export function setMonitorWarningAlarmText(monitorWarningAlarmText) {
    return {
        type: SET_MONITORWARNINGALARMTEXT,
        monitorWarningAlarmText
    }
}

export function setMonitorGoodAlarmText(monitorGoodAlarmText) {
    return {
        type: SET_MONITORGOODALARMTEXT,
        monitorGoodAlarmText
    }
}

export function setMonitorErrorConditionsData(monitorErrorConditionsData) {
    return {
        type: SET_MONITORERRORCONDITIONSDATA,
        monitorErrorConditionsData
    }
}

export function setMonitorSettingErrorConditionsData(monitorSettingErrorConditionsData) {
    return {
        type: SET_MONITORSETTINGERRORCONDITIONSDATA,
        monitorSettingErrorConditionsData
    }
}

export function setMonitorWarningConditionsData(monitorWarningConditionsData) {
    return {
        type: SET_MONITORWARNINGCONDITIONSDATA,
        monitorWarningConditionsData
    }
}

export function setMonitorSettingWarningConditionsData(monitorSettingWarningConditionsData) {
    return {
        type: SET_MONITORSETTINGWARNINGCONDITIONSDATA,
        monitorSettingWarningConditionsData
    }
}

export function setMonitorGoodConditionsData(monitorGoodConditionsData) {
    return {
        type: SET_MONITORGOODCONDITIONSDATA,
        monitorGoodConditionsData
    }
}

export function setMonitorSettingGoodConditionsData(monitorSettingGoodConditionsData) {
    return {
        type: SET_MONITORSETTINGGOODCONDITIONSDATA,
        monitorSettingGoodConditionsData
    }
}

export function setDeleteMonitorAlarmConditionsData(deleteMonitorAlarmConditionsData) {
    return {
        type: SET_DELETEMONITORALARMCONDITIONSDATA,
        deleteMonitorAlarmConditionsData
    }
}

export function setEquipmentServerAddress(equipmentServerAddress) {
    return {
        type: SET_EQUIPMENTSERVERADDRESS,
        equipmentServerAddress
    }
}

export function setEquipmentModel(equipmentModel) {
    return {
        type: SET_EQUIPMENTMODEL,
        equipmentModel
    }
}

export function setNavigateFromCreateMonitorViewFlag(navigateFromCreateMonitorViewFlag) {
    return {
        type: SET_NAVIGATEFROMCREATEMONITORVIEWFLAG,
        navigateFromCreateMonitorViewFlag
    }
}

export function setMonitorDisks(monitorDisks) {
    return {
        type: SET_MONITORDISKS,
        monitorDisks
    }
}

export function setMonitorHasDisks(monitorHasDisks) {
    return {
        type: SET_MONITORHASDISKS,
        monitorHasDisks
    }
}

export function setSelectedMonitorDisk(selectedMonitorDisk) {
    return {
        type: SET_SELECTEDMONITORDISK,
        selectedMonitorDisk
    }
}

export function setMonitorDiskInodes(monitorDiskInodes) {
    return {
        type: SET_MONITORDISKINODES,
        monitorDiskInodes
    }
}

export function setMonitorHasDiskInodes(monitorHasDiskInodes) {
    return {
        type: SET_MONITORHASDISKINODES,
        monitorHasDiskInodes
    }
}

export function setSelectedMonitorDiskInodes(selectedMonitorDiskInodes) {
    return {
        type: SET_SELECTEDMONITORDISKINODES,
        selectedMonitorDiskInodes
    }
}

export function setMonitorDiskIONames(monitorDiskIONames) {
    return {
        type: SET_MONITORDISKIONAMES,
        monitorDiskIONames
    }
}
export function setMonitorHasDiskIONames(monitorHasDiskIONames) {
    return {
        type: SET_MONITORHASDISKIONAMES,
        monitorHasDiskIONames
    }
}

export function setSelectedMonitorDiskIOName(selectedMonitorDiskIOName) {
    return {
        type: SET_SELECTEDMONITORDISKIONAME,
        selectedMonitorDiskIOName
    }
}

export function setNetWorks(networks) {
    return {
        type: SET_NETWORKS,
        networks
    }
}

export function setHasNetWorks(hasNetworks) {
    return {
        type: SET_HASNETWORKS,
        hasNetworks
    }
}

export function setSelectedNetwork (selectedNetwork) {
    return {
        type: SET_SELECTEDNETWORK,
        selectedNetwork
    }
}

export function setMonitorNetworks(monitorNetworks) {
    return {
        type: SET_MONITORNETWORKS,
        monitorNetworks
    }
}

export function setMonitorHasNetworks(monitorHasNetworks) {
    return {
        type: SET_MONITORHASNETWORKS,
        monitorHasNetworks
    }
}

export function setSelectedMonitorNetwork(selectedMonitorNetwork) {
    return {
        type: SET_SELECTEDMONITORNETWORK,
        selectedMonitorNetwork
    }
}

export function setMonitorProcesses(monitorProcesses) {
    return {
        type: SET_MONITORPROCESSES,
        monitorProcesses
    }
}

export function setMonitorHasProcesses(monitorHasProcesses) {
    return {
        type: SET_MONITORHASPROCESSES,
        monitorHasProcesses
    }
}

export function setSelectedMonitorProcess(selectedMonitorProcess) {
    return {
        type: SET_SELECTEDMONITORPROCESS,
        selectedMonitorProcess
    }
}

export function setMonitorServices(monitorServices) {
    return {
        type: SET_MONITORSERVICES,
        monitorServices
    }
}

export function setMonitorHasServices(monitorHasServices) {
    return {
        type: SET_MONITORHASSERVICES,
        monitorHasServices
    }
}

export function setSelectedMonitorService(selectedMonitorService) {
    return {
        type: SET_SELECTEDMONITORSERVICE,
        selectedMonitorService
    }
}

export function setMonitorNTEventLogs(monitorNTEventLogs) {
    return {
        type: SET_MONITORNTEVENTLOGS,
        monitorNTEventLogs
    }
}

export function setSelectedMonitorNTEventLog(selectedMonitorNTEventLog) {
    return {
        type: SET_SELECTEDMONITORNTEVENTLOG,
        selectedMonitorNTEventLog
    }
}

export function setMonitorScripts(monitorScripts) {
    return {
        type: SET_MONITORSCRIPTS,
        monitorScripts
    }
}

export function setMonitorScriptsEntryAlias(monitorScriptsEntryAlias) {
    return {
        type: SET_MONITORSCRIPTS_ENTRYALIAS,
        monitorScriptsEntryAlias
    }
}

export function setGetMonitorsEntryAliasDataDoneFlag(getMonitorsEntryAliasDataDoneFlag) {
    return {
        type: SET_GETMONITORSENTRYALIASDATADONEFLAG,
        getMonitorsEntryAliasDataDoneFlag
    }
}

export function setGetMonitorsSnmpMIBFileDataDoneFlag(getMonitorsSnmpMIBFileDataDoneFlag) {
    return {
        type: SET_GETMONITORSSNMPMIBFILEDATADONEFLAG,
        getMonitorsSnmpMIBFileDataDoneFlag
    }
}

export function setSelectedMonitorScript(selectedMonitorScript) {
    return {
        type: SET_SELECTEDMONITORSCRIPT,
        selectedMonitorScript
    }
}

export function setVMwareNames(VMwareNames) {
    return {
        type: SET_VMWARE_NAMES,
        VMwareNames
    }
}

export function setHasVMwareNames(hasVMwareNames) {
    return {
        type: SET_HAS_VMWARE_NAMES,
        hasVMwareNames
    }
}

export function setSelectedVMwareNames(selectedVMwareNames) {
    return {
        type: SET_SELECTED_VMWARE_NAMES,
        selectedVMwareNames
    }
}

export function setGetMonitorsPropertyDataDoneFlag(getMonitorsPropertyDataDoneFlag) {
    return {
        type: SET_GETMONITORSPROPERTYDATADONEFLAG,
        getMonitorsPropertyDataDoneFlag
    }
}
export function setGetAlarmConditionDataDoneFlag(getAlarmConditionDataDoneFlag) {
    return {
        type: SET_GETALARMCONDITIONDATADONEFLAG,
        getAlarmConditionDataDoneFlag
    }
}

export function setGetMySqlMonitorCounterDataDoneFlag(getMySqlMonitorCounterDataDoneFlag) {
    return {
        type: SET_GETMYSQLMONITORCOUNTERDATADONEFLAG,
        getMySqlMonitorCounterDataDoneFlag
    }
}

export function setGetSQLServerMonitorCounterDataDoneFlag(getSQLServerMonitorCounterDataDoneFlag) {
    return {
        type: SET_GETSQLSERVERMONITORCOUNTERDATADONEFLAG,
        getSQLServerMonitorCounterDataDoneFlag
    }
}

export function setGetOracleMonitorCounterDataDoneFlag(getOracleMonitorCounterDataDoneFlag) {
    return {
        type: SET_GETOracleMONITORCOUNTERDATADONEFLAG,
        getOracleMonitorCounterDataDoneFlag
    }
}

//监测器属性数据
export function setMonitorsPropertyData(monitorsPropertyData) {
    return {
        type: SET_MONITORS_PROPERTY_DATA,
        monitorsPropertyData
    }
}

//设置监测器属性编辑状态，true 是编辑监测器 false 是增加监测器
export function setMonitorsPropertyEdit(monitorsPropertyEdit) {
    return {
        type: SET_MONITORS_PROPERTY_EDIT,
        monitorsPropertyEdit
    }
}

//MySQL监测器:计数器 所有可选择项数据
export function setMySqlMonitorCounterData(mySqlCounterData) {
    return {
        type: SET_MONITORS_MYSQL_COUNTERDATA,
        mySqlCounterData
    }
}

//MySQL监测器:计数器 属性数据
export function setMySqlMonitorPropertyCounterData(mySqlMonitorsPropertyCounterData) {
    return {
        type: SET_MONITORS_MYSQL_PROPERTYCOUNTERDATA,
        mySqlMonitorsPropertyCounterData
    }
}

//MySQL监测器:计数器 当前选择项数据
export function setMySqlMonitorCurrentCounterData(mySqlCurrentCounterData) {
    return {
        type: SET_MONITORS_MYSQL_CURRENTCOUNTER,
        mySqlCurrentCounterData
    }
}

//SQL监测器:计数器 所有可选择项数据
export function setMonitorSQLServerCounters(monitorSQLServerCounters) {
    return {
        type: SET_MONITORSQLSERVERCOUNTERS,
        monitorSQLServerCounters
    }
}
//SQL监测器:计数器 属性数据
export function setSQLServerMonitorPropertyCounterData(sqlServerMonitorsPropertyCounterData) {
    return {
        type: SET_MONITORS_SQLSERVER_PROPERTYCOUNTERDATA,
        sqlServerMonitorsPropertyCounterData
    }
}
//SQL监测器:计数器 当前选择项数据
export function setSelectedMonitorSQLServerCounter(selectedMonitorSQLServerCounter) {
    return {
        type: SET_SELECTEDMONITORSQLSERVERCOUNTER,
        selectedMonitorSQLServerCounter
    }
}

//Oracle监测器:计数器 所有可选择项数据
export function setOracleMonitorCounterData(OracleCounterData) {
    return {
        type: SET_MONITORS_ORACLE_COUNTERDATA,
        OracleCounterData
    }
}

//Oracle监测器:计数器 属性数据
export function setOracleMonitorPropertyCounterData(OracleMonitorsPropertyCounterData) {
    return {
        type: SET_MONITORS_ORACLE_PROPERTYCOUNTERDATA,
        OracleMonitorsPropertyCounterData
    }
}

//Oracle监测器:计数器 当前选择项数据
export function setOracleMonitorCurrentCounterData(OracleCurrentCounterData) {
    return {
        type: SET_MONITORS_ORACLE_CURRENTCOUNTER,
        OracleCurrentCounterData
    }
}

export function setMonitorSnmpMIBFile(monitorSnmpMIBFile) {
    return {
        type: SET_MONITORSNMPMIBFILE,
        monitorSnmpMIBFile
    }
}

export function setMonitorSnmpMIBCounter(monitorSnmpMIBCounter) {
    return {
        type: SET_MONITORSNMPMIBCOUNTER,
        monitorSnmpMIBCounter
    }
}

export function setSelectedMonitorSnmpMIBCounter(selectedMonitorSnmpMIBCounter) {
    return {
        type: SET_SELECTEDMONITORSNMPMIBCOUNTER,
        selectedMonitorSnmpMIBCounter
    }
}

export function setSelectedMonitorMongoQuery(selectedMonitorMongoQuery) {
    return {
        type: SET_SELECTEDMONITORMONGOQUERY,
        selectedMonitorMongoQuery
    }
}

export function setMonitorStorageDisks(monitorStorageDisks) {
    return {
        type: SET_MONITORSTORAGEDISKS,
        monitorStorageDisks
    }
}

export function setSelectedMonitorStorageDisk(selectedMonitorStorageDisk) {
    return {
        type: SET_SELECTEDMONITORSTORAGEDISK,
        selectedMonitorStorageDisk
    }
}

export function setMonitorIPMISensorCounters(monitorIPMISensorCounters) {
    return {
        type: SET_MONITORIPMISENSORCOUNTERS,
        monitorIPMISensorCounters
    }
}

export function setSelectedMonitorIPMISensorCounter(selectedMonitorIPMISensorCounter) {
    return {
        type: SET_SELECTEDMONITORIPMISENSORCOUNTER,
        selectedMonitorIPMISensorCounter
    }
}

export function setMonitorStorageProcessors(monitorStorageProcessors) {
    return {
        type: SET_MONITORSTORAGEPROCESSORS,
        monitorStorageProcessors
    }
}

export function setSelectedMonitorStorageProcessor(selectedMonitorStorageProcessor) {
    return {
        type: SET_SELECTEDMONITORSTORAGEPROCESSOR,
        selectedMonitorStorageProcessor
    }
}

export function setMonitorFibreChannelStatusNodes(monitorFibreChannelStatusNodes) {
    return {
        type: SET_MONITORFIBRECHANNELSTATUSNODES,
        monitorFibreChannelStatusNodes
    }
}

export function setSelectedMonitorFibreChannelStatusNode(selectedMonitorFibreChannelStatusNode) {
    return {
        type: SET_SELECTEDMONITORFIBRECHANNELSTATUSNODES,
        selectedMonitorFibreChannelStatusNode
    }
}

export function setMonitorStorageVolumeFiles(monitorStorageVolumeFiles) {
    return {
        type: SET_MONITORSTORAGEVOLUMEFILES,
        monitorStorageVolumeFiles
    }
}

export function setSelectedMonitorStorageVolumeFile(selectedMonitorStorageVolumeFile) {
    return {
        type: SET_SELECTEDMONITORSTORAGEVOLUMEFILE,
        selectedMonitorStorageVolumeFile
    }
}

export function setMonitorRoomEnvironmentObjects(monitorRoomEnvironmentObjects) {
    return {
        type: SET_MONITORROOMENVIRONMENTOBJECTS,
        monitorRoomEnvironmentObjects
    }
}

export function setSelectedMonitorRoomEnvironmentObject(selectedMonitorRoomEnvironmentObject) {
    return {
        type: SET_SELECTEDMONITORROOMENVIRONMENTOBJECT,
        selectedMonitorRoomEnvironmentObject
    }
}

export function setMonitorWeblogicExecuteQueues(monitorWeblogicExecuteQueues) {
    return {
        type: SET_MONITORWEBLOGICEXECUTEQUEUES,
        monitorWeblogicExecuteQueues
    }
}

export function setSelectedMonitorWeblogicExecuteQueue(selectedMonitorWeblogicExecuteQueue) {
    return {
        type: SET_SELECTEDMONITORWEBLOGICEXECUTEQUEUE,
        selectedMonitorWeblogicExecuteQueue
    }
}

export function setMonitorWeblogicWebApps(monitorWeblogicWebApps) {
    return {
        type: SET_MONITORWEBLOGICWEBAPPS,
        monitorWeblogicWebApps
    }
}

export function setSelectedMonitorWeblogicWebApp(selectedMonitorWeblogicWebApp) {
    return {
        type: SET_SELECTEDMONITORWEBLOGICWEBAPP,
        selectedMonitorWeblogicWebApp
    }
}

export function setMonitorWeblogicConnPools(monitorWeblogicConnPools) {
    return {
        type: SET_MONITORWEBLOGICCONNPOOLS,
        monitorWeblogicConnPools
    }
}

export function setSelectedMonitorWeblogicConnPool(selectedMonitorWeblogicConnPool) {
    return {
        type: SET_SELECTEDMONITORWEBLOGICCONNPOOL,
        selectedMonitorWeblogicConnPool
    }
}

export function setMonitorVMwareHostNetworks(monitorVMwareHostNetworks) {
    return {
        type: SET_MONITORVMWAREHOSTNETWORKS,
        monitorVMwareHostNetworks
    }
}

export function setSelectedMonitorVMwareHostNetwork(selectedMonitorVMwareHostNetwork) {
    return {
        type: SET_SELECTEDMONITORVMWAREHOSTNETWORK,
        selectedMonitorVMwareHostNetwork
    }
}

export function setMonitorVMwarePerformances(monitorVMwarePerformances) {
    return {
        type: SET_MONITORVMWAREPERFORMANCESS,
        monitorVMwarePerformances
    }
}

export function setSelectedMonitorVMwarePerformance(selectedMonitorVMwarePerformance) {
    return {
        type: SET_SELECTEDMONITORVMWAREPERFORMANCES,
        selectedMonitorVMwarePerformance
    }
}

export function setMonitorWeblogicClusters(monitorWeblogicClusters) {
    return {
        type: SET_MONITORWEBLOGICCLUSTERS,
        monitorWeblogicClusters
    }
}

export function setSelectedMonitorWeblogicCluster(selectedMonitorWeblogicCluster) {
    return {
        type: SET_SELECTEDMONITORWEBLOGICCLUSTER,
        selectedMonitorWeblogicCluster
    }
}

export function setMonitorWeblogicServers(monitorWeblogicServers) {
    return {
        type: SET_MONITORWEBLOGICSERVERS,
        monitorWeblogicServers
    }
}

export function setSelectedMonitorWeblogicServer(selectedMonitorWeblogicServer) {
    return {
        type: SET_SELECTEDMONITORWEBLOGICSERVER,
        selectedMonitorWeblogicServer
    }
}

export function setMonitorWeblogicHeaps(monitorWeblogicHeaps) {
    return {
        type: SET_MONITORWEBLOGICHEAPS,
        monitorWeblogicHeaps
    }
}

export function setSelectedMonitorWeblogicHeap(selectedMonitorWeblogicHeap) {
    return {
        type: SET_SELECTEDMONITORWEBLOGICHEAP,
        selectedMonitorWeblogicHeap
    }
}

export function setMonitorAgentDiskSpaceDiskNames(monitorAgentDiskSpaceDiskNames) {
    return {
        type: SET_MONITORAGENTDISKSPACEDISKNAMES,
        monitorAgentDiskSpaceDiskNames
    }
}

export function setSelectedMonitorAgentDiskSpaceDiskName(selectedMonitorAgentDiskSpaceDiskName) {
    return {
        type: SET_SELECTEDMONITORAGENTDISKSPACEDISKNAME,
        selectedMonitorAgentDiskSpaceDiskName
    }
}

export function setMonitorAgentProcesss(monitorAgentProcesss) {
    return {
        type: SET_MONITORAGENTPROCESSS,
        monitorAgentProcesss
    }
}

export function setSelectedMonitorAgentProcess(selectedMonitorAgentProcess) {
    return {
        type: SET_SELECTEDMONITORAGENTPROCESS,
        selectedMonitorAgentProcess
    }
}

export function setMonitorAgentServices(monitorAgentServices) {
    return {
        type: SET_MONITORAGENTSERVICES,
        monitorAgentServices
    }
}

export function setSelectedMonitorAgentService(selectedMonitorAgentService) {
    return {
        type: SET_SELECTEDMONITORAGENTSERVICE,
        selectedMonitorAgentService
    }
}

export function setMonitorAgentNetIFs(monitorAgentNetIFs) {
    return {
        type: SET_MONITORAGENTNETIFS,
        monitorAgentNetIFs
    }
}

export function setSelectedMonitorAgentNetIF(selectedMonitorAgentNetIF) {
    return {
        type: SET_SELECTEDMONITORAGENTNETIF,
        selectedMonitorAgentNetIF
    }
}

export function setMonitorAgentDiskIONames(monitorAgentDiskIONames) {
    return {
        type: SET_MONITORAGENTDISKIONAMES,
        monitorAgentDiskIONames
    }
}

export function setSelectedMonitorAgentDiskIOName(selectedMonitorAgentDiskIOName) {
    return {
        type: SET_SELECTEDMONITORAGENTDISKIONAME,
        selectedMonitorAgentDiskIOName
    }
}

export function setMonitorAgentDiskInodesNames(monitorAgentDiskInodesNames) {
    return {
        type: SET_MONITORAGENTDISKINODESNAMES,
        monitorAgentDiskInodesNames
    }
}

export function setSelectedMonitorAgentDiskInodesName(selectedMonitorAgentDiskInodesName) {
    return {
        type: SET_SELECTEDMONITORAGENTDISKINODESNAME,
        selectedMonitorAgentDiskInodesName
    }
}

export function setMonitorAgentScripts(monitorAgentScripts) {
    return {
        type: SET_MONITORAGENTSCRIPTS,
        monitorAgentScripts
    }
}

export function setSelectedMonitorAgentScript(selectedMonitorAgentScript) {
    return {
        type: SET_SELECTEDMONITORAGENTSCRIPT,
        selectedMonitorAgentScript
    }
}

export function setMonitorOracleTableSpace(monitorOracleTableSpace) {
    return {
        type: SET_MONITORORACLETABLESPACE,
        monitorOracleTableSpace
    }
}

export function setSelectedMonitorOracleTableSpace(selectedMonitorOracleTableSpace) {
    return {
        type: SET_SELECTEDMONITORORACLETABLESPACE,
        selectedMonitorOracleTableSpace
    }
}

//资源属性数据
export function setResourcesPropertyData(resourcesPropertyData) {
  return {
      type: SET_RESOURCES_PROPERTY_DATA,
      resourcesPropertyData
  }
}
//测试连接数据
export function setTestPropertyData(testPropertyData) {
  return {
      type: SET_TEST_PROPERTY_DATA,
      testPropertyData
  }
}

export function setGetResourcesPropertyDataDoneFlag(getResourcesPropertyDataDoneFlag) {
  return {
      type: SET_GETRESOURCESPROPERTYDATADONEFLAG,
      getResourcesPropertyDataDoneFlag
  }
}

//设置资源属性编辑状态，true 是编辑资源 false 是增加资源
export function setResourcesPropertyEdit(resourcesPropertyEdit) {
  return {
      type: SET_RESOURCES_PROPERTY_EDIT,
      resourcesPropertyEdit
  }
}

export function setDepend(depend) {
  return {
      type: SET_DEPEND,
      depend
  }
}

export function setAlertDepend(alertDepend) {
  return {
      type: SET_ALERTDEPEND,
      alertDepend
  }
}

export function setResourcesAlarmConfig(resourcesAlarmConfig) {
  return {
      type: SET_RESOURCESALARMCONFIG,
      resourcesAlarmConfig
  }
}

export function setResourcesSelectedAlarmConfig(resourcesSelectedAlarmConfig) {
  return {
      type: SET_RESOURCESSELECTEDALARMCONFIG,
      resourcesSelectedAlarmConfig
  }
}

export function setResourceEquipmentModel(resourceEquipmentModel) {
  return {
      type: SET_RESOURCE_EQUIPMENTMODEL,
      resourceEquipmentModel
  }
}

export function setResourceModal(resourceModal) {
  return {
      type: SET_RESOURCEMODAL,
      resourceModal
  }
}

export function saveCreateMonitors(createMonitors) {
  return {
    type: SAVE_CREATEMONITORS,
    createMonitors
  }
}

export function setEquipmentAccessoryInfos(equipmentAccessoryInfos) {
  return {
      type: SET_EQUIPMENT_ACCESSORYINFOS,
      equipmentAccessoryInfos
  }
}

export function saveResourcesData(resourcesData) {
  return {
      type: SAVE_RESOURCEDATA,
      resourcesData
  }
}

export function setOperateMonitor(operateMonitor) {
  return {
      type: SET_OPERATEMONITOR,
      operateMonitor
  }
}

export function setEquipmentGroupId(equipmentGroupId) {
  return {
      type: SET_EQUIPMENTGROUPID,
      equipmentGroupId
  }
}

export function setRefreshResourceMonitors(refreshResourceMonitors) {
  return {
      type: SET_REFRESH_RESOURCE_MONITORS,
      refreshResourceMonitors
  }
}

export function setLoadingMonitorList(loadingMonitorList) {
  return {
      type: SET_LOADING_MONITOR_LIST,
      loadingMonitorList
  }
}

//记录选中树单击的节点，避免右键时选中节点切换了
export function setSelectedClickNode(selectedClickNode) {
  return {
      type: SET_SELECTED_CLICK_NODE,
      selectedClickNode
  }
}
// 资源视图中选中tab
export function setResourceViewActiveTab(resourceViewActiveTab) {
  return {
      type: SET_RESOURCE_VIEW_ACTIVE_TAB,
      resourceViewActiveTab
  }
}

export function setMonitorStatusReportData(monitorStatusReportData) {
  return {
      type: SET_MONITOR_STATUS_REPORT_DATA,
      monitorStatusReportData
  }
}

export function setBatchMonitorStatusReportData(batchMonitorStatusReportData) {
  return {
      type: SET_BATCH_MONITOR_STATUS_REPORT_DATA,
      batchMonitorStatusReportData
  }
}

export function setSafeGroupList(safeGroupList) {
  return {
      type: SET_SAFE_GROUP_LIST,
      safeGroupList
  }
}

export function setTaskSchedulerList(taskSchedulerList) {
  return {
      type: SET_TASK_SCHEDULER_LIST,
      taskSchedulerList
  }
}

export function setNetworkNodeType(networkNodeType) {
  return {
      type: SET_NETWORK_NODE_TYPE,
      networkNodeType
  }
}

export function setEquipmentNodeType(equipmentNodeType) {
  return {
      type: SET_EQUIPMENT_NODE_TYPE,
      equipmentNodeType
  }
}

export function setNetworkRelations(networkRelations) {
  return {
      type: SET_NETWORK_RELATIONS,
      networkRelations
  }
}

export function setSelectedLevel(selectedLevel) {
  return {
      type: SET_SELECTEDLEVEL,
      selectedLevel
  }
}

export function setDraggedNode(draggedNode) {
  return {
      type: SET_DRAGGEDNODE,
      draggedNode
  }
}

export function setSelectedMonitorFrom3D(selectedMonitorFrom3D) {
  return {
      type: SET_SELECTED_MONITOR_FROM_3D,
      selectedMonitorFrom3D
  }
}

export function receiveCreateOperationAudit(param, callback) {
    return dispatch => {
      dispatch(createOperationAudit(param, callback));
    }
}

function receiveGetResourceSetTree(data) {
    return (dispatch, getState) => {
        if(data.results.length == 0) {
            dispatch(requestDataActions.setRequestFail());
            return;
        }
        var state = getState();
        var resultData = $.parseJSON(data.results[0].TREEDATA);
        var alarmRulesData = [];
        alarmRulesData.push({id:"12341234",name: "无"});
        // alarmRulesData.concat($.parseJSON(data.results[0].ALARMCONFIG));
        var aD = $.parseJSON(data.results[0].ALARMCONFIG);
        for(var i = 0; i < aD.length; i++){
          alarmRulesData.push(aD[i]);
        }
        if(resultData instanceof Array && resultData.length > 0){
          var newData =[];
          var rSetNewData = [];
          rSetNewData.push({
            bid: "",
            icon: "",
            id: "se",
            name:"监测树",
            open: true,
            parent: false,
            pId: "0",
            type: "all"
          });
          for(var i=0;i< resultData.length;i++){
            var nData = {};
            var iconTemp="";
            if(resultData[i].icon){
              iconTemp="public"+ resultData[i].icon.substring(1);
            };
            if(resultData[i].status){
              nData  ={
                alarmconfig:resultData[i].alarmconfig,
                alarmname:resultData[i].alarmname,
                bid: resultData[i].bid,
                icon: iconTemp,
                id: resultData[i].id,
                name:resultData[i].name,
                pId: resultData[i].pid,
                status:resultData[i].status,
                title:resultData[i].title,
                type: resultData[i].type
              };
            }else{
              nData  ={
                    bid: resultData[i].bid,
                    icon: iconTemp,
                    id: resultData[i].id,
                    name:resultData[i].name,
                    open:resultData[i].open,
                    parent: resultData[i].parent,
                    pId: resultData[i].pid,
                    type: resultData[i].type
                  }
            }
            rSetNewData.push(nData);
          }

          var oldTreeList = [];
        //   oldTreeList = this.oldTree;
          oldTreeList = state.equipmentReducer.getOldTree;
          if(oldTreeList.length > 0 ){
            for(var i =0;i <rSetNewData.length;i++){
              for(var j=0;j < oldTreeList.length;j++){
                if(rSetNewData[i].id == oldTreeList[j].id){
                  rSetNewData[i].open =oldTreeList[j].open;
                }
              }
            }
            // TreeUtil.treeConfig("monitortree",rSetNewData);
            // TreeUtil.setTreeNode(this.treeIds);
            // TreeUtil.setTreeNode(state.equipmentReducer.treeIds);
            // $('#monitorTable').bootstrapTable('refreshOptions', {data: TreeUtil.monitortreeF()});
            dispatch(setAlarmRulesArray(alarmRulesData));
            dispatch(setResourceSetTree(rSetNewData));
            dispatch(isShowTree(true));
          }else{
            dispatch(setAlarmRulesArray(alarmRulesData));
            dispatch(setResourceSetTree(rSetNewData));
          }

        //   this.alarmRulesArray = alarmRulesData;
        //   this.resourceSetTree = rSetNewData;

        //   this.emit("change");
        dispatch(requestDataActions.setRequestSuccess());
        }
    }
}

function oDataGetResourceSetTree() {
    return dispatch => {
		oData.getResourceSetTree(data => dispatch(receiveGetResourceSetTree(data)));
    }
}

export function getResourceSetTree() {
    return dispatch => {
        dispatch(requestDataActions.setRequest());
        return dispatch(oDataGetResourceSetTree());
    }
}

function receiveSetEquipment(obj, code, data) {
    return dispatch => {
        if(code == "ok"){
          for(var i=0;i < obj.length;i++){
            if(obj[i].key == "USERNAME"){
              Util.showMessageDialog("基础设置","修改成功。");
            }else if(obj[i].key == "COMMUNITY"){
              Util.showMessageDialog("共同体","修改成功。");
            }else if(obj[i].key == "ALARM_RULE"){
              Util.showMessageDialog("报警规则","修改成功。");
              dispatch(getResourceSetTree());
              //refresh left tree
              // $.fn.zTree.init($("#monitortree"), this.rSetting(), newData);
            }else if(obj[i].key == "STATUS"){
              Util.showMessageDialog("依赖","修改成功。");
            }
          }
          dispatch(requestDataActions.setRequestSuccess());
        }
        else {
            dispatch(requestDataActions.setRequestFail());
        }
    }
}

function oDataSetEquipment(obj) {
    return dispatch => {
		oData.setEquipment(obj, (code, data) => dispatch(receiveSetEquipment(obj, code, data)));
    }
}

export function setEquipment(obj) {
    return dispatch => {
        dispatch(requestDataActions.setRequest());
        return dispatch(oDataSetEquipment(obj));
    }
}

export function changePicData(key) {
    return (dispatch, getState) => {
        var state = getState();
        // var _this = this;
        var tval = state.equipmentReducer.twoHoursReport;
        for(var i=0;i<tval.length;i++){
            var k = tval[i].MonitorEntry;
            if(k == key){
                var v = tval[i].Values;
                // _this.curTowHourName = k;
                // _this.curTowHourValue = v;
                dispatch(setCurTowHourName(k));
                dispatch(setCurTowHourValue(v));
                // _this.emit("change");
            };
        };
    }
}

function receiveGetGroupAllData(data, callback) {
    return dispatch => {
        if(data.results.length == 0){
          dispatch(requestDataActions.setRequestFail());
          return;
        }
        //通过eval() 函数可以将JSON字符串转化为对象
        var dataObj = eval(data.results[0]);
        var equipments = dataObj.EQUIPMENTS;
        var groups = dataObj.GROUPS;
        var status = dataObj.STATUSCOUNT;
        // _this.equipments = eval('('+equipments+')');
        // _this.subGroups = eval('('+groups+')');
        // _this.status = eval('('+status+')');
        dispatch(setEquipments(eval('('+equipments+')')));
        dispatch(setSubGroups(eval('('+groups+')')));
        dispatch(setStatus(eval('('+status+')')));
        // _this.emit("change");
        callback&&callback(eval('('+status+')'));
        dispatch(requestDataActions.setRequestSuccess());
    }
}

function oDataGetGroupAllData(filters, callback) {
    return dispatch => {
		oData.getGroupAllData(filters, data => dispatch(receiveGetGroupAllData(data, callback)));
    }
}

export function getGroupAllData(rid, callback) {
    return dispatch => {
        var filters = [{key:"RECID",value:rid}];
        // this.groupId = rid;
        dispatch(setGroupId(rid));
        dispatch(requestDataActions.setRequest());
        return dispatch(oDataGetGroupAllData(filters, callback));
    }
}

export function getCurrentGroupAllData(rid, callback) {
    return dispatch => {
      // === 已切换到 OFBiz 新接口 /monitor/tree?groupId=xxx ===
      // 旧接口 oData.getGroupAllData 走 /bods.svc/EccGroup?$expand=...
      // 新接口用 monitor/tree 的 groupId 参数只返回该分组子树，再经 adaptMonitorTreeToLegacy
      // 转成旧 PascalCase 嵌套结构，供 getDeletedGroupIds 递归收集子节点 id。
      ofbiz.getMonitorTree({ groupId: rid }).then(res => {
        const result = res || {};
        const tree = result.tree || result || [];
        const arr = Array.isArray(tree) ? tree : [tree];
        const legacyData = adaptMonitorTreeToLegacy(arr);
        callback && callback(legacyData);
      }).catch(err => {
        callback && callback([]);
      });
    }
}

export function getCurrentEquipmentAllData(rid, callback) {
    return dispatch => {
      // === 已切换到 OFBiz 新接口 /equipment/getById ===
      // 新接口删除设备时自动级联删监测器（文档10），删除流程不再需要前端收集 monitors id。
      // 这里返回简单的设备结构即可（getDeletedGroupIds 会遍历，无 EquipmentMonitor 则跳过）。
      ofbiz.getEquipmentById(rid).then(detail => {
        if (!detail) { callback && callback({}); return; }
        callback && callback({
          RecId: detail.equipmentId,
          Title: detail.fixedAssetName,
          EquipmentMonitor: [],  // 新接口删除自动级联，无需前端收集
        });
      }).catch(err => {
        callback && callback({});
      });
    }
}

function receiveGetAssetByGb(data) {
    return dispatch => {
        var results = data.results;
        if(results.length>0){
            var result = results[0];
            var assetIdNtz = result.RecId;
            // _this.assetIdNtz = assetIdNtz;
            dispatch(setAssetIdNtz(assetIdNtz));
            // _this.emit("change");
            dispatch(requestDataActions.setRequestSuccess());
        }
        else {
            dispatch(requestDataActions.setRequestFail());
            return;
        }
    }
}

function oDataGetAssetByGb(rid) {
    return dispatch => {
		oData.getAssetByGb(rid, data => dispatch(receiveGetAssetByGb(data)));
    }
}

function receiveGetEquipmentAllData(data) {
	return (dispatch, getState) => {
        var state = getState();
        var results = data.results;
        if(results.length == 0){
            // _this.emit("change");
            dispatch(requestDataActions.setRequestFail());
            return;
        }
        if(results.length>0){
            var result = results[0];
            //console.log("查询成功",result);
            var alarms = result.ALARM_CONDITIONS;
            var funcVal = result.FUNCTION_VALUE;
            var logcount = result.LOGCOUNT;
            var monitors = result.MONITORS;
            var twoHoursReport = result.TWO_HOURS_REPORT;
            alarms = eval("(" + alarms + ")");
            logcount = eval("(" + logcount + ")");
            funcVal = eval("(" + funcVal + ")");
            monitors = eval(monitors);
            twoHoursReport = eval(twoHoursReport);
            var statusGood=0, statusWarning=0, statusError=0, statusDisabled=0;
            if(monitors.length>0){
                var moList = [];
                for(var i=0;i<monitors.length;i++){
                    var monitor = {
                        id:monitors[i].monitorId,
                        type:monitors[i].monitorType,
                        status:monitors[i].status,
                        nameChar:monitors[i].name,
                        discribe:monitors[i].message,
                        lastModify:monitors[i].updateTime
                    };
                    moList.push(monitor);

                    switch (monitors[i].status) {
                        case "good":
                            statusGood++;
                            break;
                        case "warning":
                            statusWarning++;
                            break;
                        case "error":
                            statusError++;
                            break;
                        case "disabled":
                            statusDisabled++;
                            break;
                    }
                }
                // _this.monitors = moList;
                // _this.monitorTableData = _this.monitors;
                // _this.monitorTableSelectFirstFlag = true;
                // _this.selectedMonitorName = monitors[0].name;
                dispatch(setMonitors(moList.slice(0)));
                dispatch(setMonitorTableData(moList.slice(0)));
                dispatch(setMonitorTableSelectFirstFlag(true));
                dispatch(setSelectedMonitorName(monitors[0].name));
                var filter ={
                  monitorId:monitors[0].monitorId,
                  monitorType:monitors[0].monitorType
                };
        				dispatch(getMonitorsPropertyDataFromID(monitors[0].monitorId));
        				dispatch(getAlarmConditionDataFromMonitorId(monitors[0].monitorId));
        				dispatch(getMySqlMonitorPropertyCounterData(monitors[0].monitorId));
        				dispatch(setSelectedMonitorByClickMonitorTableRow(state.equipmentReducer.selectedNode.type, monitors[0].monitorType));
            }
            // _this.monitorsStatus = [monitors.length, statusGood, statusWarning, statusError, statusDisabled];
            dispatch(setMonitorsStatus([monitors.length, statusGood, statusWarning, statusError, statusDisabled]));
            if(funcVal && funcVal.length>0){
                // _this.curFuncValName = funcVal[0].MonitorEntry;
                // _this.curFuncValAvg = funcVal[0].avg;
                // _this.curFuncValMax = funcVal[0].max;
                // _this.curFuncValMin = funcVal[0].min;
                // _this.curFuncValNew = funcVal[0].new;
                // dispatch(setCurFuncValName(funcVal[0].MonitorEntry));
                // dispatch(setCurFuncValAvg(funcVal[0].avg));
                // dispatch(setCurFuncValMax(funcVal[0].max));
                // dispatch(setCurFuncValMin(funcVal[0].min));
                // dispatch(setCurFuncValNew(funcVal[0].new));
            }
            // _this.funcValue = funcVal;
            // _this.twoHoursReport = twoHoursReport;
            dispatch(setFuncValue(funcVal));
            dispatch(setTwoHoursReport(twoHoursReport));
            if(twoHoursReport && twoHoursReport.length>0){
                // _this.curTowHourName = twoHoursReport[0].MonitorEntry;
                // _this.curTowHourValue = twoHoursReport[0].Values;
                dispatch(setCurTowHourName(twoHoursReport[0].MonitorEntry));
                dispatch(setCurTowHourValue(twoHoursReport[0].Values));
            }
            else{
                // _this.curTowHourName = "";
                // _this.curTowHourValue = [];
                dispatch(setCurTowHourName(""));
                dispatch(setCurTowHourValue([]));
            }
            if(alarms) {
                // _this.errorAlarm = alarms.errorAlarm;
                // _this.goodAlarm = alarms.goodAlarm;
                // _this.warningAlarm = alarms.warningAlarm;
                dispatch(setErrorAlarm(alarms.errorAlarm));
                dispatch(setGoodAlarm(alarms.goodAlarm));
                dispatch(setWarningAlarm(alarms.warningAlarm));
            }
            if(logcount) {
                // _this.logGood = logcount[0];
                // _this.logDanger = logcount[1];
                // _this.logError = logcount[2];
                // _this.logBan = logcount[3];
      				if(logcount.length>0) {
        					dispatch(setLogGood(logcount[0]));
	                dispatch(setLogDanger(logcount[1]));
	                dispatch(setLogError(logcount[2]));
	                dispatch(setLogBan(logcount[3]));
      				}else {
        					dispatch(setLogGood("0"));
	                dispatch(setLogDanger("0"));
	                dispatch(setLogError("0"));
	                dispatch(setLogBan("0"));
      				}
            }
            // _this.emit("change");
            dispatch(requestDataActions.setRequestSuccess());
        }
    }
}

function oDataGetEquipmentAllData(filters) {
    return dispatch => {
      // === 已切换到 OFBiz 新接口 /equipment/getById ===
      var rid = filters && filters.RecId;
      ofbiz.getEquipmentById(rid).then(detail => {
        // 构造旧返回结构供 receiveGetEquipmentAllData 消费
        var legacy = detail ? adaptEquipmentDetailToLegacy(detail, classEnumToEquipmentType) : {};
        dispatch(receiveGetEquipmentAllData({ results: [legacy] }));
      }).catch(err => {
        dispatch(receiveGetEquipmentAllData({ results: [] }));
      });
    }
}

export function getEquipmentAllData(rid) {
    return (dispatch, getState) => {
        var state = getState();
        if(state.equipmentReducer.bClickTreeNode) {
            // this.bClickTreeNode = false;
            dispatch(setbClickTreeNode(false));
            // var _this = this;
            // this.equipmentIdNtz = rid;
            dispatch(setEquipmentIdNtz(rid));
            dispatch(requestDataActions.setRequest());
            dispatch(oDataGetAssetByGb(rid));
            // var filters = [{key:"RecId",value:rid}];
            var filters = {RecId: rid};
            // _this.monitorTableData = [];
            // _this.monitorTableSelectFirstFlag = false;
            // _this.selectedMonitorName = "";
            dispatch(setMonitorTableData([]));
            dispatch(setMonitorTableSelectFirstFlag(false));
            dispatch(setSelectedMonitorName(""));
            dispatch(requestDataActions.setRequest());
            return dispatch(oDataGetEquipmentAllData(filters));
        }
    }
}

export function getMonitorTableData(filter) {
    return (dispatch, getState) => {
        var state = getState();
        if(filter != null) {
            // this.monitorTableData = [];
            // dispatch(setMonitorTableData([]));
            var monitorTableData = [];
            for(var i = 0; i < state.equipmentReducer.monitors.length; i++) {
                var bMatch = true;
                if(filter.hasOwnProperty('includedName') && state.equipmentReducer.monitors[i].nameChar.toLowerCase().indexOf($.trim(filter.includedName.toLowerCase())) == -1 ) {
                    bMatch = false;
                }

                if(bMatch) {
                    // this.monitorTableData.push(this.monitors[i]);
                    monitorTableData.push(state.equipmentReducer.monitors[i]);
                }
            }
            dispatch(setMonitorTableData(monitorTableData));
        }
        else {
            // this.monitorTableData = this.monitors;
            dispatch(setMonitorTableData(state.equipmentReducer.monitors));
        }
        // this.emit("change");
    }
}

function receiveGetMonitorData(data) {
    return dispatch => {
        // _this.bClickDesViewMonitorTableRow = false;
        dispatch(setbClickDesViewMonitorTableRow(false));
        if(data.results.length == 0){
            // _this.emit("change");
            dispatch(requestDataActions.setRequestFail());
            return;
        }
        //通过eval() 函数可以将JSON字符串转化为对象
        var dataObj = eval(data.results[0]);
        var alarms = dataObj.ALARM_CONDITIONS;
        var funcVal = dataObj.FUNCTION_VALUE;
        var logcount = dataObj.LOGCOUNT;
        var twoHoursReport = dataObj.TWO_HOURS_REPORT;
        alarms = eval("(" + alarms + ")");
        logcount = eval("(" + logcount + ")");
        funcVal = eval("(" + funcVal + ")");
        twoHoursReport = eval(twoHoursReport);

        if(funcVal && funcVal.length>0){
            // _this.curFuncValName = funcVal[0].MonitorEntry;
            // _this.curFuncValAvg = funcVal[0].avg;
            // _this.curFuncValMax = funcVal[0].max;
            // _this.curFuncValMin = funcVal[0].min;
            // _this.curFuncValNew = funcVal[0].new;
            // dispatch(setCurFuncValName(funcVal[0].MonitorEntry));
            // dispatch(setCurFuncValAvg(funcVal[0].avg));
            // dispatch(setCurFuncValMax(funcVal[0].max));
            // dispatch(setCurFuncValMin(funcVal[0].min));
            // dispatch(setCurFuncValNew(funcVal[0].new));
        }
        // _this.funcValue = funcVal;
        // _this.twoHoursReport = twoHoursReport;
        dispatch(setFuncValue(funcVal));
        dispatch(setTwoHoursReport(twoHoursReport));
        if(twoHoursReport && twoHoursReport.length>0){
            // _this.curTowHourName = twoHoursReport[0].MonitorEntry;
            // _this.curTowHourValue = twoHoursReport[0].Values;
            dispatch(setCurTowHourName(twoHoursReport[0].MonitorEntry));
            dispatch(setCurTowHourValue(twoHoursReport[0].Values));
        }
        else{
            // _this.curTowHourName = "";
            // _this.curTowHourValue = [];
            dispatch(setCurTowHourName(""));
            dispatch(setCurTowHourValue([]));
        }
        if(alarms) {
            // _this.errorAlarm = alarms.errorAlarm;
            // _this.goodAlarm = alarms.goodAlarm;
            // _this.warningAlarm = alarms.warningAlarm;
            dispatch(setErrorAlarm(alarms.errorAlarm));
            dispatch(setGoodAlarm(alarms.goodAlarm));
            dispatch(setWarningAlarm(alarms.warningAlarm));
        }
        if(logcount) {
            // _this.logGood = logcount[0];
            // _this.logDanger = logcount[1];
            // _this.logError = logcount[2];
            // _this.logBan = logcount[3];
			if(logcount.length>0) {
				dispatch(setLogGood(logcount[0]));
				dispatch(setLogDanger(logcount[1]));
				dispatch(setLogError(logcount[2]));
				dispatch(setLogBan(logcount[3]));
			}
			else {
				dispatch(setLogGood("0"));
				dispatch(setLogDanger("0"));
				dispatch(setLogError("0"));
				dispatch(setLogBan("0"));
			}
        }
        // _this.emit("change");
        dispatch(requestDataActions.setRequestSuccess());
    }
}

function oDataGetMonitorData(filter) {
    return dispatch => {
		oData.getMonitorData(filter, data => dispatch(receiveGetMonitorData(data)));
    }
}

export function getMonitorData(filter) {
    return dispatch => {
        dispatch(requestDataActions.setRequest());
        return dispatch(oDataGetMonitorData(filter));
    }
}

/**
 * 按设备 ID 获取监测器列表（文档06 /monitor/list）
 * 替代从树数据 EquipmentMonitor 嵌套取监测器的方式。
 * @param {string} equipmentId 父设备 ID
 * @param {function} callback 回调，参数为适配后的旧 PascalCase 监测器数组
 */
export function getMonitorListByEquipment(equipmentId, callback) {
  return dispatch => {
    ofbiz.getMonitorList({ parentFixedAssetId: equipmentId }, 1, 500).then(res => {
      var list = getOfbizPageList(res);
      // 适配成旧 PascalCase 格式（monitorInfoView.initData → formatMonitorNls 期望）
      var legacyList = list.map(item => {
        var attrs = item.attributes || {};
        return {
          RecId: item.monitorId || item.fixedAssetId,
          Title: item.fixedAssetName || item.monitorName,
          MonitorType: attrs.MONITOR_TYPE || item.monitorType,
          MonitorStatus: item.monitorStatus || attrs.MONITOR_STATUS,
          // IS_DISABLED 可能为布尔或字符串 'false'/'true'/'Y'/'N'，统一规范化成布尔，避免字符串 'false' 误判禁用置灰
          IsDisabled: normalizeDisabled(attrs.IS_DISABLED) || normalizeDisabled(item.isDisabled),
          MonitorValue: item.monitorValue || attrs.LAST_VALUE || item.lastValue || '',
          MonitorEntry: attrs.METRIC_FOR_STATUS || '',
        };
      });
      callback && callback(legacyList);
    }).catch(err => {
      callback && callback([]);
    });
  }
}

function getOfbizPageList(res) {
  if (Array.isArray(res)) {
    return res;
  }
  if (!res) {
    return [];
  }
  return res.list || res.dataList || res.records || (res.data && (res.data.list || res.data.records)) || [];
}

function getMonitorTypeFromListItem(item) {
  var attrs = item.attributes || {};
  var monitorType = attrs.MONITOR_TYPE || item.monitorType || item.MonitorType || item.type || '';
  if (!monitorType && item.MonitorTableName) {
    monitorType = item.MonitorTableName.replace('EccMonitor.', '');
  }
  return monitorType;
}

function adaptMonitorListItemToCreateOption(item, equipmentType) {
  var attrs = item.attributes || {};
  var monitorType = getMonitorTypeFromListItem(item);
  var monitorName = item.MonitorName || item.monitorName || item.fixedAssetName || item.name || monitorType;
  return {
    RecId: item.RecId || item.monitorListId || item.monitorId || item.fixedAssetId || monitorType,
    MonitorName: monitorName,
    MonitorTableName: item.MonitorTableName || ('EccMonitor.' + monitorType),
    MonitorRange: item.MonitorRange || item.monitorRange || equipmentType || '',
    IsKeepalive: item.IsKeepalive || item.isKeepalive || attrs.IS_KEEPALIVE || 'false',
    isPassive: item.isPassive || attrs.IS_PASSIVE || false,
    description: item.description || item.monitorPackage || item.packageName || attrs.DESCRIPTION || '',
  };
}

// 把监测器模板行适配成监测器选择列表项（名称/描述按数据优先级展示）
// 名称优先模板数据 MonitorName（如"共享目录"），再兜底 monitorType（如"Windows 服务器"）；
// 描述优先有意义的国际化结果，否则用 monitorType 作为类型说明；
// 过滤旧国际化接口返回的字面假值（'MonitorName'/'Description'），避免覆盖真实名称。
function adaptMonitorTemplateToTableData(item, result) {
  var monitorType = item.MonitorTableName.substring(11);
  result = result || {};
  var localeName = result[monitorType] && result[monitorType][monitorType] && result[monitorType][monitorType] !== 'MonitorName' ? result[monitorType][monitorType] : '';
  var localeDesc = result[monitorType] && result[monitorType].Description && result[monitorType].Description !== 'Description' ? result[monitorType].Description : '';
  var name = item.MonitorName || localeName || item.monitorType || monitorType;
  var description = localeDesc || item.monitorType || item.MonitorName || '';
  var returnValue = (result[monitorType] && result[monitorType].Item) || '';
  return {
    id: item.RecId,
    name: name,
    description: description,
    returnValue: returnValue,
    monitorType: monitorType,
    monitorPackage: item.description || description,
    IsKeepalive: item.IsKeepalive,
    isPassive: item.isPassive,
  };
}

function getSelectedEquipmentIdFromState(state) {
  var reducer = state.equipmentReducer || {};
  var selectedResource = reducer.selectedResource || reducer.selectedNode || {};
  return selectedResource.id || selectedResource.RecId || selectedResource.equipmentId || selectedResource.fixedAssetId || '';
}

// 从 state 中取父级设备（新增监测器场景）的真实类型码 equipType（如 Equipment.Windows）
// 优先取适配层透传的 equipType（attributes.EQUIP_TYPE），兜底树节点 eqType，最后为空。
function getSelectedEquipmentEquipTypeFromState(state) {
  var reducer = state.equipmentReducer || {};
  var node = reducer.selectedResource || reducer.selectedNode || reducer.backupResource || {};
  if (node.equipType) return node.equipType;
  if (node.attributes && node.attributes.EQUIP_TYPE) return node.attributes.EQUIP_TYPE;
  if (node.eqType) return node.eqType;
  return '';
}

// 旧 EquipmentType 短名（如 'Unix'）→ 新 EQUIP_TYPE 设备类型码（如 'Equipment.Unix'）
// 新接口 /equipment/create 的 EQUIP_TYPE 为必填，用于匹配监测器模板的 MONITOR_RANGE。
function toEquipmentTypeCode(equipmentType) {
  if (!equipmentType) return '';
  const type = String(equipmentType).trim();
  if (!type) return '';
  return type.indexOf('Equipment.') === 0 ? type : 'Equipment.' + type;
}

// ---------------------------------------------------------------------------
// 设备类型数据：动态接口 + 静态回退
// 新接口 /itoss/control/json/equipment/types 返回设备类型树：
//   data.list: [{ categoryCode, categoryName, types: [{ typeCode, typeName, typeId }] }]
// typeCode 即设备的 EQUIP_TYPE 值（如 Equipment.Windows），与旧前端静态
// ResourceUtils.resourceData 的 types 字符串保持一致。
// 此处统一适配成旧结构（大类 RecId=categoryCode、型号 relationEqName=typeCode），
// 供 getResourceTypes / getResourcesByTypeId / getResourcesBySearchName 复用。
// 模块级缓存一次；接口失败或为空时回退静态 resourceData，保证页面可用。
// ---------------------------------------------------------------------------
let _equipmentTypesCachePromise = null;

function buildStaticEquipmentTypes() {
  const resourceData = (ResourceUtils && ResourceUtils.resourceData) || [];
  const categories = resourceData.map(item => ({
    RecId: item.resource,
    typeAlias: item.resource,
    EqName: item.resource_zh || item.resource,  // 显示中文名
    descript: '',
    ifshow: true,
  }));
  const types = [];
  resourceData.forEach(cat => {
    (cat.types || []).forEach(typeStr => {
      // typeStr 形如 "Equipment.Unix"，去掉前缀得到 typeAlias
      const alias = typeStr.replace(/^Equipment\./, '');
      types.push({
        RecId: typeStr,
        typeAlias: alias,
        EqName: alias,
        descript: cat.resource_zh + ' - ' + alias,
        relationEqName: typeStr,
        eqType: typeStr,
        parentType: cat.resource,  // 所属大类，用于按类型过滤
        ifshow: true,
      });
    });
  });
  return { categories, types };
}

function getEquipmentTypesData() {
  if (!_equipmentTypesCachePromise) {
    _equipmentTypesCachePromise = ofbiz.getEquipmentTypes()
      .then(res => {
        // 兼容两种返回形态：{ list: [...] } 或直接数组
        const list = Array.isArray(res) ? res : ((res && res.list) || []);
        if (!list.length) {
          // 接口返回空，回退静态数据
          return buildStaticEquipmentTypes();
        }
        const categories = list.map(cat => ({
          RecId: cat.categoryCode,
          typeAlias: cat.categoryCode,
          EqName: cat.categoryNameZh || cat.categoryName || cat.categoryCode,
          descript: cat.categoryName || cat.categoryCode,
          ifshow: true,
        }));
        const types = [];
        list.forEach(cat => {
          const catName = cat.categoryNameZh || cat.categoryName || cat.categoryCode;
          const catDesc = cat.description || cat.categoryName || cat.categoryCode;
          (cat.types || []).forEach(t => {
            const codeAlias = t.typeCode.replace(/^Equipment\./, '');
            const showName = t.typeName || codeAlias;
            types.push({
              RecId: t.typeCode,
              // 表格展示用 typeName；EqName 必须是代码短名（typeCode 去前缀），
              // 因为提交时 EquipmentType=EqName 会经 equipmentTypeToClassEnum/EQUIP_TYPE 转换，
              // 用中文展示名会导致类型映射失败
              typeAlias: showName,
              EqName: codeAlias,
              descript: t.description || catDesc || (catName + ' - ' + showName),
              relationEqName: t.typeCode,
              eqType: t.typeCode,
              parentType: cat.categoryCode,
              ifshow: true,
            });
          });
        });
        return { categories, types };
      })
      .catch(() => {
        // 接口失败：本次回退静态数据，但不缓存，下次调用重新请求
        _equipmentTypesCachePromise = null;
        return buildStaticEquipmentTypes();
      });
  }
  return _equipmentTypesCachePromise;
}

export function getResourceTypes(callback) { //获取资源类型数据。
    return dispatch => {
      // 动态获取设备类型树（/equipment/types），失败回退前端静态 resourceData
      getEquipmentTypesData().then(data => {
        dispatch(setResourceTypes(data.categories));
        dispatch(setCreateResourcesTableData(data.types));
        dispatch(requestDataActions.setRequestSuccess());
        callback && callback();
      });
    }
}

export function getResourcesByTypeId(resourceTypeRecId) {
	return dispatch => {
    getEquipmentTypesData().then(data => {
      // 按大类 categoryCode 过滤（'' 或 null 表示全部）
      let filtered = data.types;
      if (resourceTypeRecId) {
        filtered = data.types.filter(item => item.parentType === resourceTypeRecId);
      }
      dispatch(setCreateResourcesTableData(filtered));
      dispatch(requestDataActions.setRequestSuccess());
    });
  }
}

export function getResourcesBySearchName(searchName, callback) {
	return dispatch => {
    getEquipmentTypesData().then(data => {
      let filtered = data.types;
      if (searchName) {
        const kw = searchName.toLowerCase();
        filtered = data.types.filter(item =>
          item.typeAlias.toLowerCase().indexOf(kw) > -1 ||
          (item.descript && item.descript.toLowerCase().indexOf(kw) > -1)
        );
      }
      dispatch(setCreateResourcesTableData(filtered));
      dispatch(requestDataActions.setRequestSuccess());
      callback && callback();
    });
  }
}

export function setSelectedResourceByRightClickTree(treeNode, callback) {
	return dispatch => {
    // ⚠️ 后端无 EquipmentTypeRel 对应，旧 oData.getResourceTypeRel 会走旧鉴权。
    // 这里直接选中传入的 treeNode（不再去查资源类型关系），保证右键新建流程可用。
    dispatch(setSelectedResource(treeNode));
    dispatch(requestDataActions.setRequestSuccess());
    callback && callback(treeNode);
  }
}

export function getEquipment(equipmentId) {
	return dispatch => {
		dispatch(requestDataActions.setRequest());
    // === 已切换到 OFBiz 新接口 /equipment/getById ===
    ofbiz.getEquipmentById(equipmentId).then(detail => {
      if (!detail) {
        dispatch(requestDataActions.setRequestFail());
        return;
      }
      var attrs = detail.attributes || {};
      dispatch(setEquipmentServerAddress(attrs.IP_ADDRESS || detail.ipAddress || ''));
      dispatch(setEquipmentModel(attrs.MODEL || ''));
      dispatch(requestDataActions.setRequestSuccess());
    }).catch(err => {
      dispatch(requestDataActions.setRequestFail());
    });
	}
}

export function getMonitors(equipmentType, vendor, resourceModel, callback, equipmentId) {
	return (dispatch, getState) => {
    dispatch(setCreateMonitorsTableData([]));
    dispatch(setCommonMonitors([]));
		dispatch(requestDataActions.setRequest());
		// === 已切换到 OFBiz 新接口 /monitor/types（监测器模板列表，按设备类型过滤）===
    // 新增监测器的候选 = 监测器模板（FixedAsset IT_MONITOR_TEMPLATE），按父级设备的
    // 真实 equipType（设备 EQUIP_TYPE 属性，如 Equipment.Windows，来自资源树节点
    // monitor/tree 返回的 equipType）过滤；不再按 parentFixedAssetId 查 /monitor/list。
    var equipType = getSelectedEquipmentEquipTypeFromState(getState()) || equipmentType;
    ofbiz.getMonitorTypes({ equipType }).then(listData => {
      var monitorResults = getOfbizPageList(listData).map(item => adaptMonitorListItemToCreateOption(item, equipmentType));
			if(monitorResults.length == 0){
          dispatch(requestDataActions.setRequestFail());
          callback && callback();
          return;
      }
			var monitorsTableData = [], count = 0, commonMonitors = [];
      // console.log(monitorResults);
			if(equipmentType == "Equipment.Network" || equipmentType == "Equipment.FireWall") {
				dispatch(requestDataActions.setRequest());
				oData.getMibs(vendor, resourceModel, function(data2){
          // console.log(data2);
					if(data2.results.length == 0){
            // _this.emit("change");
            dispatch(requestDataActions.setRequestFail());
            if(equipmentType == "Equipment.FireWall"){
  						for(var i = 0; i < monitorResults.length; i++) {
  							var monitorType = monitorResults[i].MonitorTableName.substring(11);
  							if(monitorType == "PowerStatus" || monitorType == "Temperature" || monitorType == "NetworkCpu" || monitorType == "NetworkMemory" || monitorType == "FanStatus") {
  								monitorResults.splice(i, 1);
  								i--;
  							}
  						}
            }
			    }else {
						for(var i = 0; i < monitorResults.length; i++) {
							var monitorType = monitorResults[i].MonitorTableName.substring(11);
							if(monitorType == "PowerStatus" && data2.results[0].PowerOID == "") {
								monitorResults.splice(i, 1);
								i--;
							}
							else if(monitorType == "Temperature" && data2.results[0].TemperatureOID == "") {
								monitorResults.splice(i, 1);
								i--;
							}
							else if(monitorType == "NetworkCpu" && (data2.results[0].CpuOID == "" && data2.results[0].Cpu1mOID == "" && data2.results[0].Cpu5mOID == "" && data2.results[0].Cpu5sOID == "")) {
								monitorResults.splice(i, 1);
								i--;
							}
							else if(monitorType == "NetworkMemory" && (data2.results[0].MemUseOID == "" && (data2.results[0].MemFreeOID == "" || data2.results[0].MemTotalOID == "")  )) {
								monitorResults.splice(i, 1);
								i--;
							}
							else if(monitorType == "FanStatus" && data2.results[0].FanstatusOID == "") {
								monitorResults.splice(i, 1);
								i--;
							}
						}
					}

          // 国际化监测器列表信息
          dispatch(requestDataActions.setRequest());
          var _monitorLocale = monitorResults.map((item) => {
            var _monitorType = item.MonitorTableName.substring(11), _resourceType = item.MonitorRange.replace('Equipment.', '');
            return { "monitorId": "", "monitorType": _monitorType, "MonitorRange": _resourceType, "key": "MonitorName", "locale": "zh" }
          });
          ServerEquipment.getMonitorLocale(_monitorLocale, (result) => {
            result = result || {};
            if (result.errorCode) {
              dispatch(requestDataActions.setRequestFail());
            }
            monitorResults.map((item) => {
              var _row = adaptMonitorTemplateToTableData(item, result);
              var monitorType = _row.monitorType;
              monitorsTableData.push(_row);
              var _index = commonMonitorNames.indexOf(monitorType);
              if (_index > -1) {
                commonMonitors[_index] = Object.assign({}, _row, { returnValue: '' });
              }
            })
            // console.log(commonMonitors);
            commonMonitors = commonMonitors.filter(item => item);
            if (commonMonitors.length > 6) {
              commonMonitors = commonMonitors.slice(0, 6);
            }
            dispatch(setCreateMonitorsTableData(monitorsTableData));
            dispatch(setCommonMonitors(commonMonitors));
            dispatch(requestDataActions.setRequestSuccess());
            callback && callback({monitorsTableData: monitorsTableData, commonMonitors: commonMonitors});
          })
          // 获取Item国际化
					// for(var i = 0; i < monitorResults.length; i++) {
					// 	dispatch(requestDataActions.setRequest());
					// 	oData.getMonitorReturnValues(monitorResults[i].MonitorTableName.substring(11), function(data3, monitorType){
					// 		count++;
					// 		if(data3.results.length == 0){
		      //       // _this.emit("change");
		      //       dispatch(requestDataActions.setRequestFail());
					// 			for(var j = 0; j < monitorResults.length; j++) {
					// 				if(monitorResults[j].MonitorTableName.substring(11) == monitorType) {
          //           var _description = createMonitorModalTexts[monitorType] ? createMonitorModalTexts[monitorType].Description : monitorResults[j].MonitorName;
					// 					monitorsTableData.push({id:monitorResults[j].RecId, name:monitorResults[j].MonitorName, description:_description, returnValue:"", monitorType:monitorType, monitorPackage:monitorResults[j].description, IsKeepalive: monitorResults[j].IsKeepalive, isPassive: monitorResults[j].isPassive});
					// 					if(monitorType.indexOf("Ping") != -1
					// 					|| monitorType.toLowerCase().indexOf("cpu") != -1
					// 					|| monitorType.toLowerCase().indexOf("memory") != -1
					// 					|| monitorType.toLowerCase().indexOf("disk") != -1
					// 					|| monitorType.indexOf("Process") != -1) {
					// 						commonMonitors.push({id:monitorResults[j].RecId, name:monitorResults[j].MonitorName, description:_description, returnValue:"", monitorType:monitorType, monitorPackage:monitorResults[j].description});
					// 					}
					// 					break;
					// 				}
					// 			}
					// 			if(count == monitorResults.length) {
					// 				dispatch(setCreateMonitorsTableData(monitorsTableData));
					// 				dispatch(setCommonMonitors(commonMonitors));
					// 			}
			    //       return;
			    //     }
					// 		var monitorReturnValues = data3.results;
					// 		var returnValue="";
					// 		for(var j = 0; j < monitorReturnValues.length; j++) {
					// 			if(returnValue=="") {
					// 				returnValue += createMonitorModalTexts[monitorReturnValues[j].MonitorType][monitorReturnValues[j].SaveItem];
					// 			}
					// 			else {
					// 				returnValue += ','+createMonitorModalTexts[monitorReturnValues[j].MonitorType][monitorReturnValues[j].SaveItem];
					// 			}
					// 		}
					// 		for(var j = 0; j < monitorResults.length; j++) {
					// 			if(monitorResults[j].MonitorTableName.substring(11) == monitorType) {
          //         var _description = createMonitorModalTexts[monitorType] ? createMonitorModalTexts[monitorType].Description : monitorResults[j].MonitorName;
					// 				monitorsTableData.push({id:monitorResults[j].RecId, name:monitorResults[j].MonitorName, description:_description, returnValue:returnValue, monitorType:monitorType, monitorPackage:monitorResults[j].description, IsKeepalive: monitorResults[j].IsKeepalive, isPassive: monitorResults[j].isPassive});
					// 				if(monitorType.indexOf("Ping") != -1
					// 				|| monitorType.toLowerCase().indexOf("cpu") != -1
					// 				|| monitorType.toLowerCase().indexOf("memory") != -1
					// 				|| monitorType.toLowerCase().indexOf("disk") != -1
					// 				|| monitorType.indexOf("Process") != -1) {
					// 					commonMonitors.push({id:monitorResults[j].RecId, name:monitorResults[j].MonitorName, description:_description, returnValue:"", monitorType:monitorType, monitorPackage:monitorResults[j].description});
					// 				}
					// 				break;
					// 			}
					// 		}
					// 		if(count == monitorResults.length) {
					// 			dispatch(setCreateMonitorsTableData(monitorsTableData));
					// 			dispatch(setCommonMonitors(commonMonitors));
					// 		}
			    //     // _this.emit("change");
			    //     dispatch(requestDataActions.setRequestSuccess());
					// 	});
					// }
	        // _this.emit("change");
	        dispatch(requestDataActions.setRequestSuccess());
				});
			}
			else {
        // 国际化监测器列表信息
        dispatch(requestDataActions.setRequest());
        var _monitorLocale = monitorResults.map((item) => {
          var _monitorType = item.MonitorTableName.substring(11), _resourceType = item.MonitorRange.replace('Equipment.', '');
          return { "monitorId": "", "monitorType": _monitorType, "MonitorRange": _resourceType, "key": "MonitorName", "locale": "zh" }
        });
        ServerEquipment.getMonitorLocale(_monitorLocale, (result) => {
          result = result || {};
          if (result.errorCode) {
            dispatch(requestDataActions.setRequestFail());
            // 国际化失败不中断：继续用模板数据兜底展示（名称/描述按数据优先级）
          }
          monitorResults.map((item) => {
            var _row = adaptMonitorTemplateToTableData(item, result);
            var monitorType = _row.monitorType;
            monitorsTableData.push(_row);
            var _index = commonMonitorNames.indexOf(monitorType);
            if (_index > -1) {
              commonMonitors[_index] = Object.assign({}, _row, { returnValue: '' });
            }
          });
          commonMonitors = commonMonitors.filter(item => item);
          if (commonMonitors.length > 6) {
            commonMonitors = commonMonitors.slice(0, 6);
          }
          // console.log(commonMonitors);
          dispatch(setCreateMonitorsTableData(monitorsTableData));
          dispatch(setCommonMonitors(commonMonitors));
          dispatch(requestDataActions.setRequestSuccess());
          callback && callback({monitorsTableData: monitorsTableData, commonMonitors: commonMonitors});
        })
        // 获取Item国际化
				// for(var i = 0; i < monitorResults.length; i++) {
				// 	dispatch(requestDataActions.setRequest());
				// 	oData.getMonitorReturnValues(monitorResults[i].MonitorTableName.substring(11), function(data2, monitorType){
				// 		count++;
				// 		if(data2.results.length == 0){
				// 			// _this.emit("change");
				// 			dispatch(requestDataActions.setRequestFail());
				// 			for(var j = 0; j < monitorResults.length; j++) {
				// 				if(monitorResults[j].MonitorTableName.substring(11) == monitorType) {
        //           var _description = createMonitorModalTexts[monitorType] ? createMonitorModalTexts[monitorType].Description : monitorResults[j].MonitorName;
				// 					monitorsTableData.push({id:monitorResults[j].RecId, name:monitorResults[j].MonitorName, description:_description, returnValue:"", monitorType:monitorType, monitorPackage:monitorResults[j].description, IsKeepalive: monitorResults[j].IsKeepalive, isPassive: monitorResults[j].isPassive});
				// 					if(monitorType.indexOf("Ping") != -1
				// 					|| ((monitorResults[j].Range=="Equipment.AgentUnix" && monitorType=="AgentCPU") || (monitorResults[j].Range=="Equipment.Unix" && monitorType=="CPU") || (monitorResults[j].Range=="Equipment.WirelessNetwork" && monitorType=="NetworkCpu") || (monitorResults[j].Range!="Equipment.AgentUnix" && monitorResults[j].Range!="Equipment.Unix" && monitorResults[j].Range!="Equipment.WirelessNetwork" && monitorType.toLowerCase().indexOf("cpu") != -1))
				// 					|| ((monitorResults[j].Range=="Equipment.AgentUnix" && monitorType=="AgentMemory") || (monitorResults[j].Range=="Equipment.Unix" && monitorType=="Memory") || (monitorResults[j].Range=="Equipment.WirelessNetwork" && monitorType=="NetworkMemory") || (monitorResults[j].Range!="Equipment.AgentUnix" && monitorResults[j].Range!="Equipment.Unix" && monitorResults[j].Range!="Equipment.WirelessNetwork" && monitorType.toLowerCase().indexOf("memory") != -1))
				// 					|| ((monitorResults[j].Range=="Equipment.AgentUnix" && monitorType=="AgentDiskSpace") || (monitorResults[j].Range=="Equipment.Unix" && monitorType=="DiskSpace") || (monitorResults[j].Range=="Equipment.SNMPUnix" && monitorType=="SnmpDisk") || (monitorResults[j].Range!="Equipment.AgentUnix" && monitorResults[j].Range!="Equipment.Unix" && monitorResults[j].Range!="Equipment.SNMPUnix" && monitorType.toLowerCase().indexOf("disk") != -1))
				// 					|| monitorType.indexOf("Process") != -1) {
				// 						commonMonitors.push({id:monitorResults[j].RecId, name:monitorResults[j].MonitorName, description:_description, returnValue:"", monitorType:monitorType, monitorPackage:monitorResults[j].description});
				// 					}
				// 					break;
				// 				}
				// 			}
				// 			if(count == monitorResults.length) {
				// 				dispatch(setCreateMonitorsTableData(monitorsTableData));
				// 				dispatch(setCommonMonitors(commonMonitors));
				// 			}
				// 			return;
				// 		}
				// 		var monitorReturnValues = data2.results;
				// 		var returnValue="";
				// 		for(var j = 0; j < monitorReturnValues.length; j++) {
				// 			if(returnValue=="") {
				// 				returnValue += createMonitorModalTexts[monitorReturnValues[j].MonitorType] ? createMonitorModalTexts[monitorReturnValues[j].MonitorType][monitorReturnValues[j].SaveItem] : '';
				// 			}
				// 			else {
				// 				returnValue += ','+createMonitorModalTexts[monitorReturnValues[j].MonitorType][monitorReturnValues[j].SaveItem];
				// 			}
				// 		}
				// 		for(var j = 0; j < monitorResults.length; j++) {
				// 			if(monitorResults[j].MonitorTableName.substring(11) == monitorType) {
        //         var _description = createMonitorModalTexts[monitorType] ? createMonitorModalTexts[monitorType].Description : monitorResults[j].MonitorName;
				// 				monitorsTableData.push({id:monitorResults[j].RecId, name:monitorResults[j].MonitorName, description:_description, returnValue:returnValue, monitorType:monitorType, monitorPackage:monitorResults[j].description, IsKeepalive: monitorResults[j].IsKeepalive, isPassive: monitorResults[j].isPassive});
				// 				if(monitorType.indexOf("Ping") != -1
				// 				|| ((monitorResults[j].Range=="Equipment.AgentUnix" && monitorType=="AgentCPU") || (monitorResults[j].Range=="Equipment.Unix" && monitorType=="CPU") || (monitorResults[j].Range=="Equipment.WirelessNetwork" && monitorType=="NetworkCpu") || (monitorResults[j].Range!="Equipment.AgentUnix" && monitorResults[j].Range!="Equipment.Unix" && monitorResults[j].Range!="Equipment.WirelessNetwork" && monitorType.toLowerCase().indexOf("cpu") != -1))
				// 				|| ((monitorResults[j].Range=="Equipment.AgentUnix" && monitorType=="AgentMemory") || (monitorResults[j].Range=="Equipment.Unix" && monitorType=="Memory") || (monitorResults[j].Range=="Equipment.WirelessNetwork" && monitorType=="NetworkMemory") || (monitorResults[j].Range!="Equipment.AgentUnix" && monitorResults[j].Range!="Equipment.Unix" && monitorResults[j].Range!="Equipment.WirelessNetwork" && monitorType.toLowerCase().indexOf("memory") != -1))
				// 				|| ((monitorResults[j].Range=="Equipment.AgentUnix" && monitorType=="AgentDiskSpace") || (monitorResults[j].Range=="Equipment.Unix" && monitorType=="DiskSpace") || (monitorResults[j].Range=="Equipment.SNMPUnix" && monitorType=="SnmpDisk") || (monitorResults[j].Range!="Equipment.AgentUnix" && monitorResults[j].Range!="Equipment.Unix" && monitorResults[j].Range!="Equipment.SNMPUnix" && monitorType.toLowerCase().indexOf("disk") != -1))
				// 				|| monitorType.indexOf("Process") != -1) {
				// 					commonMonitors.push({id:monitorResults[j].RecId, name:monitorResults[j].MonitorName, description:_description, returnValue:"", monitorType:monitorType, monitorPackage:monitorResults[j].description});
				// 				}
				// 				break;
				// 			}
				// 		}
				// 		if(count == monitorResults.length) {
				// 			dispatch(setCreateMonitorsTableData(monitorsTableData));
				// 			dispatch(setCommonMonitors(commonMonitors));
				// 		}
				// 		// _this.emit("change");
				// 		dispatch(requestDataActions.setRequestSuccess());
				// 	});
				// }
			}
      // _this.emit("change");
      dispatch(requestDataActions.setRequestSuccess());
		}).catch(() => {
      dispatch(setCreateMonitorsTableData([]));
      dispatch(setCommonMonitors([]));
      dispatch(requestDataActions.setRequestFail());
      callback && callback();
    });
  }
}

export function getMonitorsBySearchName(searchName, equipmentType, vendor, resourceModel, equipmentId) {
	return (dispatch, getState) => {
    dispatch(setCreateMonitorsTableData([]));
		dispatch(requestDataActions.setRequest());
    var keyword = $.trim(searchName || '');
    // === 已切换到 OFBiz 新接口 /monitor/types（监测器模板列表，按设备类型过滤）===
    // 与 getMonitors 一致：按父级设备 equipType 取模板，前端再按名称关键字过滤
    var equipType = getSelectedEquipmentEquipTypeFromState(getState()) || equipmentType;
    ofbiz.getMonitorTypes({ equipType }).then(listData => {
      // 名称/描述按数据优先级：优先模板 monitorName/monitorType
      var monitorsTableData = getOfbizPageList(listData).map(item => adaptMonitorTemplateToTableData(item, null));
      if(keyword) {
        monitorsTableData = monitorsTableData.filter((item) => {
          return item.name.toLowerCase().indexOf(keyword.toLowerCase()) !== -1;
        });
      }
      dispatch(setCreateMonitorsTableData(monitorsTableData));
      dispatch(requestDataActions.setRequestSuccess());
    }).catch(() => {
      dispatch(setCreateMonitorsTableData([]));
      dispatch(requestDataActions.setRequestFail());
    });
    return;
		oData.getMonitors(equipmentType, function(data){
			if(data.results.length == 0){
	            // _this.emit("change");
	            dispatch(requestDataActions.setRequestFail());
	            return;
	        }
	        //console.log("查询成功",data.results);
			var monitorsTableData = [], filteredMonitors = [], count = 0;
			var monitorResults = data.results;
			if(equipmentType == "Equipment.Network" || equipmentType == "Equipment.FireWall") {
				dispatch(requestDataActions.setRequest());
				oData.getMibs(vendor, resourceModel, function(data2){
					if(data2.results.length == 0){
			            // _this.emit("change");
			            dispatch(requestDataActions.setRequestFail());
						for(var i = 0; i < monitorResults.length; i++) {
							var monitorType = monitorResults[i].MonitorTableName.substring(11);
							if(monitorType == "PowerStatus" || monitorType == "Temperature" || monitorType == "NetworkCpu" || monitorType == "NetworkMemory" || monitorType == "FanStatus") {
								monitorResults.splice(i, 1);
								i--;
							}
						}
			        }
			        else {
						for(var i = 0; i < monitorResults.length; i++) {
							var monitorType = monitorResults[i].MonitorTableName.substring(11);
							if(monitorType == "PowerStatus" && data2.results[0].PowerOID == "") {
								monitorResults.splice(i, 1);
								i--;
							}
							else if(monitorType == "Temperature" && data2.results[0].TemperatureOID == "") {
								monitorResults.splice(i, 1);
								i--;
							}
							else if(monitorType == "NetworkCpu" && data2.results[0].CpuOID == "") {
								monitorResults.splice(i, 1);
								i--;
							}
							else if(monitorType == "NetworkMemory" && data2.results[0].MemTotalOID == "") {
								monitorResults.splice(i, 1);
								i--;
							}
							else if(monitorType == "FanStatus" && data2.results[0].FanstatusOID == "") {
								monitorResults.splice(i, 1);
								i--;
							}
						}
					}
          // 国际化监测器列表信息
          dispatch(requestDataActions.setRequest());
          var _monitorLocale = monitorResults.map((item) => {
            var _monitorType = item.MonitorTableName.substring(11), _resourceType = item.MonitorRange.replace('Equipment.', '');
            return { "monitorId": "", "monitorType": _monitorType, "MonitorRange": _resourceType, "key": "MonitorName", "locale": "zh" }
          });
          ServerEquipment.getMonitorLocale(_monitorLocale, (result) => {
            if (result.errorCode) {
              dispatch(requestDataActions.setRequestFail());
            } else {
              dispatch(requestDataActions.setRequestSuccess());
            }
            monitorResults.map((item) => {
              var monitorType = item.MonitorTableName.substring(11);
              var name = result[monitorType] && result[monitorType][monitorType] !== 'MonitorName' ? result[monitorType][monitorType] : item.MonitorName, description = result[monitorType] ? result[monitorType].Description : '', returnValue = result[monitorType] ? result[monitorType].Item : '';
              monitorsTableData.push({id:item.RecId, name:name, description:description, returnValue:returnValue, monitorType:monitorType, monitorPackage:item.description, IsKeepalive: item.IsKeepalive, isPassive: item.isPassive});
            })
            if($.trim(searchName) != "") {
              filteredMonitors = monitorsTableData.filter((item) => {
                return item.name.toLowerCase().indexOf($.trim(searchName.toLowerCase())) !== -1;
              })
    				} else {
    					filteredMonitors = monitorsTableData;
    				}
            dispatch(setCreateMonitorsTableData(filteredMonitors));
          })

					// if($.trim(searchName) != "") {
			    //         for(var i = 0; i < monitorResults.length; i++) {
			    //             var bMatch = true;
			    //             if(monitorResults[i].MonitorName.toLowerCase().indexOf($.trim(searchName.toLowerCase())) == -1) {
			    //                 bMatch = false;
			    //             }
          //
			    //             if(bMatch) {
			    //                 filteredMonitors.push(monitorResults[i]);
			    //             }
			    //         }
			    //     }
			    //     else {
					// 	filteredMonitors = monitorResults;
			    //     }

					// for(var i = 0; i < filteredMonitors.length; i++) {
					// 	dispatch(requestDataActions.setRequest());
					// 	oData.getMonitorReturnValues(filteredMonitors[i].MonitorTableName.substring(11), function(data3, monitorType){
					// 		count++;
					// 		if(data3.results.length == 0){
					//             // _this.emit("change");
					//             dispatch(requestDataActions.setRequestFail());
					// 			for(var j = 0; j < filteredMonitors.length; j++) {
					// 				if(filteredMonitors[j].MonitorTableName.substring(11) == monitorType) {
          //           var _description = createMonitorModalTexts[monitorType] ? createMonitorModalTexts[monitorType].Description : filteredMonitors[j].MonitorName;
					// 					monitorsTableData.push({id:filteredMonitors[j].RecId, name:filteredMonitors[j].MonitorName, description:_description, returnValue:"", monitorType:monitorType, monitorPackage:filteredMonitors[j].description, IsKeepalive: monitorResults[j].IsKeepalive, isPassive: monitorResults[j].isPassive});
					// 					break;
					// 				}
					// 			}
					// 			if(count == filteredMonitors.length) {
					// 				dispatch(setCreateMonitorsTableData(monitorsTableData));
					// 			}
					//             return;
					//         }
					// 		var monitorReturnValues = data3.results;
					// 		var returnValue="";
					// 		for(var j = 0; j < monitorReturnValues.length; j++) {
					// 			if(returnValue=="") {
					// 				returnValue += createMonitorModalTexts[monitorReturnValues[j].MonitorType][monitorReturnValues[j].SaveItem];
					// 			}
					// 			else {
					// 				returnValue += ','+createMonitorModalTexts[monitorReturnValues[j].MonitorType][monitorReturnValues[j].SaveItem];
					// 			}
					// 		}
					// 		for(var j = 0; j < filteredMonitors.length; j++) {
					// 			if(filteredMonitors[j].MonitorTableName.substring(11) == monitorType) {
          //         var _description = createMonitorModalTexts[monitorType] ? createMonitorModalTexts[monitorType].Description : filteredMonitors[j].MonitorName;
					// 				monitorsTableData.push({id:filteredMonitors[j].RecId, name:filteredMonitors[j].MonitorName, description:_description, returnValue:returnValue, monitorType:monitorType, monitorPackage:filteredMonitors[j].description, IsKeepalive: monitorResults[j].IsKeepalive, isPassive: monitorResults[j].isPassive});
					// 				break;
					// 			}
					// 		}
					// 		if(count == filteredMonitors.length) {
					// 			dispatch(setCreateMonitorsTableData(monitorsTableData));
					// 		}
					//         // _this.emit("change");
					//         dispatch(requestDataActions.setRequestSuccess());
					// 	});
					// }
			        // _this.emit("change");
			        dispatch(requestDataActions.setRequestSuccess());
				});
			}
			else {
        // 国际化监测器列表信息
        dispatch(requestDataActions.setRequest());
        var _monitorLocale = monitorResults.map((item) => {
          var _monitorType = item.MonitorTableName.substring(11), _resourceType = item.MonitorRange.replace('Equipment.', '');
          return { "monitorId": "", "monitorType": _monitorType, "MonitorRange": _resourceType, "key": "MonitorName", "locale": "zh" }
        });
        ServerEquipment.getMonitorLocale(_monitorLocale, (result) => {
          if (result.errorCode) {
            dispatch(requestDataActions.setRequestFail());
          } else {
            dispatch(requestDataActions.setRequestSuccess());
          }
          monitorResults.map((item) => {
            var monitorType = item.MonitorTableName.substring(11);
            var name = result[monitorType] && result[monitorType][monitorType] !== 'MonitorName' ? result[monitorType][monitorType] : item.MonitorName, description = result[monitorType] ? result[monitorType].Description : '', returnValue = result[monitorType] ? result[monitorType].Item : '';
            monitorsTableData.push({id:item.RecId, name:name, description:description, returnValue:returnValue, monitorType:monitorType, monitorPackage:item.description, IsKeepalive: item.IsKeepalive, isPassive: item.isPassive});
          })
          if($.trim(searchName) != "") {
            filteredMonitors = monitorsTableData.filter((item) => {
              return item.name.toLowerCase().indexOf($.trim(searchName.toLowerCase())) !== -1;
            })
  				} else {
  					filteredMonitors = monitorsTableData;
  				}
          dispatch(setCreateMonitorsTableData(filteredMonitors));
        })

				// if($.trim(searchName) != "") {
				// 	for(var i = 0; i < monitorResults.length; i++) {
				// 		var bMatch = true;
				// 		if(monitorResults[i].MonitorName.toLowerCase().indexOf($.trim(searchName.toLowerCase())) == -1) {
				// 			bMatch = false;
				// 		}
        //
				// 		if(bMatch) {
				// 			filteredMonitors.push(monitorResults[i]);
				// 		}
				// 	}
				// }
				// else {
				// 	filteredMonitors = monitorResults;
				// }

				// for(var i = 0; i < filteredMonitors.length; i++) {
				// 	dispatch(requestDataActions.setRequest());
				// 	oData.getMonitorReturnValues(filteredMonitors[i].MonitorTableName.substring(11), function(data2, monitorType){
				// 		count++;
				// 		if(data2.results.length == 0){
				// 			// _this.emit("change");
				// 			dispatch(requestDataActions.setRequestFail());
				// 			for(var j = 0; j < filteredMonitors.length; j++) {
				// 				if(filteredMonitors[j].MonitorTableName.substring(11) == monitorType) {
        //           var _description = createMonitorModalTexts[monitorType] ? createMonitorModalTexts[monitorType].Description : filteredMonitors[j].MonitorName;
				// 					monitorsTableData.push({id:filteredMonitors[j].RecId, name:filteredMonitors[j].MonitorName, description:_description, returnValue:"", monitorType:monitorType, monitorPackage:filteredMonitors[j].description, IsKeepalive: monitorResults[j].IsKeepalive, isPassive: monitorResults[j].isPassive});
				// 					break;
				// 				}
				// 			}
				// 			if(count == filteredMonitors.length) {
				// 				dispatch(setCreateMonitorsTableData(monitorsTableData));
				// 			}
				// 			return;
				// 		}
				// 		var monitorReturnValues = data2.results;
				// 		var returnValue="";
				// 		for(var j = 0; j < monitorReturnValues.length; j++) {
				// 			if(returnValue=="") {
				// 				returnValue += createMonitorModalTexts[monitorReturnValues[j].MonitorType][monitorReturnValues[j].SaveItem];
				// 			}
				// 			else {
				// 				returnValue += ','+createMonitorModalTexts[monitorReturnValues[j].MonitorType][monitorReturnValues[j].SaveItem];
				// 			}
				// 		}
				// 		for(var j = 0; j < filteredMonitors.length; j++) {
				// 			if(filteredMonitors[j].MonitorTableName.substring(11) == monitorType) {
        //         var _description = createMonitorModalTexts[monitorType] ? createMonitorModalTexts[monitorType].Description : filteredMonitors[j].MonitorName;
				// 				monitorsTableData.push({id:filteredMonitors[j].RecId, name:filteredMonitors[j].MonitorName, description:_description, returnValue:returnValue, monitorType:monitorType, monitorPackage:filteredMonitors[j].description, IsKeepalive: monitorResults[j].IsKeepalive, isPassive: monitorResults[j].isPassive});
				// 				break;
				// 			}
				// 		}
				// 		if(count == filteredMonitors.length) {
				// 			dispatch(setCreateMonitorsTableData(monitorsTableData));
				// 		}
				// 		// _this.emit("change");
				// 		dispatch(requestDataActions.setRequestSuccess());
				// 	});
				// }
			}

	        // _this.emit("change");
	        dispatch(requestDataActions.setRequestSuccess());
		});
    }
}

export function setSelectedMonitorByClickMonitorTableRow(equipmentType, monitorType) {
	return (dispatch, getState) => {
		dispatch(requestDataActions.setRequest());
    var monitorsTableData = getState().equipmentReducer.createMonitorsTableData || [];
    var selectedMonitor = monitorsTableData.find(item => item.monitorType === monitorType);
    if (selectedMonitor) {
      dispatch(setSelectedMonitor(selectedMonitor));
      dispatch(getMonitorAlarmConditionNameData(monitorType));
      dispatch(requestDataActions.setRequestSuccess());
      return;
    }
		// 兜底：createMonitorsTableData 未命中时，按父级设备类型从监测器模板列表取（doc：/monitor/types）
		var equipType = getSelectedEquipmentEquipTypeFromState(getState()) || equipmentType;
		ofbiz.getMonitorTypes({ equipType }).then(listData => {
			var monitorResults = getOfbizPageList(listData).map(item => adaptMonitorListItemToCreateOption(item, equipmentType));
			var matched = null;
			for(var i = 0; i < monitorResults.length; i++) {
				var _type = monitorResults[i].MonitorTableName.substring(11);
				if(_type == monitorType) {
					matched = monitorResults[i];
					break;
				}
			}
			if (matched) {
				dispatch(setSelectedMonitor({id:matched.RecId, name:matched.MonitorName, description:createMonitorModalTexts[monitorType] ? createMonitorModalTexts[monitorType].Description : matched.description, returnValue:"", monitorType:monitorType, monitorPackage:matched.description}));
				dispatch(getMonitorAlarmConditionNameData(monitorType));
			}
			dispatch(requestDataActions.setRequestSuccess());
		}).catch(() => {
			dispatch(requestDataActions.setRequestFail());
		});
  }
}

export function getMonitorAlarmConditionNameData(monitorType, callback) {
	return dispatch => {
		dispatch(setMonitorAlarmConditionNameData([]));
		dispatch(requestDataActions.setRequest());
		// === 已切换到 OFBiz 新接口 /monitor/returnItems ===
		// 旧接口 /bods.svc/Item 已不存在；新接口返回
		//   { list: [{ recId, saveItem, showName, monitorType, isMainReturn(Y/N), sequenceId }] }
		// 适配成旧结构 monitorAlarmConditionNameData = [{ id, name, saveItem }]，主返回项置前
		ofbiz.getMonitorReturnItems(monitorType).then(listData => {
			var monitorReturnValues = getOfbizPageList(listData);
			if (!monitorReturnValues.length) {
				dispatch(requestDataActions.setRequestFail());
				callback && callback();
				return;
			}
			var monitorAlarmConditionNameData = [];
			monitorReturnValues.forEach(item => {
				var _entry = {
					id: item.recId || item.saveItem,
					name: item.showName || item.saveItem,
					saveItem: item.saveItem
				};
				if (item.isMainReturn == 'Y' || item.isMainReturn == '1' || item.isMainReturn === true) {
					monitorAlarmConditionNameData.unshift(_entry);
				}
				else {
					monitorAlarmConditionNameData.push(_entry);
				}
			});
			dispatch(setMonitorAlarmConditionNameData(monitorAlarmConditionNameData));
			dispatch(requestDataActions.setRequestSuccess());
			callback && callback();
		}).catch(() => {
			dispatch(setMonitorAlarmConditionNameData([]));
			dispatch(requestDataActions.setRequestFail());
			callback && callback();
		});
	}
}

export function getInitialAlarmConditionDataFromMonitorType(monitorType, callback) {
	return (dispatch, getState) => {
		dispatch(setMonitorErrorConditionsData([]));
		dispatch(setMonitorSettingErrorConditionsData([]));
		dispatch(setMonitorWarningConditionsData([]));
		dispatch(setMonitorSettingWarningConditionsData([]));
		dispatch(setMonitorGoodConditionsData([]));
		dispatch(setMonitorSettingGoodConditionsData([]));
		dispatch(requestDataActions.setRequest());
		// === 已切换到 OFBiz 新接口 /monitor/alarmConditions ===
		// 旧接口 /bods.svc/EccAlarmCondition 已不存在；新接口返回告警条件模板，
		// 字段同时兼容 camelCase 与旧 PascalCase（saveItem/SaveReturnValue、alarmStatus/AlarmStatus、
		// operator/Operators、threshold/AlramValue）
		ofbiz.getMonitorAlarmConditions(monitorType).then(listData => {
			var alarmConditionsData = getOfbizPageList(listData);
			var monitorAlarmConditionNameData = getState().equipmentReducer.monitorAlarmConditionNameData;
			var errorAlarmConditionsData = [], warningAlarmConditionsData = [], goodAlarmConditionsData = []
			for(var i = 0; i < alarmConditionsData.length; i++) {
				var _cond = alarmConditionsData[i];
				var saveItem = _cond.saveItem || _cond.SaveReturnValue || _cond.returnValue || '';
				var alarmStatus = _cond.alarmStatus || _cond.AlarmStatus || _cond.status || '';
				var _alarmCondition = monitorAlarmConditionNameData.find(item => item.saveItem == saveItem);
				var alarmConditionName = _alarmCondition ? _alarmCondition.name : '';
				var _entry = {
					id: '',
					conditionName: alarmConditionName,
					returnValue: saveItem,
					conditionSymbol: _cond.operator || _cond.Operators || _cond.operators || '',
					conditionValue: _cond.threshold || _cond.AlramValue || _cond.alramValue || _cond.alarmValue || '',
					conditionRelation: ""
				};
				if (alarmStatus == "error") {
					errorAlarmConditionsData.push(_entry);
				}
				else if (alarmStatus == "warning") {
					warningAlarmConditionsData.push(_entry);
				}
				else if (alarmStatus == "good") {
					goodAlarmConditionsData.push(_entry);
				}
			}
			dispatch(setMonitorErrorConditionsData(errorAlarmConditionsData));
			dispatch(setMonitorSettingErrorConditionsData(errorAlarmConditionsData));
			dispatch(setMonitorWarningConditionsData(warningAlarmConditionsData));
			dispatch(setMonitorSettingWarningConditionsData(warningAlarmConditionsData));
			dispatch(setMonitorGoodConditionsData(goodAlarmConditionsData));
			dispatch(setMonitorSettingGoodConditionsData(goodAlarmConditionsData));
			dispatch(requestDataActions.setRequestSuccess());
			callback && callback();
		}).catch(() => {
			dispatch(setMonitorErrorConditionsData([]));
			dispatch(setMonitorWarningConditionsData([]));
			dispatch(setMonitorGoodConditionsData([]));
			dispatch(requestDataActions.setRequestFail());
			callback && callback();
		});
	}
}

export function getAlarmConditionByMonitorId(monitorId, callback) {
  return dispatch => {
    oData.getAlarmConditionDataFromMonitorId(monitorId, function(data){
      callback && callback(data.results);
    }, (res) => {
      if (res.errmsg !== 'token invalid.' && !res.errmsg) {
        res.errmsg = '';
      }
      Util.showInterfaceErrorInfo(res);
      callback && callback();
    })
  }
}

export function batchSettingMonitorAlarmConditions(monitorId, monitorType, callback) {
  return (dispatch, getState) => {
    let addAlarmCount = 0;
    var state = getState();
    var monitorErrorConditionsData = state.equipmentReducer.monitorErrorConditionsData;
		var monitorWarningConditionsData = state.equipmentReducer.monitorWarningConditionsData;
		var monitorGoodConditionsData = state.equipmentReducer.monitorGoodConditionsData;

    var newAlarmConditions = [];
		for(var i = 0; i < monitorErrorConditionsData.length; i++) {
			newAlarmConditions.push({AlarmStatus:"error", MonitorId:monitorId, ReturnValue:monitorErrorConditionsData[i].returnValue, Operator:monitorErrorConditionsData[i].conditionSymbol, AlramValue:monitorErrorConditionsData[i].conditionValue, MonitorType:monitorType, relation:monitorErrorConditionsData[i].conditionRelation});
		}
    for(var i = 0; i < monitorWarningConditionsData.length; i++) {
			newAlarmConditions.push({AlarmStatus:"warning", MonitorId:monitorId, ReturnValue:monitorWarningConditionsData[i].returnValue, Operator:monitorWarningConditionsData[i].conditionSymbol, AlramValue:monitorWarningConditionsData[i].conditionValue, MonitorType:monitorType, relation:monitorWarningConditionsData[i].conditionRelation});
		}
		for(var i = 0; i < monitorGoodConditionsData.length; i++) {
			newAlarmConditions.push({AlarmStatus:"good", MonitorId:monitorId, ReturnValue:monitorGoodConditionsData[i].returnValue, Operator:monitorGoodConditionsData[i].conditionSymbol, AlramValue:monitorGoodConditionsData[i].conditionValue, MonitorType:monitorType, relation:monitorGoodConditionsData[i].conditionRelation});
		}

    for(var i = 0; i < newAlarmConditions.length; i++) {
      oData.addMonitorAlarmCondition(newAlarmConditions[i],
        () => {
          addAlarmCount ++;
          if (addAlarmCount == newAlarmConditions.length) {
            callback && callback(true)
          }
        },
        () => {
          addAlarmCount ++;
          if (addAlarmCount == newAlarmConditions.length) {
            callback && callback(false)
          }
        }
      );
		}
  }
}

export function batchDeleteMonitorAlarmConditions(callback) {
	return (dispatch, getState) => {
		var state = getState();
		var deleteMonitorAlarmConditionsData = state.equipmentReducer.deleteMonitorAlarmConditionsData;
		for(var i = 0; i < deleteMonitorAlarmConditionsData.length; i++) {
      oData.deleteMonitorAlarmCondition(deleteMonitorAlarmConditionsData[i].RecId,
        () => { callback && callback() },
        () => { callback && callback() }
      );
		}
	}
}

export function getAlarmConditionDataFromMonitorId(monitorId, callback, monitorTypeParam) {
	return (dispatch, getState) => {
		dispatch(setMonitorErrorConditionsData([]));
		dispatch(setMonitorSettingErrorConditionsData([]));
		dispatch(setMonitorWarningConditionsData([]));
		dispatch(setMonitorSettingWarningConditionsData([]));
		dispatch(setMonitorGoodConditionsData([]));
		dispatch(setMonitorSettingGoodConditionsData([]));
		dispatch(requestDataActions.setRequest());
		// === 已切换到 OFBiz 新接口 /monitor/alarmConditions（按 monitorType）===
		// 旧接口 /bods.svc/Alarm 已下线；编辑场景从 state 取当前监测器的 monitorType，
		// 字段兼容新旧命名（saveItem/ReturnValue、alarmStatus/AlarmStatus、
		// operator/Operator、threshold/AlramValue）
		var selectedMonitor = getState().equipmentReducer.selectedMonitor || {};
		var monitorType = monitorTypeParam || selectedMonitor.monitorType || '';
		if (!monitorType) {
			dispatch(setGetAlarmConditionDataDoneFlag(true));
			dispatch(requestDataActions.setRequestFail());
			callback && callback();
			return;
		}
		ofbiz.getMonitorAlarmConditions(monitorType).then(listData => {
			var alarmConditionsData = getOfbizPageList(listData);
			if (!alarmConditionsData.length) {
				dispatch(setGetAlarmConditionDataDoneFlag(true));
				dispatch(requestDataActions.setRequestFail());
				callback && callback();
				return;
			}
			var monitorAlarmConditionNameData = getState().equipmentReducer.monitorAlarmConditionNameData;
			var errorAlarmConditionsData = [], warningAlarmConditionsData = [], goodAlarmConditionsData = []
			alarmConditionsData.forEach(_cond => {
				var saveItem = _cond.returnValue || _cond.saveItem || _cond.SaveReturnValue || _cond.ReturnValue || '';
				var alarmStatus = _cond.alarmStatus || _cond.AlarmStatus || _cond.status || '';
				var _alarmCondition = monitorAlarmConditionNameData.find(item => item.saveItem == saveItem);
				var alarmConditionName = _alarmCondition ? _alarmCondition.name : '';
				var _entry = {
					id: _cond.recId || _cond.RecId || '',
					conditionName: alarmConditionName,
					returnValue: saveItem,
					conditionSymbol: _cond.operator || _cond.Operator || _cond.Operators || '',
					conditionValue: _cond.threshold || _cond.AlramValue || _cond.alramValue || '',
					conditionRelation: _cond.relation || ''
				};
				if (alarmStatus == "error") {
					errorAlarmConditionsData.push(_entry);
				}
				else if (alarmStatus == "warning") {
					warningAlarmConditionsData.push(_entry);
				}
				else if (alarmStatus == "good") {
					goodAlarmConditionsData.push(_entry);
				}
			});
			dispatch(setMonitorErrorConditionsData(errorAlarmConditionsData));
			dispatch(setMonitorSettingErrorConditionsData(errorAlarmConditionsData));
			dispatch(setMonitorWarningConditionsData(warningAlarmConditionsData));
			dispatch(setMonitorSettingWarningConditionsData(warningAlarmConditionsData));
			dispatch(setMonitorGoodConditionsData(goodAlarmConditionsData));
			dispatch(setMonitorSettingGoodConditionsData(goodAlarmConditionsData));
			dispatch(setGetAlarmConditionDataDoneFlag(true));
			dispatch(requestDataActions.setRequestSuccess());
			callback && callback();
		}).catch(() => {
			dispatch(setGetAlarmConditionDataDoneFlag(true));
			dispatch(requestDataActions.setRequestFail());
			callback && callback();
		});
	}
}
//保存监测器属性-报警条件的值
export function saveMonitorAlarmConditions(monitorId, monitorType, callback) {
	return (dispatch, getState) => {
		var state = getState();
		var monitorErrorConditionsData = state.equipmentReducer.monitorErrorConditionsData;
		var monitorWarningConditionsData = state.equipmentReducer.monitorWarningConditionsData;
		var monitorGoodConditionsData = state.equipmentReducer.monitorGoodConditionsData;
		var deleteMonitorAlarmConditionsData = state.equipmentReducer.deleteMonitorAlarmConditionsData;

		var newAlarmConditions = [], updatedAlarmConditions = [];
		for(var i = 0; i < monitorErrorConditionsData.length; i++) {
			if(monitorErrorConditionsData[i].id == "") {
				newAlarmConditions.push({AlarmStatus:"error", MonitorId:monitorId, ReturnValue:monitorErrorConditionsData[i].returnValue, Operator:monitorErrorConditionsData[i].conditionSymbol, AlramValue:monitorErrorConditionsData[i].conditionValue, MonitorType:monitorType, relation:monitorErrorConditionsData[i].conditionRelation});
			}
			else {
				updatedAlarmConditions.push({RecId:monitorErrorConditionsData[i].id, AlarmStatus:"error", MonitorId:monitorId, ReturnValue:monitorErrorConditionsData[i].returnValue, Operator:monitorErrorConditionsData[i].conditionSymbol, AlramValue:monitorErrorConditionsData[i].conditionValue, MonitorType:monitorType, relation:monitorErrorConditionsData[i].conditionRelation});
			}
		}
		for(var i = 0; i < monitorWarningConditionsData.length; i++) {
			if(monitorWarningConditionsData[i].id == "") {
				newAlarmConditions.push({AlarmStatus:"warning", MonitorId:monitorId, ReturnValue:monitorWarningConditionsData[i].returnValue, Operator:monitorWarningConditionsData[i].conditionSymbol, AlramValue:monitorWarningConditionsData[i].conditionValue, MonitorType:monitorType, relation:monitorWarningConditionsData[i].conditionRelation});
			}
			else {
				updatedAlarmConditions.push({RecId:monitorWarningConditionsData[i].id, AlarmStatus:"warning", MonitorId:monitorId, ReturnValue:monitorWarningConditionsData[i].returnValue, Operator:monitorWarningConditionsData[i].conditionSymbol, AlramValue:monitorWarningConditionsData[i].conditionValue, MonitorType:monitorType, relation:monitorWarningConditionsData[i].conditionRelation});
			}
		}
		for(var i = 0; i < monitorGoodConditionsData.length; i++) {
			if(monitorGoodConditionsData[i].id == "") {
				newAlarmConditions.push({AlarmStatus:"good", MonitorId:monitorId, ReturnValue:monitorGoodConditionsData[i].returnValue, Operator:monitorGoodConditionsData[i].conditionSymbol, AlramValue:monitorGoodConditionsData[i].conditionValue, MonitorType:monitorType, relation:monitorGoodConditionsData[i].conditionRelation});
			}
			else {
				updatedAlarmConditions.push({RecId:monitorGoodConditionsData[i].id, AlarmStatus:"good", MonitorId:monitorId, ReturnValue:monitorGoodConditionsData[i].returnValue, Operator:monitorGoodConditionsData[i].conditionSymbol, AlramValue:monitorGoodConditionsData[i].conditionValue, MonitorType:monitorType, relation:monitorGoodConditionsData[i].conditionRelation});
			}
		}

    const total = deleteMonitorAlarmConditionsData.length + newAlarmConditions.length + updatedAlarmConditions.length;
    let count = 0, failCount = 0;
		for(var i = 0; i < deleteMonitorAlarmConditionsData.length; i++) {
      oData.deleteMonitorAlarmCondition(deleteMonitorAlarmConditionsData[i].id,
        () => {
          count ++;
          if (count == total) {
            callback && callback(!failCount);
          }
        },
        () => {
          count ++;
          failCount ++;
          if (count == total) {
            callback && callback(!failCount);
          }
        }
      );
		}
		for(var i = 0; i < newAlarmConditions.length; i++) {
      oData.addMonitorAlarmCondition(newAlarmConditions[i],
        () => {
          count ++;
          if (count == total) {
            callback && callback(!failCount);
          }
        },
        () => {
          count ++;
          failCount ++;
          if (count == total) {
            callback && callback(!failCount);
          }
        }
      );
		}
		for(var i = 0; i < updatedAlarmConditions.length; i++) {
      oData.updateMonitorAlarmCondition(updatedAlarmConditions[i],
        () => {
          count ++;
          if (count == total) {
            callback && callback(!failCount);
          }
        },
        () => {
          count ++;
          failCount ++;
          if (count == total) {
            callback && callback(!failCount);
          }
        }
      );
		}
	}
}

export function deleteMonitorAlarmConditions() {
	return (dispatch, getState) => {
		var state = getState();
		var monitorErrorConditionsData = state.equipmentReducer.monitorErrorConditionsData;
		var monitorWarningConditionsData = state.equipmentReducer.monitorWarningConditionsData;
		var monitorGoodConditionsData = state.equipmentReducer.monitorGoodConditionsData;
		var deleteAlarmConditionIds = [];
		for(var i = 0; i < monitorErrorConditionsData.length; i++) {
			deleteAlarmConditionIds.push({RecId:monitorErrorConditionsData[i].id});
		}
		for(var i = 0; i < monitorWarningConditionsData.length; i++) {
			deleteAlarmConditionIds.push({RecId:monitorWarningConditionsData[i].id});
		}
		for(var i = 0; i < monitorGoodConditionsData.length; i++) {
			deleteAlarmConditionIds.push({RecId:monitorGoodConditionsData[i].id});
		}

		for(var i = 0; i < deleteAlarmConditionIds.length; i++) {
			dispatch(requestDataActions.setRequest());
			// oData.deleteMonitorAlarmCondition({
      //     data: deleteAlarmConditionIds[i],
      //     callback: function(resp){
      //         dispatch(requestDataActions.setRequestSuccess());
      //     },
      //     error: function(resp){
      //         dispatch(requestDataActions.setRequestFail());
      //     }
      // });
      oData.deleteMonitorAlarmCondition(deleteAlarmConditionIds[i].id,
        () => { dispatch(requestDataActions.setRequestSuccess()); },
        () => { dispatch(requestDataActions.setRequestFail()); }
      );
		}
	}
}

// export function getMonitorDisk(param) {
//   return (dispatch, getState) => {
//     var state = getState();
//     var filter = [{key:"EquipmentId", value:param.equipmentId}];
//     dispatch(setMonitorDisks([]));
//     dispatch(requestDataActions.setRequest());
//     oData.getMonitorDisk(filter, function(data){
//         if(data.results.length == 0){
//           if (param && param.callback) param.callback();
//           dispatch(requestDataActions.setRequestFail());
//           return;
//         }
//         //通过eval() 函数可以将JSON字符串转化为对象
//         var dataObj = eval(data.results[0]);
//         var diskNames = dataObj.DiskName;
//         var diskIds = dataObj.DiskID;
//         var hasDiskNames = dataObj.HasDiskName;
//         diskNames = eval("(" + diskNames + ")");
//         diskIds = eval("(" + diskIds + ")");
//         hasDiskNames = eval("(" + hasDiskNames + ")");
//
//         var monitorDisks = [], hasDisks = [];
//         for(var i = 0; i < diskNames.length; i++) {
//           if(diskIds.length == diskNames.length) {
//             monitorDisks.push({name:diskNames[i], oid:diskIds[i]});
//           }
//           else {
//             monitorDisks.push({name:diskNames[i], oid:""});
//           }
//         }
//         if(!hasDiskNames.length == 0){
//           for(var i=0;i<hasDiskNames.length;i++) {
//             if(hasDiskNames[i].indexOf("diskName=")>=0){
//               hasDisks.push(hasDiskNames[i].substring(9));
//             }else{
//               hasDisks.push(hasDiskNames[i]);
//             }
//           }
//         }
//         //按磁盘名排序
//         monitorDisks.sort(function(a,b){
//             return a.name>b.name ? 1 : -1;
//         });
//         dispatch(setMonitorDisks(monitorDisks));
//         dispatch(setMonitorHasDisks(hasDisks));
//         state = getState();
//         if(param && param.callback) param.callback({
//           monitorDisks: state.equipmentReducer.monitorDisks,
//           monitorHasDisks: state.equipmentReducer.monitorHasDisks
//         });
//         dispatch(requestDataActions.setRequestSuccess());
//     }, function(){
//       if (param && param.callback) param.callback();
//     });
//   }
// }

export function getMonitorDiskInodes1(param) {
  return (dispatch, getState) => {
    var state = getState();
    var filter = [{key:"EQUIPMENT_ID", value:param.equipmentId}];
    dispatch(setMonitorDiskInodes([]));
    dispatch(requestDataActions.setRequest());
    oData.getMonitorDiskInodes(filter, function(data){
      if(data.results.length == 0){
        if (param && param.callback) param.callback();
        dispatch(requestDataActions.setRequestFail());
        return;
      }
      //通过eval() 函数可以将JSON字符串转化为对象
      var dataObj = eval(data.results[0]);
      var diskNames = dataObj.DISK_INODES_NAME;
      var hasResults = [];
      var hasDiskInodes = dataObj.HAS_DISK_INODES_NAME;
      diskNames = eval("(" + diskNames + ")");
      hasDiskInodes = eval("(" + hasDiskInodes + ")");
      var monitorDisks = [], hasDisks = [];
      if(diskNames.length ==0) {
        dispatch(requestDataActions.setRequestFail());
        return;
      }else{
        for(var i = 0; i < diskNames.length; i++) {
          monitorDisks.push({name:diskNames[i]});
        }
      }

      if(!hasDiskInodes.length == 0){
        for(var i in hasDiskInodes) {
          hasResults.push(hasDiskInodes[i]);
        }
      }
      //按磁盘名排序
      monitorDisks.sort(function(a,b){
          return a.name>b.name ? 1 : -1;
      });
      dispatch(setMonitorDiskInodes(monitorDisks));
      dispatch(setMonitorHasDiskInodes(hasResults));
      state = getState();
      if(param && param.callback) param.callback({
        monitorDiskInodes: state.equipmentReducer.monitorDiskInodes,
        monitorHasDiskInodes: state.equipmentReducer.monitorHasDiskInodes
      });
      dispatch(requestDataActions.setRequestSuccess());
    }, function(){
      if (param && param.callback) param.callback();
    });
  }
}

export function getMonitorDiskIONames1(param) {
  return (dispatch, getState) => {
    var state = getState();
        var filter = [{key:"EQUIPMENT_ID", value:param.equipmentId}];
        dispatch(setMonitorDiskIONames([]));
        dispatch(requestDataActions.setRequest());
        oData.getMonitorDiskIONames(filter, function(data){
          if(data.results.length == 0){
            if (param && param.callback) param.callback();
            dispatch(requestDataActions.setRequestFail());
            return;
          }
          //通过eval() 函数可以将JSON字符串转化为对象
          var dataObj = eval(data.results[0]);
          var diskIOName = eval("(" + dataObj.DISK_IO_NAME + ")");

          var monitorDisks = [];
          for(var i = 0; i < diskIOName.length; i++) {
            monitorDisks.push({name:diskIOName[i]});
          }
          //按磁盘名排序
          monitorDisks.sort(function(a,b){
              return a.name>b.name ? 1 : -1;
          });
          var hasResults = [];
          var hasDiskIONames = dataObj.HAS_DISK_IO_NAME;
          hasDiskIONames = eval("(" + hasDiskIONames + ")");
          if(!hasDiskIONames.length == 0){
            for(var i in hasDiskIONames) {
              hasResults.push(hasDiskIONames[i]);
            }
          }
          dispatch(setMonitorDiskIONames(monitorDisks));
          dispatch(setMonitorHasDiskIONames(hasResults));
          state = getState();
          if(param && param.callback) param.callback({
            monitorDiskIONames: state.equipmentReducer.monitorDiskIONames,
            monitorHasDiskIONames: state.equipmentReducer.monitorHasDiskIONames
          });
          dispatch(requestDataActions.setRequestSuccess());
        }, function(){
          if (param && param.callback) param.callback();
        });
    };
}

export function getNetWork1(param) {
  return (dispatch, getState) => {
    var state = getState();
        var filter = [{key:"EQUIPMENT_ID", value:param.equipmentId}];
        dispatch(setNetWorks([]));
        dispatch(requestDataActions.setRequest());
        oData.getNetWork(filter, function(data){
          if(data.results.length == 0){
            if (param && param.callback) param.callback();
            dispatch(requestDataActions.setRequestFail());
            return;
          }
          //通过eval() 函数可以将JSON字符串转化为对象
          var dataObj = eval(data.results[0]);
          var network = eval("(" + dataObj.NETWORK + ")");
          var results = [];
          for(var i = 0; i < network.length; i++) {
            results.push({name:network[i]});
          }
          var hasResults = [];
          var hasNetworks = dataObj.HAS_NETWORK;
          hasNetworks = eval("(" + hasNetworks + ")");
          if(!hasNetworks.length == 0){
            for(var i in hasNetworks) {
              hasResults.push(hasNetworks[i]);
            }
          }
          dispatch(setNetWorks(results));
          dispatch(setHasNetWorks(hasResults));
          state = getState();
          if(param && param.callback) param.callback({
            networks: state.equipmentReducer.networks,
            hasNetworks: state.equipmentReducer.hasNetworks
          });
          dispatch(requestDataActions.setRequestSuccess());
        }, function(){
          if (param && param.callback) param.callback();
        });
    };
}

export function getMonitorProcess1(param) {
  return (dispatch, getState) => {
    var state = getState();
    var filter = [{key:"EquipmentId", value:param.equipmentId}];
    var equipmentType = param.equipmentType;
    dispatch(setMonitorProcesses([]));
    dispatch(requestDataActions.setRequest());
    oData.getMonitorProcess(filter, function(data){
      if(data.results.length == 0){
        if (param && param.callback) param.callback();
        dispatch(requestDataActions.setRequestFail());
        return;
      }
      //通过eval() 函数可以将JSON字符串转化为对象
      var dataObj = eval(data.results[0]);
      var processNames = dataObj.ProcessName;
      var processIds = dataObj.ProcessID;
      var processParam = dataObj.ProcessParameters;
      processNames = eval("(" + processNames + ")");
      processIds = eval("(" + processIds + ")");
      processParam = eval("(" + processParam + ")");
      var monitorProcesses = [];
      for(var i = 0; i < processNames.length; i++) {
          if(processIds.length == processNames.length) {
            if(equipmentType == "Equipment.SNMPUnix" || equipmentType == "Equipment.SNMPWindows") {
              monitorProcesses.push({name:processNames[i], oid:processIds[i].substring(processIds[i].lastIndexOf(".")+1), processParam: processParam[i]});
            }else {
              monitorProcesses.push({name:processNames[i], oid:processIds[i]});
            }
          }else {
            monitorProcesses.push({name:processNames[i], oid:""});
          }
      }
      //按oid排序
      monitorProcesses.sort(function(a,b){
        return a.oid>b.oid ? 1 : -1;
      });
      var filteredMonitorProcesses = [], isRepeated;
      for (var i = 0; i < monitorProcesses.length; i++) {
        isRepeated = false;
        for (var j = 0; j < filteredMonitorProcesses.length; j++) {
          if (monitorProcesses[i].name == filteredMonitorProcesses[j].name) {
            isRepeated = true;
            break;
          }
        }
        if (!isRepeated) {
          filteredMonitorProcesses.push(monitorProcesses[i]);
        }
      }
      var hasResults = [];
      var hasProcessName = dataObj.HasProcessName;
      hasProcessName = eval("(" + hasProcessName + ")");
      for(var i in hasProcessName){
        hasResults.push(hasProcessName[i]);
      }
      dispatch(setMonitorProcesses(filteredMonitorProcesses));
      dispatch(setMonitorHasProcesses(hasResults));
      state = getState();
      if(param && param.callback) param.callback({
        monitorProcesses: state.equipmentReducer.monitorProcesses,
        monitorHasProcesses: state.equipmentReducer.monitorHasProcesses
      });
      dispatch(requestDataActions.setRequestSuccess());
    }, function(){
      if (param && param.callback) param.callback();
    });
  }
}

//以下是 createMonitorView_SnmpNWBandwidth 的网络接口
export function getMonitorNetWork1(param) {
  return (dispatch, getState) => {
    var state = getState();
    var filter = [{key:"EquipmentId", value: param.equipmentId},{key:"MonitorType", value: param.monitorType}];
    var equipmentType = param.equipmentType;
    dispatch(setMonitorNetworks([]));
    dispatch(requestDataActions.setRequest());
    oData.getMonitorNetWork(filter, function(data){
      if(data.results.length == 0){
        if (param && param.callback) param.callback();
        dispatch(requestDataActions.setRequestFail());
        return;
      }
      //通过eval() 函数可以将JSON字符串转化为对象
      var dataObj = eval(data.results[0]);
      var networkNames = dataObj.NetWorkName;
      var networkIds = dataObj.NetWorkID;
      var networkStatus = dataObj.NetWorkStatus;
      networkNames = eval("(" + networkNames + ")");
      networkIds = eval("(" + networkIds + ")");
      networkStatus = eval("(" + networkStatus + ")");
      var monitorNetworks = [];
      for(var i = 0; i < networkNames.length; i++) {
        if (networkNames[i]) {
          if(networkIds.length == networkNames.length && networkStatus.length == networkNames.length) {
              if(equipmentType == "Equipment.SNMPUnix" || equipmentType == "Equipment.SNMPWindows" || equipmentType == "Equipment.Network") {
                  monitorNetworks.push({name:networkNames[i], oid:networkIds[i].substring(networkIds[i].lastIndexOf(".")+1), status:networkStatus[i]});
              }
              else {
                  monitorNetworks.push({name:networkNames[i], oid:networkIds[i], status:networkStatus[i]});
              }
          }
          else {
              monitorNetworks.push({name:networkNames[i], oid:"", status:""});
          }
        }
      }
      //按网卡名排序
      // monitorNetworks.sort(function(a,b){
      //     return a.name>b.name ? 1 : -1;
      // });
      dispatch(setMonitorNetworks(monitorNetworks));
      state = getState();
      if(param && param.callback) param.callback({
        monitorNetworks: state.equipmentReducer.monitorNetworks
      });
      dispatch(requestDataActions.setRequestSuccess());
    }, function(){
      if (param && param.callback) param.callback();
    });
  }
}

export function getMonitorScripts1(filt) {
    return dispatch => {
        var filter = [{key:"EQUIPMENT_ID", value:filt.equipmentId},{key:"FILE_PATH",value:filt.scriptPath}];
        dispatch(setMonitorScripts([]));
        dispatch(requestDataActions.setRequest());
        oData.getMonitorScripts(filter,function(data){
            var results = data.results[0].SCRIPT_NAME;
            if(results){
              results = eval(results);
              var dataresult=[];
              for (var i = 0; i < results.length; i++) {
                var value={
                  SCRIPT_NAME:results[i]
                }
                dataresult.push(value);
              }
              dispatch(setMonitorScripts(dataresult));
            };
            dispatch(requestDataActions.setRequestSuccess());
        })
    }
}

export function getMonitorServiceNames1(param) {
  return (dispatch, getState) => {
    var state = getState();
    var filter = [{key:"EQUIPMENT_ID", value:param.equipmentId}];
    dispatch(setMonitorServices([]));
    dispatch(requestDataActions.setRequest());
    oData.getMonitorServiceNames(filter, function(data){
        if(data.results.length == 0){
          if (param && param.callback) param.callback();
          dispatch(requestDataActions.setRequestFail());
          return;
        }
        //通过eval() 函数可以将JSON字符串转化为对象
        var dataObj = eval(data.results[0]);
        var serviceNames = eval("(" + dataObj.SERVICE_NAME + ")");
        var results = [];
        for(var i = 0; i < serviceNames.length; i++) {
          results.push({SERVICE_NAME:serviceNames[i]});
        }

        //按服务名排序
        results.sort(function(a,b){
            return a.SERVICE_NAME>b.SERVICE_NAME ? 1 : -1;
        });
        var hasResults = [];
        var hasServiceNames = dataObj.HAS_SERVICE_NAME;
        hasServiceNames = eval("(" + hasServiceNames + ")");
        if(!hasServiceNames.length == 0){
          for(var i in hasServiceNames) {
            hasResults.push(hasServiceNames[i]);
          }
        }
        dispatch(setMonitorServices(results));
        dispatch(setMonitorHasServices(hasResults));
        state = getState();
        if(param && param.callback) param.callback({
          monitorServices: state.equipmentReducer.monitorServices,
          monitorHasServices: state.equipmentReducer.monitorHasServices
        });
        dispatch(requestDataActions.setRequestSuccess());
    }, function(){
      if (param && param.callback) param.callback();
    });
  }
}

export function getMonitorNTEventLog(equipmentId) {
    return dispatch => {
        var filter = [{key:"EQUIPMENT_ID", value:equipmentId}];
        dispatch(setMonitorNTEventLogs([]));
        dispatch(requestDataActions.setRequest());
        oData.getMonitorNTEventLog(filter, function(data){
            if(data.results.length == 0){
                // _this.emit("change");
                dispatch(requestDataActions.setRequestFail());
                return;
            }
            //通过eval() 函数可以将JSON字符串转化为对象
            var dataObj = eval(data.results[0]);
            var eventNames = dataObj.EVENT_NAME;
            eventNames = eval("(" + eventNames + ")");
            //按服务名排序
            eventNames.sort(function(a,b){
                return a>b ? 1 : -1;
            });
            var NTEventLogs = [];
            for(var i = 0; i < eventNames.length; i++) {
                NTEventLogs.push({EVENT_NAME: eventNames[i]});
            }
            dispatch(setMonitorNTEventLogs(NTEventLogs));
            dispatch(requestDataActions.setRequestSuccess());
        });
    }
}

// 获取磁盘名称列表
export function getMonitorDisk(param, callback, notSetReduxState) {
	return dispatch => {
    if (!notSetReduxState) {
      dispatch(setMonitorDisks([]));
      dispatch(setMonitorHasDisks([]));
    }
		ServerEquipment.getDiskspaceNamesList(param.equipmentId, function(data){
      // console.log(data);
      if (data.names) {
        var diskNames = data.names;
        var filterNames = data.filternames;
        var monitorDisks = [], hasDisks = [];
        for (var i = 0; i < diskNames.length; i++) {
          if (typeof diskNames[i] == 'object') {
            monitorDisks.push({name: diskNames[i].DISK_NAME, oid: diskNames[i].OID});
          } else {
            monitorDisks.push({name: diskNames[i], oid: ""});
          }
        }
        for (var i = 0; i < filterNames.length; i++) {
          if(filterNames[i].indexOf("diskName=") >= 0){
            hasDisks.push(filterNames[i].substring(9));
          } else {
            hasDisks.push(filterNames[i]);
          }
        }
        // 按磁盘名排序
        monitorDisks.sort(function(a,b){
            return a.name > b.name ? 1 : -1;
        });
        if (!notSetReduxState) {
          dispatch(setMonitorDisks(monitorDisks));
          dispatch(setMonitorHasDisks(hasDisks));
        }
        param.callback && param.callback(true, monitorDisks, hasDisks);
      } else {
        param.callback && param.callback(false, [], []);
      }
		}, (res) => {
      if (res.errmsg !== 'token invalid.' && !res.errmsg) {
        res.errmsg = "获取磁盘列表失败。";
      }
      Util.showInterfaceErrorInfo(res);
      param.callback && param.callback();
    });
	}
}

// 获取磁盘索引名称列表
export function getMonitorDiskInodes(param, callback) {
	return dispatch => {
    dispatch(setMonitorDiskInodes([]));
    dispatch(setMonitorHasDiskInodes([]));
		ServerEquipment.getDisksNodesNamesList(param.equipmentId, function(data){
      // console.log(data);
      var names = data.names;
      var filternames = data.filternames;
      var monitorDisks = [], hasDisks = [];
      for (var i = 0; i < names.length; i++) {
        monitorDisks.push({name: names[i]});
      }
      //按磁盘名排序
      monitorDisks.sort(function(a,b){
          return a.name > b.name ? 1 : -1;
      });
      dispatch(setMonitorDiskInodes(monitorDisks));
      dispatch(setMonitorHasDiskInodes(filternames));
      param.callback && param.callback(true);
		}, (res) => {
      if (res.errmsg !== 'token invalid.' && !res.errmsg) {
        res.errmsg = "获取磁盘索引列表失败。";
      }
      Util.showInterfaceErrorInfo(res);
      param.callback && param.callback();
    });
	}
}

// 获取磁盘IO名称列表
export function getMonitorDiskIONames(param, callback) {
	return dispatch => {
    dispatch(setMonitorDiskIONames([]));
    dispatch(setMonitorHasDiskIONames([]));
		ServerEquipment.getDisksIONamesList(param.equipmentId, function(data){
      // console.log(data);
      var names = data.names;
      var filternames = data.filternames;
      var monitorDisks = [], hasDisks = [];
      for (var i = 0; i < names.length; i++) {
        monitorDisks.push({name: names[i]});
      }
      //按磁盘名排序
      monitorDisks.sort(function(a,b){
          return a.name > b.name ? 1 : -1;
      });
      dispatch(setMonitorDiskIONames(monitorDisks));
      dispatch(setMonitorHasDiskIONames(filternames));
      param.callback && param.callback(true);
		}, (res) => {
      if (res.errmsg !== 'token invalid.' && !res.errmsg) {
        res.errmsg = "获取磁盘IO列表失败。";
      }
      Util.showInterfaceErrorInfo(res);
      param.callback && param.callback();
    });
	}
}

// 获取硬盘名称列表
export function getMonitorHardDiskNames(param, callback) {
	return dispatch => {
    dispatch(setMonitorDiskInodes([]));
    dispatch(setMonitorHasDiskInodes([]));
    var filter = { equipmentid: param.equipmentId, monitortype: param.monitorType };
		ServerEquipment.getHardDiskNamesList(filter, function(data){
      // console.log(data);
      var names = data.names;
      var filternames = data.filternames;
      var monitorDisks = [], hasDisks = [];
      for (var i = 0; i < names.length; i++) {
        monitorDisks.push({name: names[i]});
      }
      //按磁盘名排序
      monitorDisks.sort(function(a,b){
          return a.name > b.name ? 1 : -1;
      });
      dispatch(setMonitorDiskInodes(monitorDisks));
      dispatch(setMonitorHasDiskInodes(filternames));
      param.callback && param.callback(true);
		}, (res) => {
      if (res.errmsg !== 'token invalid.' && !res.errmsg) {
        res.errmsg = "获取硬盘列表失败。";
      }
      Util.showInterfaceErrorInfo(res);
      param.callback && param.callback();
    });
	}
}

// 获取进程列表
export function getMonitorProcess(param, callback, notSetReduxState) {
	return dispatch => {
    if (!notSetReduxState) {
      dispatch(setMonitorProcesses([]));
      dispatch(setMonitorHasProcesses([]));
    }
		ServerEquipment.getProcessNamesList(param.equipmentId, function(data){
      // console.log(data);
      var names = data.names;
      var filternames = data.filternames;
      var monitorProcesses = [], hasMonitorProcesses = [];
      var _processNames = [];
      // 设置列表数据，及去重
      for (var i = 0; i < names.length; i++) {
        var _obj = {};
        if (typeof names[i] == 'object') {
          _obj = {name: names[i].PROCESS_NAME, oid: names[i].OID, processParam: names[i].DES};
        } else {
          _obj = {name: names[i], oid: ""};
        }
        if (_processNames.indexOf(_obj.name) == -1) {
          monitorProcesses.push(_obj);
          _processNames.push(_obj.name);
        }
      }
      for (var i = 0; i < filternames.length; i++) {
        hasMonitorProcesses.push(filternames[i]);
      }
      if (!notSetReduxState) {
        dispatch(setMonitorProcesses(monitorProcesses));
        dispatch(setMonitorHasProcesses(hasMonitorProcesses));
      }
      param.callback && param.callback(true, monitorProcesses, hasMonitorProcesses);
		}, (res) => {
      if (res.errmsg !== 'token invalid.' && !res.errmsg) {
        res.errmsg = "获取进程列表失败。";
      }
      Util.showInterfaceErrorInfo(res);
      param.callback && param.callback();
    });
	}
}

// 获取网卡列表
export function getNetWork(param, callback) {
	return dispatch => {
    dispatch(setNetWorks([]));
    dispatch(setHasNetWorks([]));
    var filter = { equipmentid: param.equipmentId, monitortype: param.monitorType };
    var equipmentType = param.equipmentType;
		ServerEquipment.getNetworkNamesList(filter, function(data){
      // console.log(data);
      var names = data.names;
      var filternames = data.filternames;
      var monitorNetworks = [], hasMonitorNetworks = [];
      // 设置列表数据
      for (var i = 0; i < names.length; i++) {
        if (typeof names[i] == 'object') {
          // OFBiz discover 接口：SNMP 通道 names 元素含 DISK_NAME/OID/TYPE_NAME/SPEED_NAME/
          // OPER_STATUS_NAME/ADMIN_STATUS_NAME/ALIAS；保留老 INTERFACE_NAME/STATUS 兼容
          monitorNetworks.push({
            name: names[i].INTERFACE_NAME || names[i].DISK_NAME,
            oid: names[i].OID,
            status: names[i].STATUS || names[i].OPER_STATUS_NAME,
            typeName: names[i].TYPE_NAME || '',
            speedName: names[i].SPEED_NAME || '',
            statusName: names[i].OPER_STATUS_NAME || '',
            adminName: names[i].ADMIN_STATUS_NAME || '',
            alias: names[i].ALIAS || '',
          });
        } else {
          monitorNetworks.push({name: names[i], oid: "", status: "", typeName: '', speedName: '', statusName: '', adminName: '', alias: ''});
        }
      }
      for (var i = 0; i < filternames.length; i++) {
        hasMonitorNetworks.push(filternames[i]);
      }
      dispatch(setNetWorks(monitorNetworks));
      dispatch(setHasNetWorks(hasMonitorNetworks));
      param.callback && param.callback(true);
		}, (res) => {
      if (res.errmsg !== 'token invalid.' && !res.errmsg) {
        res.errmsg = "获取网卡列表失败。";
      }
      Util.showInterfaceErrorInfo(res);
      param.callback && param.callback();
    });
	}
}

// 获取服务列表
export function getMonitorServiceNames(param, callback) {
	return dispatch => {
    dispatch(setMonitorServices([]));
    dispatch(setMonitorHasServices([]));
    var filter = { equipmentid: param.equipmentId };
		ServerEquipment.getServiceNamesList(filter, function(data){
      // console.log(data);
      var names = data.names;
      var filternames = data.filternames;
      var results = [], hasResults = [];
      // 设置列表数据
      for (var i = 0; i < names.length; i++) {
        results.push({name: names[i]});
      }
      //按服务名排序
      results.sort(function(a, b) {
        return a.name > b.name ? 1 : -1;
      });
      for (var i = 0; i < filternames.length; i++) {
        hasResults.push(filternames[i]);
      }
      dispatch(setMonitorServices(results));
      dispatch(setMonitorHasServices(hasResults));
      param.callback && param.callback(true);
		}, (res) => {
      if (res.errmsg !== 'token invalid.' && !res.errmsg) {
        res.errmsg = "获取服务列表失败。";
      }
      Util.showInterfaceErrorInfo(res);
      param.callback && param.callback();
    });
	}
}

// 获取脚本列表
export function getMonitorScripts(param, callback) {
	return dispatch => {
    dispatch(setMonitorScripts([]));
    var filter = { equipmentid: param.equipmentId, path: param.scriptPath || '' };
		ServerEquipment.getScriptNamesList(filter, function(data){
      // console.log(data);
      var names = data.names;
      var filternames = data.filternames;
      var results = [], hasResults = [];
      // 设置列表数据
      for (var i = 0; i < names.length; i++) {
        results.push(names[i]);
      }
      dispatch(setMonitorScripts(results));
      callback && callback(results);
		}, (res) => {
      if (res.errmsg !== 'token invalid.' && !res.errmsg) {
        res.errmsg = "获取脚本列表失败。";
      }
      Util.showInterfaceErrorInfo(res);
      callback && callback();
    });
	}
}

// 获取脚本具体内容
export function getMonitorScriptInfo(param, callback) {
	return dispatch => {
    var filter = { equipmentid: param.equipmentId, path: param.scriptPath || '' };
		ServerEquipment.getScriptInfo(filter, function(data){
      callback && callback(data);
		}, (res) => {
      if (res.errmsg !== 'token invalid.' && !res.errmsg) {
        res.errmsg = "获取脚本失败。";
      }
      Util.showInterfaceErrorInfo(res);
      callback && callback();
    });
	}
}

// 获取网卡列表，包含SnmpNWBandwidth，SnmpGigabitInterface
export function getMonitorNetWork(param, callback, notSetReduxState) {
	return dispatch => {
    if (!notSetReduxState) {
      dispatch(setMonitorNetworks([]));
      dispatch(setMonitorHasNetworks([]));
    }
    var filter = { equipmentid: param.equipmentId, monitortype: param.monitorType };
    var equipmentType = param.equipmentType;
		ServerEquipment.getNetworkNamesList(filter, function(data){
      // console.log(data);
      var names = data.names;
      var filternames = data.filternames;
      var monitorNetworks = [], hasMonitorNetworks = [];
      // 设置列表数据
      for (var i = 0; i < names.length; i++) {
        if (typeof names[i] == 'object') {
          // OFBiz discover 接口：SNMP 通道 names 元素含 DISK_NAME/OID/TYPE_NAME/SPEED_NAME/
          // OPER_STATUS_NAME/ADMIN_STATUS_NAME/ALIAS；保留老 INTERFACE_NAME/STATUS 兼容
          monitorNetworks.push({
            name: names[i].INTERFACE_NAME || names[i].DISK_NAME,
            oid: names[i].OID,
            status: names[i].STATUS || names[i].OPER_STATUS_NAME,
            typeName: names[i].TYPE_NAME || '',
            speedName: names[i].SPEED_NAME || '',
            statusName: names[i].OPER_STATUS_NAME || '',
            adminName: names[i].ADMIN_STATUS_NAME || '',
            alias: names[i].ALIAS || '',
          });
        } else {
          monitorNetworks.push({name: names[i], oid: "", status: "", typeName: '', speedName: '', statusName: '', adminName: '', alias: ''});
        }
      }
      for (var i = 0; i < filternames.length; i++) {
        hasMonitorNetworks.push(filternames[i]);
      }
      if (!notSetReduxState) {
        dispatch(setMonitorNetworks(monitorNetworks));
        dispatch(setMonitorHasNetworks(hasMonitorNetworks));
      }
      param.callback && param.callback(true, monitorNetworks, hasMonitorNetworks);
		}, (res) => {
      if (res.errmsg !== 'token invalid.' && !res.errmsg) {
        res.errmsg = `获取${param.monitorType == 'SnmpGigabitInterface' ? '接口' : '网卡'}列表失败。`;
      }
      Util.showInterfaceErrorInfo(res);
      param.callback && param.callback();
    });
	}
}

// 获取虚拟机 网卡列表，存储列表，计数器列表
export function getVMwareNames(param, callback) {
	return dispatch => {
    dispatch(setVMwareNames([]));
    dispatch(setHasVMwareNames([]));
    var filter = { equipmentid: param.equipmentId, monitortype: param.monitorType };
    var equipmentType = param.equipmentType;
		ServerEquipment.getVMwareNamesList(filter, function(data){
      var names = data.names;
      var filternames = data.filternames;
      // 设置列表数据
      var vmwareNames = [];
      if (param.monitorType == 'VirtualMachineList') {
        var _names = names.map(item => {
          return { name: item, type: data.nametype }  // nametype
        });
        var _clusternames = [];
        if (data.clusternames && data.clusternames.length) {
          _clusternames = data.clusternames.map(item => {
            return { name: item, type: data.clusternamestype } // clusternamestype
          });
        }
        vmwareNames = _names.concat(_clusternames)
      } else {
        vmwareNames = names.map(item => {
          return { name: item }
        })
      }
      //按名称排序
      vmwareNames.sort(function(a, b) {
        return a.name > b.name ? 1 : -1;
      });
      dispatch(setVMwareNames(vmwareNames));
      dispatch(setHasVMwareNames(filternames));
      param.callback && param.callback(true);
		}, (res) => {
      var _label = '';
      if (param.monitorType == 'VirtualMachineList') {
        _label = '虚拟机';
      } else if (param.monitorType == 'VMwareDatastore') {
        _label = '存储';
      } else if (param.monitorType == 'VMwareHostNetwork') {
        _label = '网卡';
      }
      if (res.errmsg !== 'token invalid.' && !res.errmsg) {
        res.errmsg = "获取" + _label + "列表失败。";
      }
      Util.showInterfaceErrorInfo(res);
      param.callback && param.callback();
    });
	}
}

//获取监测器属性数据
export function getMonitorsPropertyDataFromID(filter) {
	return dispatch => {
		dispatch(setMonitorsPropertyData(null));
		dispatch(requestDataActions.setRequest());
    var monitorId = filter.monitorId;
    var monitorType = filter.monitorType;
    // === 已切换到 OFBiz 新接口 /monitor/getById ===
    ofbiz.getMonitorById(monitorId).then(detail => {
        if(!detail){
          dispatch(setGetMonitorsPropertyDataDoneFlag(true));
          dispatch(requestDataActions.setRequestFail());
          return;
        }
        // 适配旧扁平 PascalCase 结构（attributes → 扁平字段）
        var attrs = detail.attributes || {};
        // 兼容 SpecialProperties 中的 key=value 字符串（老代码可能从中提取 port、hostname 等填表单）
        var specialProps = attrs.SPECIAL_PROPS || detail.specialProperties || '';
        var legacyData = {
          RecId: detail.monitorId || detail.fixedAssetId,
          Title: detail.fixedAssetName || detail.monitorName,
          MonitorType: attrs.MONITOR_TYPE || detail.monitorType,
          ServerAddress: attrs.TARGET_HOST || detail.targetHost,
          // action 提交侧用 Port（大写P），但表单 BasicSpecialPropertiesForm 渲染端口号字段名是 port（小写）
          Port: attrs.TARGET_PORT,
          port: attrs.TARGET_PORT,
          // basicInfo 表单字段叫 RefreshTime、RefreshUnit；action 提交侧用 MonitorRefresh
          MonitorRefresh: attrs.REFRESH_TIME,
          RefreshTime: attrs.REFRESH_TIME,
          RefreshUnit: attrs.REFRESH_UNIT,
          MonitorTimeOut: attrs.TIMEOUT,
          SpecialProps: specialProps,
          SpecialProperties: specialProps,
          WarnThreshold: attrs.WARN_THRESHOLD,
          ErrorThreshold: attrs.ERROR_THRESHOLD,
          ThresholdOp: attrs.THRESHOLD_OP,
          MonitorStatus: detail.monitorStatus || attrs.MONITOR_STATUS,
          IsDisabled: attrs.IS_DISABLED,
          IsDisable: attrs.IS_DISABLED,
          // 计数器监测器（Mysql）勾选的计数器，update 时未重新勾选则透传该值避免被清空
          SaveNames: attrs.SAVE_NAMES || detail.saveNames || '',
        };
        dispatch(setMonitorsPropertyData(legacyData));
        if(monitorType == "Mysql"){
          dispatch(getMySqlMonitorPropertyCounterData(monitorId));
        }else if(monitorType == "SQLServer"){
          dispatch(getSqlServerMonitorPropertyCounterData(monitorId));
        }else if (monitorType == "Oracle") {
          dispatch(getOracleMonitorPropertyCounterData(monitorId));
        }else if(monitorType == "Script" || monitorType == "AgentScript"){
          dispatch(getMonitorsEntryAliasDataFromID(monitorId))
        }else if(monitorType == "SnmpMIB"){
          dispatch(getMonitorSnmpMIBFile())
        }
        dispatch(setGetMonitorsPropertyDataDoneFlag(true));
        dispatch(requestDataActions.setRequestSuccess());
      }).catch(err => {
        dispatch(setGetMonitorsPropertyDataDoneFlag(true));
        dispatch(requestDataActions.setRequestFail());
      });
  }
}

// 获取监测器额外的属性数据
export function getMonitorsExtraPropertyDataFromID(filter) {
	return dispatch => {
    var monitorId = filter.monitorId;
    var monitorType = filter.monitorType;
    if(monitorType == "Mysql"){
      dispatch(getMySqlMonitorPropertyCounterData(monitorId));//获取当前选择的Mysql监测器计数器属性数据
    }else if(monitorType == "SQLServer"){
      dispatch(getSqlServerMonitorPropertyCounterData(monitorId));//获取当前选择的sqlserver监测器计数器属性数据
    }else if (monitorType == "Oracle") {
      dispatch(getOracleMonitorPropertyCounterData(monitorId));//获取当前选择的Oracle监测器计数器属性数据
    }else if(monitorType == "Script" || monitorType == "AgentScript"){
      dispatch(getMonitorsEntryAliasDataFromID(monitorId))//获取监测器EntryAlias数据
    }else if(monitorType == "SnmpMIB"){
      dispatch(getMonitorSnmpMIBFile())
    }
  }
}

//增加监测器属性数据
export function addMonitorsProperty(adddata,callback) {
    return (dispatch,getState) => {
      var state = getState();
      let auditData = {
        type: 'add_monitor',
        BoId: 'monitor',
        desc: adddata.Title,
        OperationAssociation: adddata.association
      }
      adddata.hasOwnProperty('association') && delete adddata.association;
      var snmpMibCounter = [];
      if (adddata.hasOwnProperty('snmpMibCounter')) {
        snmpMibCounter = adddata.snmpMibCounter;
        delete adddata.snmpMibCounter;
      }
		// === 已切换到 OFBiz 新接口 /monitor/create ===
    // 旧字段映射：EquipmentId→parentFixedAssetId, MonitorType→MONITOR_TYPE, Title→fixedAssetName
    // IS_DISABLED（doc/06）：'false'/0=启用（默认），'true'/1=禁用
    // 字段兜底：表单字段名可能是 port/RefreshTime/hostname（小写/驼峰），action 内部期望 Port/MonitorRefresh/ServerAddress
    var createData = {
      parentFixedAssetId: adddata.EquipmentId || '',
      fixedAssetName: adddata.Title || '',
      MONITOR_TYPE: adddata.MonitorType || '',
      TARGET_HOST: adddata.ServerAddress || adddata.serverAddress || adddata.serveraddress || adddata.hostname || adddata.host || adddata.ipAddress || adddata.ipaddress || adddata.ip || '',
      TARGET_PORT: adddata.Port !== undefined && adddata.Port !== null && adddata.Port !== '' ? adddata.Port
                  : (adddata.port !== undefined && adddata.port !== null && adddata.port !== '' ? adddata.port
                  : (adddata.TARGET_PORT || '')),
      REFRESH_TIME: adddata.MonitorRefresh !== undefined && adddata.MonitorRefresh !== null && adddata.MonitorRefresh !== '' ? adddata.MonitorRefresh
                    : (adddata.RefreshTime !== undefined && adddata.RefreshTime !== null && adddata.RefreshTime !== '' ? adddata.RefreshTime
                    : (adddata.REFRESH_TIME || '')),
      REFRESH_UNIT: adddata.RefreshUnit || adddata.REFRESH_UNIT || 'MINUTES',
      TIMEOUT: adddata.MonitorTimeOut || adddata.TIMEOUT || 30000,
      IS_DISABLED: (adddata.IsDisable === 'Y' || adddata.IsDisable === true || adddata.IsDisable === 'true' || adddata.IsDisable === '1' || adddata.IsDisable === 1) ? true : false,
      SPECIAL_PROPS: adddata.SpecialProps || adddata.SpecialProperties || '',
      // 计数器监测器（Mysql/SQLServer/Oracle）勾选的计数器名，逗号拼接随监测器一起保存
      // （对应老 EccMonitorCount 表的多行 savename，新后端存 SAVE_NAMES 属性、采集时过滤 show status）
      SAVE_NAMES: (state.equipmentReducer.mySqlCurrentCounterData || []).map(item => item.name).join(',')
        || (adddata.SaveNames || adddata.saveNames || ''),
      WARN_THRESHOLD: adddata.WarnThreshold || '',
      ERROR_THRESHOLD: adddata.ErrorThreshold || '',
      THRESHOLD_OP: adddata.ThresholdOp || '',
    };
    ofbiz.createMonitor(createData).then(createResult => {
      // 构造旧格式返回供后续计数器/告警条件逻辑用
      var data = { RecId: createResult && createResult.monitorId, MonitorType: adddata.MonitorType };
		if(data && data.RecId){
          var isRefresh = false;
          var isSnmpMib = false;
          if(data.RecId && data.MonitorType){
          if(data.MonitorType == "Mysql"){
            isRefresh = true;
            //新增加计数器
            for (var i = 0; i < state.equipmentReducer.mySqlCurrentCounterData.length; i++) {
              var updataObj = {
                monitorid:data.RecId,
                monitortype:'Monitor',
                savename:state.equipmentReducer.mySqlCurrentCounterData[i].name,
                showname:state.equipmentReducer.mySqlCurrentCounterData[i].name
              };
              dispatch(addMonitorPropertyCounterData(updataObj));
            };
          }else if(data.MonitorType == "SQLServer"){
            isRefresh = true;
            //新增加计数器
            for (var i = 0; i < state.equipmentReducer.selectedMonitorSQLServerCounter.length; i++) {
              var updataObj = {
                monitorid:data.RecId,
                monitortype:'Monitor',
                savename:state.equipmentReducer.selectedMonitorSQLServerCounter[i],
                showname:state.equipmentReducer.selectedMonitorSQLServerCounter[i]
              };
              dispatch(addMonitorPropertyCounterData(updataObj));
            };
          }else if(data.MonitorType == "Oracle"){
            isRefresh = true;
            //新增加计数器
            for (var i = 0; i < state.equipmentReducer.OracleCurrentCounterData.length; i++) {
              var updataObj = {
                monitorid:data.RecId,
                monitortype:'Monitor',
                savename:state.equipmentReducer.OracleCurrentCounterData[i],
                showname:state.equipmentReducer.OracleCurrentCounterData[i]
              };
              dispatch(addMonitorPropertyCounterData(updataObj));
            };
          }else if(data.MonitorType == "Script" || data.MonitorType == "AgentScript"){
            isRefresh = true;
            var updataObj = {
              MonitorId:data.RecId,
              EntryAlias:state.equipmentReducer.monitorScriptsEntryAlias[0].EntryAlias
            };
            dispatch(addMonitorPropertyEntryAlias(updataObj));
          } else if (data.MonitorType == 'SnmpMIB') {
            isSnmpMib = true;
            var mibcount = 0;
            snmpMibCounter.forEach((cd, cdIndex) => {
              var updataObj = {
                monitorid:data.RecId,
                monitortype:'Monitor',
                savename:cd.oid,
                showname:cd.name
              };
              dispatch(addMonitorPropertyCounterData(updataObj, () => {
                mibcount++;
                if (mibcount === snmpMibCounter.length) {
                  ofbiz.refreshMonitor(data.RecId).then(() => {
                    dispatch(saveMonitorAlarmConditions(data.RecId, data.MonitorType));
                    Util.showMessageDialog("系统提示","监测器增加成功。");
                    dispatch(createOperationAudit({ ...auditData, OperationResults: 1 }));
                    callback && callback();
                  });
                }
              }));
            });
          }
        };
        //保存监测器属性-报警条件的值
        if (isRefresh) {
          // 刷新监测器
          ofbiz.refreshMonitor(data.RecId).then(() => {
            dispatch(saveMonitorAlarmConditions(data.RecId, data.MonitorType));
            Util.showMessageDialog("系统提示","监测器增加成功。");
            dispatch(createOperationAudit({ ...auditData, OperationResults: 1 }));
            callback && callback();
          });
        } else if (!isSnmpMib) {
          dispatch(saveMonitorAlarmConditions(data.RecId, data.MonitorType));
          dispatch(createOperationAudit({ ...auditData, OperationResults: 1 })); // BoId: data.RecId
          Util.showMessageDialog("系统提示","监测器增加成功。");
          callback && callback();
        }
      }else{
        Util.showMessageDialog("系统提示","监测器增加失败。");
        dispatch(createOperationAudit({ ...auditData, OperationResults: 0 }));
        callback && callback();
      };
    }).catch(status => {
      if (status && status.code == '10037') {
        let equipment = getState().deviceMonitorTreeReducer.deviceMonitorTreeMap[adddata.EquipmentId];
        let _label = Util.NetEquipment.indexOf(equipment.EquipmentType) > -1 ? '网络设备监测授权' : '服务器与应用监测授权';
        let tipText = `您购买的${_label}点数已达最高点数`;
        Util.showMessageDialog('温馨提示', `${tipText}${Util.authenanceTip}`, 'warning');
        auditData.desc += "/原因:" + tipText;
      } else {
        Util.showMessageDialog("系统提示","监测器增加失败。");
      }
      dispatch(createOperationAudit({ ...auditData, OperationResults: 0 }));
      callback && callback();
    });
  }
}

export function batchAddMonitors(monitorList, callback) {
  return (dispatch) => {
    let count = 0;
    let failCount = 0;
    let alarmConditionMap = {};  //报警条件map
    monitorList.forEach((monitor, index) => {
      let alarmCount = 0;
      if (!(monitor.MonitorType in alarmConditionMap)) {
        oData.getInitialAlarmConditionDataFromMonitorType(monitor.MonitorType, function(alarmData) {
          alarmConditionMap[monitor.MonitorType] = alarmData.results;
          oData.addMonitorProperty(monitor, function(data){
            if (alarmConditionMap[monitor.MonitorType]&&alarmConditionMap[monitor.MonitorType].length > 0) {
              //保存报警条件
              alarmConditionMap[monitor.MonitorType].forEach((alarmItem, alarmItemIndex) => {
                oData.addMonitorAlarmCondition({
                  AlarmStatus: alarmItem.AlarmStatus,
                  MonitorId: data.RecId,
                  ReturnValue: alarmItem.SaveReturnValue,
                  Operator: alarmItem.Operators,
                  AlramValue: alarmItem.AlramValue,
                  MonitorType: alarmItem.MonitorType,
                  relation: ""
                }, function(condition) {
                  alarmCount++;
                  if (alarmCount === alarmConditionMap[monitor.MonitorType].length) {
                    count++;
                    if(count==monitorList.length){
                      if (failCount > 0) {
                        Util.showMessageDialog('提示', `${(count-failCount)}条数据添加成功${failCount}条数据添加失败`, 'warning');
                      } else {
                        Util.showMessageDialog('提示', '添加成功');
                      }
                      callback && callback();
                    }
                  }
                }, function(conditionStatus) {
                  alarmCount++;
                  if (alarmCount === alarmConditionMap[monitor.MonitorType].length) {
                    count++;
                    if(count==monitorList.length){
                      if (failCount > 0) {
                        Util.showMessageDialog('提示', `${(count-failCount)}条数据添加成功${failCount}条数据添加失败`, 'warning');
                      } else {
                        Util.showMessageDialog('提示', '添加成功');
                      }
                      callback && callback();
                    }
                  }
                });
              });
            } else {
              count++;
              if(count==monitorList.length){
                if (failCount > 0) {
                  Util.showMessageDialog('提示', `${(count-failCount)}条数据添加成功${failCount}条数据添加失败`, 'warning');
                } else {
                  Util.showMessageDialog('提示', '添加成功');
                }
                callback && callback();
              }
            }
          }, function(status) {
            count++;
            failCount++;
            if(count==monitorList.length){
              if (failCount === count) {
                Util.showMessageDialog('提示', '添加失败');
              } else {
                Util.showMessageDialog('提示', `${(count-failCount)}条数据添加成功${failCount}条数据添加失败`, 'warning');
              }
              callback && callback();
            }
          });
        }, function(status) {
          alarmConditionMap[monitor.MonitorType] = [];
          oData.addMonitorProperty(monitor, function(data){
            count++;
            if(count==monitorList.length){
              if (failCount > 0) {
                Util.showMessageDialog('提示', `${(count-failCount)}条数据添加成功${failCount}条数据添加失败`, 'warning');
              } else {
                Util.showMessageDialog('提示', '添加成功');
              }
              callback && callback();
            }
          }, function(status) {
            count++;
            failCount++;
            if(count==monitorList.length){
              if (failCount === count) {
                Util.showMessageDialog('提示', '添加失败');
              } else {
                Util.showMessageDialog('提示', `${(count-failCount)}条数据添加成功${failCount}条数据添加失败`, 'warning');
              }
              callback && callback();
            }
          });
        });
      } else {
        alarmConditionData = alarmConditionMap[monitor.MonitorType];
        oData.addMonitorProperty(monitor, function(data){
          if (alarmConditionMap[monitor.MonitorType]&&alarmConditionMap[monitor.MonitorType].length > 0) {
            //保存报警条件
            alarmConditionMap[monitor.MonitorType].forEach((alarmItem, alarmItemIndex) => {
              oData.addMonitorAlarmCondition({
                AlarmStatus: alarmItem.AlarmStatus,
                MonitorId: data.RecId,
                ReturnValue: alarmItem.SaveReturnValue,
                Operator: alarmItem.Operators,
                AlramValue: alarmItem.AlramValue,
                MonitorType: alarmItem.MonitorType,
                relation: ""
              }, function(condition) {
                alarmCount++;
                if (alarmCount === alarmConditionMap[monitor.MonitorType].length) {
                  count++;
                  if(count==monitorList.length){
                    if (failCount > 0) {
                      Util.showMessageDialog('提示', `${(count-failCount)}条数据添加成功${failCount}条数据添加失败`, 'warning');
                    } else {
                      Util.showMessageDialog('提示', '添加成功');
                    }
                    callback && callback();
                  }
                }
              }, function(conditionStatus) {
                alarmCount++;
                if (alarmCount === alarmConditionMap[monitor.MonitorType].length) {
                  count++;
                  if(count==monitorList.length){
                    if (failCount > 0) {
                      Util.showMessageDialog('提示', `${(count-failCount)}条数据添加成功${failCount}条数据添加失败`, 'warning');
                    } else {
                      Util.showMessageDialog('提示', '添加成功');
                    }
                    callback && callback();
                  }
                }
              });
            });
          } else {
            count++;
            if(count==monitorList.length){
              if (failCount > 0) {
                Util.showMessageDialog('提示', `${(count-failCount)}条数据添加成功${failCount}条数据添加失败`, 'warning');
              } else {
                Util.showMessageDialog('提示', '添加成功');
              }
              callback && callback();
            }
          }
        }, function(status) {
          count++;
          failCount++;
          if(count==monitorList.length){
            if (failCount === count) {
              Util.showMessageDialog('提示', '添加失败');
            } else {
              Util.showMessageDialog('提示', `${(count-failCount)}条数据添加成功${failCount}条数据添加失败`, 'warning');
            }
            callback && callback();
          }
        });
      }
    });
  }
}
let isOutCount = false;
//增加 多个监测器 属性数据
export function addMultiMonitorsProperty(adddata, callback){
	return (dispatch, getState) => {
		dispatch(requestDataActions.setRequest());
    var successMsg = '', failMsg = '', msg = '';
    var count = 0;
    isOutCount = false;
    for(var i in adddata){
      dispatch(addMonitorsPropertySingle(adddata[i], function(param){
        if(param.add){
          if(successMsg) {
            successMsg = successMsg + ',' + param.Title;
          } else {
            successMsg = param.Title;
          }
        } else {
          if(failMsg) {
            failMsg = failMsg + ',' + param.Title;
          } else {
            failMsg = param.Title;
          }
        }
        count = count + 1;
        if(count == adddata.length){
          let { deviceMonitorTreeMap } = getState().deviceMonitorTreeReducer;
          let equipment = deviceMonitorTreeMap[adddata[i].EquipmentId];
          let auditData = {
            type: 'add_monitor',
            BoId: 'monitor',
            OperationAssociation: deviceMonitorTreeMap[equipment.GroupId].name + '/' + equipment.Title
          };
          if (isOutCount) {
            let _label = Util.NetEquipment.indexOf(equipment.EquipmentType) > -1 ? '网络设备监测授权' : '服务器与应用监测授权';
            let tipText = `您购买的${_label}点数已达最高点数`;
            auditData.desc = failMsg + "/原因：" + tipText;
            Util.showMessageDialog('温馨提示', `${tipText}${Util.authenanceTip}`, 'warning');
            dispatch(createOperationAudit({ ...auditData, OperationResults: 0 }));
          } else {
            if(successMsg){
              auditData.desc = successMsg;
              successMsg = successMsg + '添加成功。';
              msg = successMsg;
              Util.showMessageDialog("系统提示", msg);
              dispatch(createOperationAudit({ ...auditData, OperationResults: 1 }));
            } else if(failMsg){
              auditData.desc = failMsg;
              failMsg = failMsg + '添加失败。';
              msg = msg + failMsg;
              Util.showMessageDialog("系统提示", msg);
              dispatch(createOperationAudit({ ...auditData, OperationResults: 0 }));
            }
          }
          callback && callback();
        }
      }));
    }
  }
}

function addMonitorsPropertySingle(addata, callback){
	return (dispatch,getState) => {
    var state = getState();
    var returnValue = {
      Title: addata.Title,
      add: false
    }
    if (isOutCount) {
      callback(returnValue);
      return;
    }
		oData.addMonitorProperty(addata, function(data){
			if(data){
        dispatch(saveMonitorAlarmConditions(data.RecId, data.MonitorType));
        returnValue.add=true;
        callback(returnValue);
			}else{
        returnValue.add=false;
        callback(returnValue);
      };
		}, function(status) {
      if (status.hasOwnProperty('code') && status.code == '10037') {
        isOutCount = true;
      }
      returnValue.add = false;
      callback && callback(returnValue);
    });
  }
};

//更新监测器属性数据
export function updataMonitorsProperty(updata, callback) {
	return (dispatch,getState) => {
		dispatch(requestDataActions.setRequest());
    var state = getState();
    const auditData = {
      type: 'edit_monitor',
      // BoId: updata.RecId,
      BoId: 'monitor',
      desc: updata.Title,
      OperationAssociation: updata.association
    }
    updata.hasOwnProperty('association') && delete updata.association;
    var snmpMibCounter = [];
    if (updata.hasOwnProperty('snmpMibCounter')) {
      snmpMibCounter = updata.snmpMibCounter;
      delete updata.snmpMibCounter;
    }
    if(updata.MonitorType == "Mysql"){
      //先删除原来的计数器
      for (var i = 0; i < state.equipmentReducer.mySqlMonitorsPropertyCounterData.length; i++) {
        dispatch(deleteMonitorPropertyCounterData(state.equipmentReducer.mySqlMonitorsPropertyCounterData[i].RecId));
      };
      //重新增加计数器
      for (var i = 0; i < state.equipmentReducer.mySqlCurrentCounterData.length; i++) {
        var updataObj = {
          monitorid:updata.RecId,
          monitortype:'Monitor',
          savename:state.equipmentReducer.mySqlCurrentCounterData[i].name,
          showname:state.equipmentReducer.mySqlCurrentCounterData[i].name
        };
        dispatch(addMonitorPropertyCounterData(updataObj));
      };
    }else if(updata.MonitorType == "SQLServer"){
      //先删除原来的计数器
      for (var i = 0; i < state.equipmentReducer.sqlServerMonitorsPropertyCounterData.length; i++) {
        dispatch(deleteMonitorPropertyCounterData(state.equipmentReducer.sqlServerMonitorsPropertyCounterData[i].RecId));
      };
      //重新增加计数器
      for (var i = 0; i < state.equipmentReducer.selectedMonitorSQLServerCounter.length; i++) {
        var updataObj = {
          monitorid:updata.RecId,
          monitortype:'Monitor',
          savename:state.equipmentReducer.selectedMonitorSQLServerCounter[i],
          showname:state.equipmentReducer.selectedMonitorSQLServerCounter[i]
        };
        dispatch(addMonitorPropertyCounterData(updataObj));
      };
    }else if(updata.MonitorType == "Oracle"){
      //先删除原来的计数器
      for (var i = 0; i < state.equipmentReducer.OracleMonitorsPropertyCounterData.length; i++) {
        dispatch(deleteMonitorPropertyCounterData(state.equipmentReducer.OracleMonitorsPropertyCounterData[i].RecId));
      };
      //重新增加计数器
      for (var i = 0; i < state.equipmentReducer.OracleCurrentCounterData.length; i++) {
        var updataObj = {
          monitorid:updata.RecId,
          monitortype:'Monitor',
          savename:state.equipmentReducer.OracleCurrentCounterData[i],
          showname:state.equipmentReducer.OracleCurrentCounterData[i]
        };
        dispatch(addMonitorPropertyCounterData(updataObj));
      };
    }else if(updata.MonitorType == "Script" || updata.MonitorType == "AgentScript"){
      //先删除原来的计数器
      for (var i = 0; i < state.equipmentReducer.monitorScriptsEntryAlias.length; i++) {
        dispatch(deleteMonitorPropertyEntryAliasData(state.equipmentReducer.monitorScriptsEntryAlias[i].RecId));
      };
      //重新增加计数器
      for (var i = 0; i < state.equipmentReducer.monitorScriptsEntryAlias.length; i++) {
        var updataObj = {
          MonitorId:updata.RecId,
          EntryAlias:state.equipmentReducer.monitorScriptsEntryAlias[i].EntryAlias
        };
        dispatch(addMonitorPropertyEntryAlias(updataObj));
      };
    }
		// === 已切换到 OFBiz 新接口 /monitor/update ===
    // IS_DISABLED（doc/06）：'false'/0=启用，'true'/1=禁用；编辑时带出监测器当前禁用状态
    // 字段兜底：表单字段名可能是 port/RefreshTime/hostname（小写/驼峰），action 内部期望 Port/MonitorRefresh/ServerAddress
    var _currentMonitorData = state.equipmentReducer.monitorsPropertyData || state.equipmentReducer.selectedMonitor || {};
    var _isDisabled = updata.IsDisable !== undefined && updata.IsDisable !== null && updata.IsDisable !== ''
      ? updata.IsDisable
      : (_currentMonitorData.IsDisable || 'N');
    var updateData = {
      monitorId: updata.RecId,
      fixedAssetName: updata.Title || '',
      MONITOR_TYPE: updata.MonitorType || '',
      TARGET_HOST: updata.ServerAddress || updata.serverAddress || updata.serveraddress || updata.hostname || updata.host || updata.ipAddress || updata.ipaddress || updata.ip || '',
      TARGET_PORT: updata.Port !== undefined && updata.Port !== null && updata.Port !== '' ? updata.Port
                  : (updata.port !== undefined && updata.port !== null && updata.port !== '' ? updata.port
                  : (updata.TARGET_PORT || '')),
      REFRESH_TIME: updata.MonitorRefresh !== undefined && updata.MonitorRefresh !== null && updata.MonitorRefresh !== '' ? updata.MonitorRefresh
                    : (updata.RefreshTime !== undefined && updata.RefreshTime !== null && updata.RefreshTime !== '' ? updata.RefreshTime
                    : (updata.REFRESH_TIME || '')),
      REFRESH_UNIT: updata.RefreshUnit || updata.REFRESH_UNIT || 'MINUTES',
      TIMEOUT: updata.MonitorTimeOut || updata.TIMEOUT || 30000,
      IS_DISABLED: (_isDisabled === 'Y' || _isDisabled === true || _isDisabled === 'true' || _isDisabled === '1' || _isDisabled === 1) ? true : false,
      SPECIAL_PROPS: updata.SpecialProps || updata.SpecialProperties || '',
      // 计数器监测器编辑：新勾选优先；未重新勾选时透传原值（后端属性透传 saveNames），避免清空
      SAVE_NAMES: (state.equipmentReducer.mySqlCurrentCounterData || []).map(item => item.name).join(',')
        || (updata.SaveNames || updata.saveNames || (state.equipmentReducer.monitorsPropertyData && state.equipmentReducer.monitorsPropertyData.saveNames) || ''),
      WARN_THRESHOLD: updata.WarnThreshold || '',
      ERROR_THRESHOLD: updata.ErrorThreshold || '',
      THRESHOLD_OP: updata.ThresholdOp || '',
    };
    ofbiz.updateMonitor(updateData).then(result => {
      var data = { results: { RecId: updata.RecId, MonitorType: updata.MonitorType } };
			if(result){
				//保存监测器属性-报警条件的值
				dispatch(saveMonitorAlarmConditions(updata.RecId, updata.MonitorType));
				dispatch(requestDataActions.setRequestSuccess());
				Util.showMessageDialog("系统提示","监测器修改成功。");
        dispatch(createOperationAudit({ ...auditData, OperationResults: 1 }));
        //snmpmib计数器处理
        if (data.results.MonitorType == "SnmpMIB") {
          //删除取消勾选的计数器
          if (snmpMibCounter.length > 0) {
            oData.getMySqlMonitorPropertyCounter(data.results.RecId, (oldData)=>{
              oldData.forEach((ocd, ocdIndex) => {
                let sIndex = snmpMibCounter.findIndex(d => d.name === ocd.showname);
                if (sIndex === -1) {
                  oData.deleteMonitorPropertyCounter(ocd.RecId);
                } else {
                  snmpMibCounter.splice(sIndex, 1);
                }
              });
              //添加新勾选的监测器
              snmpMibCounter.forEach((mcd, mcdIndex) => {
                dispatch(addMonitorPropertyCounterData({
                  monitorid:data.results.RecId,
                  monitortype:'Monitor',
                  savename:mcd.oid,
                  showname:mcd.name
                }));
              });
            });
          }
        }
			}else{
				dispatch(requestDataActions.setRequestFail());
				Util.showMessageDialog("系统提示","监测器修改失败。");
        dispatch(createOperationAudit({ ...auditData, OperationResults: 0 }));
			};
      callback && callback();
			}).catch(() => {
      callback && callback();
      dispatch(createOperationAudit({ ...auditData, OperationResults: 0 }));
    });
  }
}
//删除监测器属性数据 {monitorId:'',monitorType=''}
export function deleteMonitorsProperty(deleteData) {
	return (dispatch,getState) => {
		dispatch(requestDataActions.setRequest());
    var state = getState();
    if(deleteData.monitorType == "Mysql"){
      //删除计数器
      for (var i = 0; i < state.equipmentReducer.mySqlMonitorsPropertyCounterData.length; i++) {
        dispatch(deleteMonitorPropertyCounterData(state.equipmentReducer.mySqlMonitorsPropertyCounterData[i].RecId));
      };
    }else if(deleteData.monitorType == "SQLServer"){
      //删除计数器
      for (var i = 0; i < state.equipmentReducer.sqlServerMonitorsPropertyCounterData.length; i++) {
        dispatch(deleteMonitorPropertyCounterData(state.equipmentReducer.sqlServerMonitorsPropertyCounterData[i].RecId));
      };
    }else if (deleteData.monitorType == "Oracle") {
      //删除计数器
      for (var i = 0; i < state.equipmentReducer.OracleMonitorsPropertyCounterData.length; i++) {
        dispatch(deleteMonitorPropertyCounterData(state.equipmentReducer.OracleMonitorsPropertyCounterData[i].RecId));
      };
    }else if(data.MonitorType == "Script" || data.MonitorType == "AgentScript"){
      var updataObj = {
        MonitorId:data.RecId,
        EntryAlias:state.equipmentReducer.monitorScriptsEntryAlias
      };
      dispatch(deleteMonitorPropertyEntryAliasData(updataObj));
    };
		oData.deleteMonitorProperty(deleteData.monitorId, function(data){
			// if(data.results.length == 0){
			// 	dispatch(requestDataActions.setRequestFail());
			// 	return;
			// };
			dispatch(deleteMonitorAlarmConditions());
			dispatch(requestDataActions.setRequestSuccess());
			Util.showMessageDialog("系统提示","监测器删除成功。");
		});
  }
}

//删除多个监测器属性数据
export function deleteMultiMonitorsProperty(param) {
	return (dispatch,getState) => {
		dispatch(requestDataActions.setRequest());
    var state = getState();
    var count = 0;
    var deldata = param.deldata;
    for(var i=0;i<deldata.length;i++){
      dispatch(deleteMonitorsPropertySingle(deldata[i],function(data){
        if(data.monitorType == "Mysql"){
          //删除计数器
          for (var m = 0; m < state.equipmentReducer.mySqlMonitorsPropertyCounterData.length; m++) {
            dispatch(deleteMonitorPropertyCounterData(state.equipmentReducer.mySqlMonitorsPropertyCounterData[m].RecId));
          };
        }else if(data.monitorType == "SQLServer"){
          //删除计数器
          for (var n = 0; n < state.equipmentReducer.sqlServerMonitorsPropertyCounterData.length; n++) {
            dispatch(deleteMonitorPropertyCounterData(state.equipmentReducer.sqlServerMonitorsPropertyCounterData[n].RecId));
          };
        }else if (data.monitorType == "Oracle") {
          //删除计数器
          for (var b = 0; b < state.equipmentReducer.OracleMonitorsPropertyCounterData.length; b++) {
            dispatch(deleteMonitorPropertyCounterData(state.equipmentReducer.OracleMonitorsPropertyCounterData[b].RecId));
          };
        }else if(data.MonitorType == "Script" || data.MonitorType == "AgentScript"){
          var updataObj = {
            MonitorId:data.RecId,
            EntryAlias:state.equipmentReducer.monitorScriptsEntryAlias
          };
          dispatch(deleteMonitorPropertyEntryAliasData(updataObj));
        };
        count = count + 1;
        if(count == deldata.length){
          for(var k = 0; k<deldata.length; k++){
            for(var j=0;j<state.equipmentReducer.monitorTableData.length;j++){
              if(deldata[k].monitorId == state.equipmentReducer.monitorTableData[j].id){
                state.equipmentReducer.monitorTableData.splice(j, 1);
              }
            }
          }
          dispatch(deleteMonitorAlarmConditions());
          dispatch(requestDataActions.setRequestSuccess());
          Util.showMessageDialog("系统提示","监测器删除成功。");
        }
        state = getState();
        if(param && param.callback) param.callback('删除成功');
        dispatch(requestDataActions.setRequestSuccess());
      }));
    }
  }
}

function deleteMonitorsPropertySingle(deldata, callback){
	return (dispatch,getState) => {
    var state = getState();
    var returnValue = {
      Title: deldata.Title,
      del: false
    }
		oData.deleteMonitorProperty(deldata.monitorId, function(data){
			if(data){
        returnValue.del=true;
        callback(returnValue);
			}else{
        returnValue.del=false;
        callback(returnValue);
      };
		});
  }
};

//获取MySQL监测器:计数器 所有可选择项数据
export function getMySqlMonitorCounterData1(equipmentId) {
	return dispatch => {
		dispatch(setMySqlMonitorCounterData([]));
		dispatch(requestDataActions.setRequest());
    var filter = [{key:"EQUIPMENT_ID", value:equipmentId}];
		oData.getMySqlMonitorCounterData(filter, function(data){
			if(data.results.length == 0){
				dispatch(requestDataActions.setRequestFail());
				return;
			};
			dispatch(setMySqlMonitorCounterData(data.results));
			dispatch(requestDataActions.setRequestSuccess());
		});
  }
}
//获取MySQL监测器:计数器; 属性数据
export function getMySqlMonitorPropertyCounterData(monitorId) {
	return dispatch => {
		dispatch(setMySqlMonitorPropertyCounterData([]));
    dispatch(setMySqlMonitorCurrentCounterData([]));
		oData.getMySqlMonitorPropertyCounter(monitorId, function(data){
      if (data) {
        var currentCounterData = [];
        for (var i = 0; i < data.length; i++) {
          currentCounterData.push({name: data[i].showname});
        }
        dispatch(setMySqlMonitorCurrentCounterData(currentCounterData));
        dispatch(setMySqlMonitorPropertyCounterData(data));
      }
		});
  }
}
//增加 MySQL监测器:计数器; 属性数据
export function addMonitorPropertyCounterData(updata, callback) {
	return dispatch => {
		// dispatch(requestDataActions.setRequest());
		oData.addMonitorPropertyCounter(updata, function(data){
			// dispatch(requestDataActions.setRequestSuccess());
      callback && callback(data);
		}, function(status) {
      callback && callback(data);
    });
  }
}
//删除 MySQL监测器:计数器;属性数据
export function deleteMonitorPropertyCounterData(updata) {
	return dispatch => {
		// dispatch(requestDataActions.setRequest());
		oData.deleteMonitorPropertyCounter(updata, function(data){
			// dispatch(requestDataActions.setRequestSuccess());
		});
  }
}

//获取SQL监测器:计数器 所有可选择项数据
export function getSQLServerMonitorCounterData(equipmentId) {
    return dispatch => {
        var filter = [{key:"EQUIPMENT_ID", value:equipmentId}];
        dispatch(setMonitorSQLServerCounters([]));
        dispatch(requestDataActions.setRequest());
        oData.getSQLServerMonitorCounterData(filter, function(data){
            if(data.results.length == 0){
                dispatch(requestDataActions.setRequestFail());
                return;
            }
            var dataObj = data.results;
            var oneArr=[];
            var newOneArr = [];
            var isRepeated;
            var data = {};
            var resultarr = [];
            var twoArr={};
            if(!dataObj.length == 0){
              for(var i in dataObj){
                if(dataObj[i].OBJECT_NAME !== '' || dataObj[i].COUNT_NAME !== ''){
                  oneArr.push(dataObj[i].OBJECT_NAME);
                }
              }
              //删除oneArr中的重复数据
              for(var j=0; j< oneArr.length; j++){
                isRepeated = false;
                for(var h=0; h<= newOneArr.length; h++){
                  if(oneArr[j] == newOneArr[h]){
                    isRepeated = true;
                    break;
                  }
                }
                if(!isRepeated){
                  newOneArr.push(oneArr[j]);
                }
              }
              for(var k in newOneArr){
                data ={
                  name:newOneArr[k],
                  children:[]
                }
                resultarr.push(data);
              }

              for(var n in resultarr){
                for(var k in dataObj){
                  if(resultarr[n].name == dataObj[k].OBJECT_NAME){
                    twoArr={name:dataObj[k].COUNT_NAME};
                    resultarr[n].children.push(twoArr);
                  }
                }
              }
            }
            dispatch(setMonitorSQLServerCounters(resultarr));
            dispatch(requestDataActions.setRequestSuccess());
        });
    }
}
//获取SQL监测器:计数器; 属性数据
export function getSqlServerMonitorPropertyCounterData(monitorId) {
	return dispatch => {
		dispatch(setSQLServerMonitorPropertyCounterData([]));
    dispatch(setSelectedMonitorSQLServerCounter([]));
		dispatch(requestDataActions.setRequest());
		oData.getMySqlMonitorPropertyCounter(monitorId, function(data){
			if(data.results.length == 0){
          dispatch(setGetMySqlMonitorCounterDataDoneFlag(true));
				  dispatch(requestDataActions.setRequestFail());
				  return;
			}else{
        var currentCounterData = [];
        for (var i = 0; i < data.results.length; i++) {
          currentCounterData.push(data.results[i].showname);
        }
        dispatch(setSQLServerMonitorPropertyCounterData(currentCounterData));
        dispatch(setSelectedMonitorSQLServerCounter(data.results));
        dispatch(setGetSQLServerMonitorCounterDataDoneFlag(true));
      };
			dispatch(requestDataActions.setRequestSuccess());
		});
  }
}

//获取 script监测器: 属性EntryAlias数据
export function getMonitorsEntryAliasDataFromID(monitorId) {
	return dispatch => {
		dispatch(setMonitorScriptsEntryAlias([]));
		oData.getMonitorsEntryAliasDataFromID(monitorId, function(data){
			if(data.results){
				dispatch(setMonitorScriptsEntryAlias(data.results));
			};
		});
  }
};

//增加 script监测器:属性数据
export function addMonitorPropertyEntryAlias(updata) {
	return dispatch => {
		// dispatch(requestDataActions.setRequest());
		oData.addMonitorPropertyEntryAlias(updata, function(data){
			// dispatch(requestDataActions.setRequestSuccess());
		});
  }
}
//删除 script 监测器:属性数据
export function deleteMonitorPropertyEntryAliasData(RecId) {
	return dispatch => {
		// dispatch(requestDataActions.setRequest());
		oData.deleteMonitorPropertyEntryAlias(RecId, function(data){
			// dispatch(requestDataActions.setRequestSuccess());
		});
  }
}

//获取Oracle监测器:计数器 所有可选择项数据
export function getOracleMonitorCounterData(equipmentId) {
	return dispatch => {
		dispatch(setOracleMonitorCounterData([]));
		dispatch(requestDataActions.setRequest());
    var filter = [{key:"EQUIPMENT_ID", value:equipmentId}];
		oData.getOracleMonitorCounterData(filter, function(data){
			if(data.results.length == 0){
				dispatch(requestDataActions.setRequestFail());
				return;
			};
			dispatch(setOracleMonitorCounterData(data.results));
			dispatch(requestDataActions.setRequestSuccess());
		});
  }
}
//获取Oracle监测器:计数器; 属性数据
export function getOracleMonitorPropertyCounterData(monitorId) {
	return dispatch => {
		dispatch(setOracleMonitorPropertyCounterData([]));
    dispatch(setOracleMonitorCurrentCounterData([]));
		dispatch(requestDataActions.setRequest());
		oData.getMySqlMonitorPropertyCounter(monitorId, function(data){
			if(data.results.length == 0){
          dispatch(setGetOracleMonitorCounterDataDoneFlag(true));
				  dispatch(requestDataActions.setRequestFail());
				  return;
			}else{
        var currentCounterData = [];
        for (var i = 0; i < data.results.length; i++) {
          currentCounterData.push(data.results[i].showname);
        }
        dispatch(setOracleMonitorCurrentCounterData(currentCounterData));
        dispatch(setOracleMonitorPropertyCounterData(data.results));
        dispatch(setGetOracleMonitorCounterDataDoneFlag(true));
      };
			dispatch(requestDataActions.setRequestSuccess());
		});
  }
}


//=================是否显示树============
export const ISSHOWTREE = 'ISSHOWTREE';//获取visio 数据
export function emitIsShowTree(data){
  return {
      type: ISSHOWTREE,
      data
  }
}
export function isShowTree(isShow){
  return dispatch => {
    return dispatch(emitIsShowTree(isShow));
  }
}
//================设置上次选择资源树节点=========================
export const GETOLDRESOURCETREENODE = 'GETOLDRESOURCETREENODE';
export function emitOldResourceTreeNode(checkedNodes) {
    return {
        type: GETOLDRESOURCETREENODE,
        checkedNodes
    }
}

//获取 SNMPMIBFile
export function getMonitorSnmpMIBFile1(param) {
    return (dispatch, getState) => {
    var state = getState();
      oData.getMonitorSnmpMIBFile(function(data){
          var results = data.results;
          if(results.length == 0){
              dispatch(requestDataActions.setRequestFail());
              return;
          };
          var resultsValue=results[0].FileNames;
          if(resultsValue){
            //substring提取字符串中介于两个指定下标之间的字符
            resultsValue = resultsValue.substring(1,resultsValue.length-2).replace(/"/g,'');
            var dataresult=resultsValue.split(",");
            dispatch(setMonitorSnmpMIBFile(dataresult));
          }
          state = getState();
          if(param && param.callback) param.callback({
            monitorSnmpMIBFile: state.equipmentReducer.monitorSnmpMIBFile
          });
          dispatch(setGetMonitorsSnmpMIBFileDataDoneFlag(true));
          dispatch(requestDataActions.setRequestSuccess());
      })
    }
}

export function getMonitorSnmpMIBCounter1(filt, callback) {
    return dispatch => {
        var filter = [{key:"EquipmentId", value:filt.EquipmentId},{key:"FileName", value:filt.FileName}];
        dispatch(setMonitorSnmpMIBCounter({}));
        dispatch(requestDataActions.setRequest());
        oData.getMonitorSnmpMIBCounter(filter, function(data){
            if(data.results.length == 0){
                dispatch(requestDataActions.setRequestFail());
                return;
            }
            var counter=data.results[0].Counter;
            var finalResult = [];
            if(counter){
              //通过eval() 函数可以将JSON字符串转化为对象
              var counterTemp = eval(counter);
              var counterObj={};      //整理后的对象
              var counterArray=[];  //整理后的数组
              counterTemp=counterTemp[0];
              var results = [];
              for(var i in counterTemp){
                counterObj = { name: counterTemp[i].name, pid: counterTemp[i].pid, oid: counterTemp[i].oid };
                counterArray.push(counterObj);
              }
              if(counterArray.length > 0){
                var one = [], other = [], otherResult = [];
                for(var q=0;q<counterArray.length;q++){
                  //筛选1级菜单
                  if(!counterArray[q].pid){
                    let clearname = counterArray[q].name.substr(0, counterArray[q].name.indexOf('(')-1);
                    results = {label: counterArray[q].name, value: clearname, key: clearname, name:counterArray[q].name, oid:counterArray[q].oid,children:SelectSon(counterArray[q].oid)};
                    //1级菜单 包括其子节点 插入最后结果
                    finalResult.push(results);
                  }
                }
                function SelectSon(oid){
                  var pidArr = [], arr = [];
                  //筛选子节点
                  for(var h=0; h<counterArray.length; h++){
                    var data = {};
                    //oid 一级菜单的oid
                    if(oid == counterArray[h].pid){
                      let clearname = counterArray[q].name.substr(0, counterArray[q].name.indexOf('(')-1);
                      data = {label: counterArray[h].name, value: clearname, key: clearname, name:counterArray[h].name, oid:counterArray[h].oid, pid:counterArray[h].pid};
                      pidArr.push(data);
                    }
                  }
                  for(var e=0;e<pidArr.length;e++){
                    let clearname = pidArr[e].name.substr(0, pidArr[e].name.indexOf('(')-1);
                    var data = {label: pidArr[e].name, value: clearname, key: clearname, name:pidArr[e].name,oid:pidArr[e].oid,children:SelectSon(pidArr[e].oid)}; //递归
                    arr.push(data);
                  }
                  //一次性返回子节点数组，他们成为同级子节点
                  return arr;
                }
              }
              finalResult = [{label: 'VALUES', value: 'VALUES', key: 'VALUES', name: "VALUES", children:finalResult}];
              dispatch(setMonitorSnmpMIBCounter(finalResult));
              if (callback) callback(finalResult);
              dispatch(requestDataActions.setRequestSuccess());
            }else{
              finalResult = [{label: 'VALUES', value: 'VALUES', key: 'VALUES', name: "VALUES"}];
              dispatch(setMonitorSnmpMIBCounter(finalResult));
              if (callback) callback(finalResult);
              dispatch(requestDataActions.setRequestSuccess());
            }
        });
    }
}

export function getMonitorStorageDisk(param) {
    return dispatch => {
        var filter = [{key:"EquipmentId", value:param.equipmentId}];
        dispatch(setMonitorStorageDisks([]));
        dispatch(requestDataActions.setRequest());
        oData.getMonitorStorageDisk(filter, function(data){
            if(data.results.length == 0){
                if(param && param.callback) param.callback();
                dispatch(requestDataActions.setRequestFail());
                return;
            }
            //通过eval() 函数可以将JSON字符串转化为对象
            var dataObj = eval(data.results[0]);
            var diskNames = dataObj.DiskNames;
            diskNames = eval("(" + diskNames + ")");

            var monitorDisks = [];
            for(var i = 0; i < diskNames.length; i++) {
                if(diskIds.length == diskNames.length) {
                    monitorDisks.push({name:diskNames[i]});
                }
                else {
                    monitorDisks.push({name:diskNames[i]});
                }
            }
            //按磁盘名排序
            monitorDisks.sort(function(a,b){
                return a.name>b.name ? 1 : -1;
            });
            dispatch(setMonitorStorageDisks(monitorDisks));
            dispatch(requestDataActions.setRequestSuccess());
            if(param && param.callback) param.callback();
        }, function(){
          if(param && param.callback) param.callback();
        });
    }
}

export function getMonitorStorageCache(equipmentId) {
    return dispatch => {
        var filter = [{key:"EquipmentId", value:equipmentId}];
        dispatch(setMonitorStorageCaches([]));
        dispatch(requestDataActions.setRequest());
        oData.getMonitorStorageCache(filter, function(data){
            if(data.results.length == 0){
                dispatch(requestDataActions.setRequestFail());
                return;
            }
            //通过eval() 函数可以将JSON字符串转化为对象
            var dataObj = eval(data.results[0]);
            var cacheNames = dataObj.CacheNames;
            cacheNames = eval("(" + cacheNames + ")");

            var monitorStorageCacheNames = [];
            for(var i = 0; i < cacheNames.length; i++) {
                if(diskIds.length == cacheNames.length) {
                    monitorStorageCacheNames.push({name:cacheNames[i]});
                }
                else {
                    monitorStorageCacheNames.push({name:cacheNames[i]});
                }
            }
            //按磁盘名排序
            monitorStorageCacheNames.sort(function(a,b){
                return a.name>b.name ? 1 : -1;
            });
            dispatch(setMonitorStorageCaches(monitorStorageCacheNames));
            dispatch(requestDataActions.setRequestSuccess());
        });
    }
}

export function getMonitorIPMISensorCounters1(equipmentId, callback) {
    return dispatch => {
        var filter = [{key:"EquipmentId", value:equipmentId}];
        dispatch(setMonitorIPMISensorCounters([]));
        dispatch(requestDataActions.setRequest());
        oData.getMonitorIPMISensorCounters(filter, function(data){
            if(data.results.length == 0){
                dispatch(requestDataActions.setRequestFail());
                if (callback) callback(false);
                return;
            }
            //通过eval() 函数可以将JSON字符串转化为对象
            var dataObj = eval(data.results[0]);
            var counter = dataObj.Counter;
            counter = eval("(" + counter + ")");
            // console.log(counter);
            // var monitorCounters = [];
            // for(var i = 0; i < counter.length; i++) {
            //   monitorCounters.push({name:counter[i]});
            // }
            //按磁盘名排序
            // monitorCounters.sort(function(a,b){
            //     return a.name>b.name ? 1 : -1;
            // });
            dispatch(setMonitorIPMISensorCounters(counter));
            if(counter.length > 0) {
              Util.showMessageDialog("系统提示", "成功获取计数器列表");
            } else {
              Util.showMessageDialog("系统提示", "暂没有计数器数据", "info");
            }
            if (callback) callback(true);
            dispatch(requestDataActions.setRequestSuccess());
        }, function(result){
          Util.showMessageDialog("系统提示", "获取计数器列表超时"+result, "error");
          if (callback) callback(false);
        });
    }
}

export function getMonitorStorageProcessors(equipmentId) {
    return dispatch => {
        var filter = [{key:"EquipmentId", value:equipmentId}];
        dispatch(setMonitorStorageProcessors([]));
        dispatch(requestDataActions.setRequest());
        oData.getMonitorStorageProcessors(filter, function(data){
            if(data.results.length == 0){
                dispatch(requestDataActions.setRequestFail());
                return;
            }
            //通过eval() 函数可以将JSON字符串转化为对象
            var dataObj = eval(data.results[0]);
            var processor = dataObj.Processor;
            processor = eval("(" + processor + ")");

            var monitorProcessors = [];
            for(var i = 0; i < processor.length; i++) {
                if(diskIds.length == processor.length) {
                    monitorProcessors.push({name:processor[i]});
                }
                else {
                    monitorProcessors.push({name:processor[i]});
                }
            }
            //按磁盘名排序
            monitorProcessors.sort(function(a,b){
                return a.name>b.name ? 1 : -1;
            });
            dispatch(setMonitorStorageProcessors(monitorProcessors));
            dispatch(requestDataActions.setRequestSuccess());
        });
    }
}

export function getMonitorFibreChannelStatusNodes(param) {
    return dispatch => {
        var filter = [{key:"EquipmentId", value:param.equipmentId}];
        dispatch(setMonitorFibreChannelStatusNodes([]));
        dispatch(requestDataActions.setRequest());
        oData.getMonitorFibreChannelStatusNodes(filter, function(data){
            if(data.results.length == 0){
                if (param && param.callback) param.callback();
                dispatch(requestDataActions.setRequestFail());
                return;
            }
            //通过eval() 函数可以将JSON字符串转化为对象
            var dataObj = eval(data.results[0]);
            var nodes = dataObj.Nodes;
            nodes = eval("(" + nodes + ")");

            var monitorNodes = [];
            for(var i = 0; i < nodes.length; i++) {
                if(diskIds.length == nodes.length) {
                    monitorNodes.push({name:nodes[i]});
                }
                else {
                    monitorNodes.push({name:nodes[i]});
                }
            }
            //按磁盘名排序
            monitorNodes.sort(function(a,b){
                return a.name>b.name ? 1 : -1;
            });
            dispatch(setMonitorFibreChannelStatusNodes(monitorNodes));
            dispatch(requestDataActions.setRequestSuccess());
            if (param && param.callback) param.callback();
        }, function(){
          if (param && param.callback) param.callback();
        });
    }
}

export function getMonitorStorageVolumeFiles(param) {
    return dispatch => {
        var filter = [{key:"EquipmentId", value:param.equipmentId}];
        dispatch(setMonitorStorageVolumeFiles([]));
        dispatch(requestDataActions.setRequest());
        oData.getMonitorStorageVolumeFiles(filter, function(data){
            if(data.results.length == 0){
                dispatch(requestDataActions.setRequestFail());
                if (param && param.callback) param.callback();
                return;
            }
            //通过eval() 函数可以将JSON字符串转化为对象
            var dataObj = eval(data.results[0]);
            var nodes = dataObj.Nodes;
            nodes = eval("(" + nodes + ")");

            var monitorNodes = [];
            for(var i = 0; i < nodes.length; i++) {
                if(diskIds.length == nodes.length) {
                    monitorNodes.push({name:nodes[i]});
                }
                else {
                    monitorNodes.push({name:nodes[i]});
                }
            }
            //按磁盘名排序
            monitorNodes.sort(function(a,b){
                return a.name>b.name ? 1 : -1;
            });
            dispatch(setMonitorStorageVolumeFiles(monitorNodes));
            dispatch(requestDataActions.setRequestSuccess());
            if (param && param.callback) param.callback();
        }, function(){
          if (param && param.callback) param.callback();
        });
    }
}

export function getMonitorRoomEnvironmentObject(equipmentId) {
    return dispatch => {
        var filter = [{key:"EquipmentId", value:equipmentId}];
        dispatch(setMonitorRoomEnvironmentObjects([]));
        dispatch(requestDataActions.setRequest());
        oData.getMonitorRoomEnvironmentObject(filter, function(data){
            if(data.results.length == 0){
                dispatch(requestDataActions.setRequestFail());
                return;
            }
            //通过eval() 函数可以将JSON字符串转化为对象
            var dataObj = eval(data.results[0]);
            var nodes = dataObj.Nodes;
            nodes = eval("(" + nodes + ")");

            var monitorNodes = [];
            for(var i = 0; i < nodes.length; i++) {
                if(diskIds.length == nodes.length) {
                    monitorNodes.push({name:nodes[i]});
                }
                else {
                    monitorNodes.push({name:nodes[i]});
                }
            }
            //按磁盘名排序
            monitorNodes.sort(function(a,b){
                return a.name>b.name ? 1 : -1;
            });
            dispatch(setMonitorRoomEnvironmentObjects(monitorNodes));
            dispatch(requestDataActions.setRequestSuccess());
        });
    }
}

export function getMonitorWeblogicExecuteQueue(param) {
    return dispatch => {
        var filter = [{key:"EquipmentId", value:param.equipmentId}];
        dispatch(setMonitorWeblogicExecuteQueues([]));
        dispatch(requestDataActions.setRequest());
        oData.getMonitorWeblogicExecuteQueue(filter, function(data){
            if(data.results.length == 0){
              if(param && param.callback) param.callback();
                dispatch(requestDataActions.setRequestFail());
                return;
            }
            //通过eval() 函数可以将JSON字符串转化为对象
            var dataObj = eval(data.results[0]);
            var diskNames = dataObj.DiskNames;
            diskNames = eval("(" + diskNames + ")");

            var monitorDisks = [];
            for(var i = 0; i < diskNames.length; i++) {
                if(diskIds.length == diskNames.length) {
                    monitorDisks.push({name:diskNames[i]});
                }
                else {
                    monitorDisks.push({name:diskNames[i]});
                }
            }
            //按磁盘名排序
            monitorDisks.sort(function(a,b){
                return a.name>b.name ? 1 : -1;
            });
            dispatch(setMonitorWeblogicExecuteQueues(resultArr));
            dispatch(requestDataActions.setRequestSuccess());
              if(param && param.callback) param.callback();
        }, function(){
          if(param && param.callback) param.callback();
        });
    }
}

export function getMonitorWeblogicWebApp(param) {
    return dispatch => {
        var filter = [{key:"EquipmentId", value:param.equipmentId}];
        dispatch(setMonitorWeblogicWebApps([]));
        dispatch(requestDataActions.setRequest());
        oData.getMonitorWeblogicWebApp(filter, function(data){
            if(data.results.length == 0){
              if(param && param.callback) param.callback();
                dispatch(requestDataActions.setRequestFail());
                return;
            }
            //通过eval() 函数可以将JSON字符串转化为对象
            var dataObj = eval(data.results[0]);
            var diskNames = dataObj.DiskNames;
            diskNames = eval("(" + diskNames + ")");

            var monitorDisks = [];
            for(var i = 0; i < diskNames.length; i++) {
                if(diskIds.length == diskNames.length) {
                    monitorDisks.push({name:diskNames[i]});
                }
                else {
                    monitorDisks.push({name:diskNames[i]});
                }
            }
            //按磁盘名排序
            monitorDisks.sort(function(a,b){
                return a.name>b.name ? 1 : -1;
            });
            var dataObj = eval(data.results[0].WeblogicConnectionPool);
            var resultArr = [];
            for(var i in dataObj){
              resultArr[i] = {name: dataObj[i]};
            }
            dispatch(setMonitorWeblogicWebApps(resultArr));
            dispatch(requestDataActions.setRequestSuccess());
              if(param && param.callback) param.callback();
        }, function(){
          if(param && param.callback) param.callback();
        });
    }
}

export function getMonitorWeblogicConnPool(param) {
    return dispatch => {
        var filter = [{key:"EquipmentId", value:param.equipmentId}];
        dispatch(setMonitorWeblogicConnPools([]));
        dispatch(requestDataActions.setRequest());
        oData.getMonitorWeblogicConnPool(filter, function(data){
            if(data.results.length == 0){
              if(param && param.callback) param.callback();
                dispatch(requestDataActions.setRequestFail());
                return;
            }
            //通过eval() 函数可以将JSON字符串转化为对象
            var dataObj = eval(data.results[0]);
            var diskNames = dataObj.DiskNames;
            diskNames = eval("(" + diskNames + ")");

            var monitorDisks = [];
            for(var i = 0; i < diskNames.length; i++) {
                if(diskIds.length == diskNames.length) {
                    monitorDisks.push({name:diskNames[i]});
                }
                else {
                    monitorDisks.push({name:diskNames[i]});
                }
            }
            //按磁盘名排序
            monitorDisks.sort(function(a,b){
                return a.name>b.name ? 1 : -1;
            });
            var dataObj = eval(data.results[0].WeblogicConnectionPool);
            var resultArr = [];
            for(var i in dataObj){
              resultArr[i] = {name: dataObj[i]};
            }
            dispatch(setMonitorWeblogicConnPools(resultArr));
            dispatch(requestDataActions.setRequestSuccess());
              if(param && param.callback) param.callback();
        }, function(){
          if(param && param.callback) param.callback();
        });
    }
}

export function getMonitorVMwareHostNetwork(param) {
  return (dispatch, getState) => {
  var state = getState();
  var filter = [{key:"EquipmentId", value:param.equipmentId}];
  dispatch(setMonitorVMwareHostNetworks([]));
  dispatch(requestDataActions.setRequest());
  oData.getMonitorVMwareHostNetwork(filter, function(data){
      if(data.results.length == 0){
          dispatch(requestDataActions.setRequestFail());
          return;
      }
      //通过eval() 函数可以将JSON字符串转化为对象
      var dataObj = eval(data.results[0].VmwareHostNetWork);
      var resultarr = [];
      for(var i in dataObj){
         resultarr[i] = {name: dataObj[i]};
      }
      dispatch(setMonitorVMwareHostNetworks(resultarr));
      state = getState();
      if(param && param.callback) param.callback({
        monitorVMwareHostNetworks: state.equipmentReducer.monitorVMwareHostNetworks
      });
      dispatch(requestDataActions.setRequestSuccess());
  });
  }
}

export function getMonitorVMwarePerformance(param) {
  return (dispatch, getState) => {
    var state = getState();
    var filter = [{key:"EQUIPMENT_ID", value: param.equipmentId}];
    dispatch(setMonitorVMwarePerformances([]));
    dispatch(requestDataActions.setRequest());
    oData.getMonitorVMwarePerformance(filter, function(data){
      if(data.results.length == 0){
          dispatch(requestDataActions.setRequestFail());
          return;
      }else{
        if(data.results[0].FLAG == "false"){
          Util.showMessageDialog("系统提示",data.results[0].ERROR_MSG);
        }else{
          var counterTemp = eval("("+ data.results[0].Counter +")");
          var resultarr = [];
          if(counterTemp){
            var oneArr = [];  //第一层
            var newOneArr = []; //删除重复数据后的新的  1层
            var isRepeated;
            //找到第一层
            for(var i in counterTemp){
              var curCounter = counterTemp[i];
              var dotIndex = curCounter.indexOf('.');
              oneArr[i] = counterTemp[i].substring(0,dotIndex);
            }
            //删除oneArr中的重复数据
            for(var j=0; j< oneArr.length; j++){
              isRepeated = false;
              for(var h=0; h<= newOneArr.length; h++){
                if(oneArr[j] == newOneArr[h]){
                  isRepeated = true;
                  break;
                }
              }
              if(!isRepeated){
                newOneArr.push(oneArr[j]);
              }
            }

            for(var r in newOneArr){
              var data = {
                 name:newOneArr[r],
                 children:[]
              };
              resultarr.push(data);
            }
            //找第二层
            for(var k in counterTemp){
              for(var n in newOneArr){
                var dotIndex = counterTemp[k].indexOf('.');
                if(counterTemp[k].substring(0, dotIndex) == newOneArr[n]){
                  var twoArr = {name:counterTemp[k].substring(dotIndex+1,counterTemp[k].length-1)};
                  var newTwoArr = [];
                  newTwoArr.push(twoArr);
                  resultarr[n].children.push(twoArr);
                }

              }
            }
          }
          dispatch(setMonitorVMwarePerformances(resultarr));
          state = getState();
          if(param && param.callback) param.callback({
            monitorVMwarePerformances: state.equipmentReducer.monitorVMwarePerformances
          });
          dispatch(requestDataActions.setRequestSuccess());
        }
      }
  });
  }
}

export function getMonitorWeblogicCluster(param) {
    return dispatch => {
        var filter = [{key:"EquipmentId", value:param.equipmentId}];
        dispatch(setMonitorWeblogicClusters([]));
        dispatch(requestDataActions.setRequest());
        oData.getMonitorWeblogicCluster(filter, function(data){
            if(data.results.length == 0){
              if(param && param.callback) param.callback();
                dispatch(requestDataActions.setRequestFail());
                return;
            }
            //通过eval() 函数可以将JSON字符串转化为对象
            var dataObj = eval(data.results[0].WeblogicCluster);
            var resultArr = [];
            for(var i in dataObj){
              resultArr[i] = {name: dataObj[i]};
            }
            dispatch(setMonitorWeblogicClusters(resultArr));
            dispatch(requestDataActions.setRequestSuccess());
            if(param && param.callback) param.callback();
        }, function(){
          if(param && param.callback) param.callback();
        });
    }
}

export function getMonitorWeblogicServer(param) {
    return dispatch => {
        var filter = [{key:"EquipmentId", value:param.equipmentId}];
        dispatch(setMonitorWeblogicServers([]));
        dispatch(requestDataActions.setRequest());
        oData.getMonitorWeblogicServer(filter, function(data){
            if(data.results.length == 0){
              if(param && param.callback) param.callback();
                dispatch(requestDataActions.setRequestFail());
                return;
            }
            //通过eval() 函数可以将JSON字符串转化为对象
            var dataObj = eval(data.results[0]);
            var diskNames = dataObj.DiskNames;
            diskNames = eval("(" + diskNames + ")");

            var monitorDisks = [];
            for(var i = 0; i < diskNames.length; i++) {
                if(diskIds.length == diskNames.length) {
                    monitorDisks.push({name:diskNames[i]});
                }
                else {
                    monitorDisks.push({name:diskNames[i]});
                }
            }
            //按磁盘名排序
            monitorDisks.sort(function(a,b){
                return a.name>b.name ? 1 : -1;
            });
            var dataObj = eval(data.results[0].WeblogicConnectionPool);
            var resultArr = [];
            for(var i in dataObj){
              resultArr[i] = {name: dataObj[i]};
            }
            dispatch(setMonitorWeblogicServers(resultArr));
            dispatch(requestDataActions.setRequestSuccess());
              if(param && param.callback) param.callback();
        }, function(){
          if(param && param.callback) param.callback();
        });
    }
}

export function getMonitorWeblogicHeap(param) {
    return dispatch => {
        var filter = [{key:"EquipmentId", value:param.equipmentId}];
        dispatch(setMonitorWeblogicHeaps([]));
        dispatch(requestDataActions.setRequest());
        oData.getMonitorWeblogicHeap(filter, function(data){
            if(data.results.length == 0){
              if(param && param.callback) param.callback();
                dispatch(requestDataActions.setRequestFail());
                return;
            }
            //通过eval() 函数可以将JSON字符串转化为对象
            var dataObj = eval(data.results[0]);
            var diskNames = dataObj.DiskNames;
            diskNames = eval("(" + diskNames + ")");

            var monitorDisks = [];
            for(var i = 0; i < diskNames.length; i++) {
                if(diskIds.length == diskNames.length) {
                    monitorDisks.push({name:diskNames[i]});
                }
                else {
                    monitorDisks.push({name:diskNames[i]});
                }
            }
            //按磁盘名排序
            monitorDisks.sort(function(a,b){
                return a.name>b.name ? 1 : -1;
            });
            var dataObj = eval(data.results[0].WeblogicConnectionPool);
            var resultArr = [];
            for(var i in dataObj){
              resultArr[i] = {name: dataObj[i]};
            }
            dispatch(setMonitorWeblogicHeaps(resultArr));
            dispatch(requestDataActions.setRequestSuccess());
              if(param && param.callback) param.callback();
        }, function(){
          if(param && param.callback) param.callback();
        });
    }
}

export function getMonitorAgentDiskSpaceDiskNames(param) {
  return (dispatch, getState) => {
    var state = getState();
    var filter = [{key:"EQUIPMENT_ID", value:param.equipmentId}];
    dispatch(setMonitorAgentDiskSpaceDiskNames([]));
    dispatch(requestDataActions.setRequest());
    oData.getMonitorAgentDiskSpaceDiskNames(filter, function(data){
      if(data.results.length == 0){
        dispatch(requestDataActions.setRequestFail());
        return;
      }
      //通过eval() 函数可以将JSON字符串转化为对象
      var dataObj = eval("("+ data.results[0].DISK_NAME +")");
      var resultArr = [];

      for(var i in dataObj){
        resultArr.push({name: dataObj[i]});
      }
      dispatch(setMonitorAgentDiskSpaceDiskNames(resultArr));
      state = getState();
      if(param && param.callback) param.callback({
        monitorAgentDiskSpaceDiskNames: state.equipmentReducer.monitorAgentDiskSpaceDiskNames
      });
      dispatch(requestDataActions.setRequestSuccess());
    });
  }
}

export function getMonitorAgentProcess(param) {
  return (dispatch, getState) => {
    var state = getState();
        var filter = [{key:"EQUIPMENT_ID", value:param.equipmentId}];
        dispatch(setMonitorAgentProcesss([]));
        dispatch(requestDataActions.setRequest());
        oData.getMonitorAgentProcess(filter, function(data){
            if(data.results.length == 0){
                dispatch(requestDataActions.setRequestFail());
                return;
            }
            //通过eval() 函数可以将JSON字符串转化为对象
            var dataObj = eval(data.results);
            var resultArr = [];
            for(var i in dataObj){
              resultArr[i] = {name: dataObj[i].PROCESS_NAME};
            }

            dispatch(setMonitorAgentProcesss(resultArr));
            state = getState();
            if(param && param.callback) param.callback({
              monitorAgentProcesss: state.equipmentReducer.monitorAgentProcesss
            });
            dispatch(requestDataActions.setRequestSuccess());
        });
    }
}

export function getMonitorAgentService(param) {
  return (dispatch, getState) => {
    var state = getState();
    var filter = [{key:"EQUIPMENT_ID", value:param.equipmentId}];
    dispatch(setMonitorAgentServices([]));
    dispatch(requestDataActions.setRequest());
    oData.getMonitorAgentService(filter, function(data){
        if(data.results.length == 0){
            dispatch(requestDataActions.setRequestFail());
            return;
        }
        //通过eval() 函数可以将JSON字符串转化为对象
        var dataObj = eval(data.results);
        var resultArr = [];
        for(var i in dataObj){
          resultArr[i] = {name: dataObj[i].SERVICE_NAME};
        }
        dispatch(setMonitorAgentServices(resultArr));
        state = getState();
        if(param && param.callback) param.callback({
          monitorAgentServices: state.equipmentReducer.monitorAgentServices
        });
        dispatch(requestDataActions.setRequestSuccess());
    });
  }
}

export function getMonitorAgentNetIF(param) {
  return (dispatch, getState) => {
    var state = getState();
        var filter = [{key:"EQUIPMENT_ID", value:param.equipmentId}];
        dispatch(setMonitorAgentNetIFs([]));
        dispatch(requestDataActions.setRequest());
        oData.getMonitorAgentNetIF(filter, function(data){
            if(data.results.length == 0){
                dispatch(requestDataActions.setRequestFail());
                return;
            }
            //通过eval() 函数可以将JSON字符串转化为对象
            var dataObj = eval(data.results);
            var resultarr = [];
            for(var i in dataObj){
              resultarr[i] = {status: dataObj[i].STATUS, name: dataObj[i].NET_INTERFACE_NAME};
            }
            dispatch(setMonitorAgentNetIFs(resultarr));
            state = getState();
            if(param && param.callback) param.callback({
              monitorAgentNetIFs: state.equipmentReducer.monitorAgentNetIFs
            });
            dispatch(requestDataActions.setRequestSuccess());
        });
    }
}

export function getMonitorAgentDiskInodesNames(param) {
  return (dispatch, getState) => {
    var state = getState();
        var filter = [{key:"EQUIPMENT_ID", value:param.equipmentId}];
        dispatch(setMonitorAgentDiskInodesNames([]));
        dispatch(requestDataActions.setRequest());
        oData.getMonitorAgentDiskInodesNames(filter, function(data){
            if(data.results.length == 0){
                dispatch(requestDataActions.setRequestFail());
                return;
            }
            var dataObj = eval(data.results);
            var diskIOName = [];
            if(dataObj){
              for(var i in dataObj){
                diskIOName[i] = {name: dataObj[i].DISK_INODES_NAME}
              }
            }
            dispatch(setMonitorAgentDiskInodesNames(diskIOName));
            state = getState();
            if(param && param.callback) param.callback({
              monitorAgentDiskInodesNames: state.equipmentReducer.monitorAgentDiskInodesNames
            });
            dispatch(requestDataActions.setRequestSuccess());
        });
    }
}

export function getMonitorAgentDiskIONames(param) {
  return (dispatch, getState) => {
    var state = getState();
        var filter = [{key:"EQUIPMENT_ID", value: param.equipmentId}];
        dispatch(setMonitorAgentDiskIONames([]));
        dispatch(requestDataActions.setRequest());
        oData.getMonitorAgentDiskIONames(filter, function(data){
            if(data.results.length == 0){
                dispatch(requestDataActions.setRequestFail());
                return;
            }
            //通过eval() 函数可以将JSON字符串转化为对象
            var dataObj = eval(data.results);
            var diskIOName = [];
            if(dataObj){
              for(var i in dataObj){
                diskIOName[i] = {name: dataObj[i].DISK_IO_NAME }
              }
            }
            dispatch(setMonitorAgentDiskIONames(diskIOName));
            state = getState();
            if(param && param.callback) param.callback({
              monitorAgentDiskIONames: state.equipmentReducer.monitorAgentDiskIONames
            });
            dispatch(requestDataActions.setRequestSuccess());
        });
    }
}

export function getMonitorAgentScripts(filt) {
    return dispatch => {
        var filter = [{key:"EquipmentId", value:filt.equipmentId},{key:"PathFile",value:filt.scriptPath}];
        dispatch(setMonitorAgentScripts([]));
        dispatch(requestDataActions.setRequest());
        oData.getMonitorAgentScripts(filter,function(data){
            var results = eval(data.results[0].AgentScript);
            var dataresult = [];
            if(results){
              for (var i = 0; i < results.length; i++) {
                var newData = results[i];
                dataresult[i] = {name: newData};
              }
            }
            dispatch(setMonitorAgentScripts(dataresult));
            dispatch(requestDataActions.setRequestSuccess());
        })
    }
}

export function getMonitorOracleTableSpace(param) {
    return dispatch => {
        var filter = [{key:"EQUIPMENT_ID", value:param.equipmentId}];
        dispatch(setMonitorOracleTableSpace([]));
        dispatch(requestDataActions.setRequest());
        oData.getMonitorOracleTableSpace(filter,function(data){
            var results = data.results;
            var dataresult = [];
            if(results){
              for (var i = 0; i < results.length; i++) {
                var newData = results[i].ORACLE_TABLESPACE;
                dataresult[i] = {name: newData};
              }
            }
            dispatch(setMonitorOracleTableSpace(dataresult));
            dispatch(requestDataActions.setRequestSuccess());
            if (param && param.callback) param.callback();
        }, function(){
          if (param && param.callback) param.callback();
        })
    }
}

// 新增获取监测器列表接口
//获取 SNMPMIBFile
export function getMonitorSnmpMIBFile(param, callback) {
  return (dispatch, getState) => {
    ServerEquipment.getMibFilesList(function(data){
        var results = data.files;
        dispatch(setMonitorSnmpMIBFile(results));
        callback && callback(results);
    }, (res) => {
      dispatch(setMonitorSnmpMIBFile([]));
      if (res.errmsg !== 'token invalid.' && !res.errmsg) {
        res.errmsg = "获取MIB文件列表失败。";
      }
      Util.showInterfaceErrorInfo(res);
      callback && callback();
    })
  }
}

//获取 MIB下计数器列表
export function getMonitorSnmpMIBCounter(param, callback) {
  return (dispatch, getState) => {
    const filter = {filename: param.FileName};
    ServerEquipment.getMibCounterList(filter, function(data){
        var results = data.values;
        dispatch(setMonitorSnmpMIBCounter(results));
        callback && callback(results);
    }, (res) => {
      dispatch(setMonitorSnmpMIBCounter([]));
      if (res.errmsg !== 'token invalid.' && !res.errmsg) {
        res.errmsg = "获取MIB计数器列表失败。";
      }
      Util.showInterfaceErrorInfo(res);
      callback && callback();
    })
  }
}

// 获取Mysql计数器列表
export function getMySqlMonitorCounterData(equipmentId, callback) {
	return dispatch => {
    dispatch(setMySqlMonitorCounterData([]));
    var filter = { equipmentid: equipmentId };
		ServerEquipment.getMysqlCounterList(filter, function(data){
      // console.log(data);
      dispatch(setMySqlMonitorCounterData(data));
      callback && callback(true);
		}, (res) => {
      if (res.errmsg !== 'token invalid.' && !res.errmsg) {
        res.errmsg = "获取计数器列表失败。";
      }
      Util.showInterfaceErrorInfo(res);
      callback && callback();
    });
	}
}

//获取资源属性数据
export function getResourcesPropertyDataFromID(filter, callback) {
	return dispatch => {
    dispatch(setResourcesPropertyData(null));
		dispatch(requestDataActions.setRequest());
    var monitorId = filter;
    // === 已切换到 OFBiz 新接口 /equipment/getById ===
    // 新接口返回 camelCase + attributes 嵌套，经 adaptEquipmentDetailToLegacy
    // 转成旧扁平 PascalCase 供表单回填
    ofbiz.getEquipmentById(monitorId).then(detail => {
      if (!detail) {
        dispatch(setGetResourcesPropertyDataDoneFlag(true));
        dispatch(requestDataActions.setRequestFail());
        return;
      }
      var legacyData = adaptEquipmentDetailToLegacy(detail, classEnumToEquipmentType);
      // 合并原 getEquipment 的职责（IP/型号），老项目两个 OData 端点在新后端是同一
      // 接口 /equipment/getById，避免 createEditResourcePanel.initRequiredData 重复请求两次
      var _attrs = detail.attributes || {};
      dispatch(setEquipmentServerAddress(_attrs.IP_ADDRESS || detail.ipAddress || ''));
      dispatch(setEquipmentModel(_attrs.MODEL || ''));
      dispatch(setResourcesPropertyData(legacyData));
      dispatch(setGetResourcesPropertyDataDoneFlag(true));
      dispatch(requestDataActions.setRequestSuccess());
      callback && callback(legacyData);
    }).catch(err => {
      // 设备详情获取失败（如 404 设备不存在）：提示错误 + 回调 null 让组件关 loading 并返回
      dispatch(setGetResourcesPropertyDataDoneFlag(true));
      dispatch(requestDataActions.setRequestFail());
      var errMsg = (err && err.message) || '获取设备详情失败';
      Util.showMessageDialog('系统提示', errMsg, 'error');
      callback && callback(null);
    });

    // 报警规则下拉已切换到 OFBiz 新接口 /alarmRule/list
    ofbiz.getAlarmRuleList({}, 1, 500).then(res => {
      var list = (res && res.list) || [];
      var finalResult = [];
      list.forEach(item => {
        var name = item.ruleName || item.workEffortName || '未命名';
        if (name == '默认报警') {
          finalResult.unshift({ name, recid: item.ruleId });
        } else {
          item.ruleId && finalResult.push({ name, recid: item.ruleId });
        }
      });
      finalResult.push({ name: 'NULL', recid: '' });
      dispatch(setResourcesAlarmConfig(finalResult));
      dispatch(setNavigateFromCreateMonitorViewFlag(true));
      dispatch(setGetResourcesPropertyDataDoneFlag(true));
      dispatch(requestDataActions.setRequestSuccess());
    });

  }
}

//增加资源属性数据
export function addResourceProperty(adddata,callback) {
	return (dispatch,getState) => {
		dispatch(requestDataActions.setRequest());
    var state = getState();
    dispatch(setResourcesPropertyData(null));
    dispatch(setResourcesPropertyEdit(false));
    dispatch(setEquipmentAccessoryInfos([]));
    var level = adddata.Level;
    var checkedKeys = adddata.checkedKeys.slice(0);
    delete adddata.Level;
    delete adddata.checkedKeys;
    let auditData = {
      type: 'add_resource',
      BoId: 'resource',
      desc: adddata.Title,
      OperationAssociation: adddata.association
    }
    adddata.hasOwnProperty('association') && delete adddata.association;
		// === 已切换到 OFBiz 新接口 /equipment/create ===
    // 旧字段映射：Title→fixedAssetName, ServerAddress→IP_ADDRESS, GroupId→parentFixedAssetId,
    // EquipmentType→classEnumId + EQUIP_TYPE(必填), EquipmentStatus→EQUIP_STATUS, OS→OS_TYPE 等
    var createData = {
      fixedAssetName: adddata.Title,
      parentFixedAssetId: adddata.GroupId || '',
      classEnumId: equipmentTypeToClassEnum(adddata.EquipmentType),
      EQUIP_TYPE: toEquipmentTypeCode(adddata.EquipmentType),  // 设备类型码，必填，匹配监测器模板
      IP_ADDRESS: adddata.ServerAddress || '',
      EQUIP_STATUS: adddata.EquipmentStatus || 'IT_ES_INUSE',
      OS_TYPE: adddata.OS || '',
      SSH_PORT: adddata.Port || '',
      SSH_USER: adddata.UserName || '',
      SSH_PWD: adddata.Passwd || '',
      // 数据库设备：数据库名 / 连接数（老字段 DATABASE_NAME / KeepaLives）
      DATABASE_NAME: adddata.DATABASE_NAME || '',
      KEEP_ALIVES: adddata.KeepaLives || '',
      // 数据库设备扩展参数：类型 / schema / 驱动 / URL / 凭据 / 端口
      DB_TYPE: adddata.DB_TYPE || '',
      DB_SCHEMA: adddata.Schemas || adddata.DB_SCHEMA || '',
      DB_DRIVER: adddata.DB_DRIVER || '',
      DB_URL: adddata.DB_URL || '',
      DB_USER: adddata.DB_USER || '',
      DB_PASSWORD: adddata.DB_PASSWORD || '',
      DB_PORT: adddata.DB_PORT || '',
      SNMP_COMMUNITY: adddata.Community || '',
      SNMP_VERSION: adddata.Edition || '',
      SNMP_AUTH_PROTOCOL: adddata.AuthenticationProtocol || '',
      SNMP_PRIV_PROTOCOL: adddata.PrivacyProtocol || '',
      SNMP_PRIV_PWD: adddata.PrivacyPwd || '',
      MODEL: adddata.EquipmentModel || '',
      VENDOR: adddata.VENDOR || '',
      MAC_ADDRESS: adddata.MAC_ADDRESS || '',
      CONTACT: adddata.CONTACT || '',
      DESCRIPTION: adddata.Description || '',
      // 报警配置（/alarmRule/list 的 ruleId，空字符串表示 NULL）
      AlarmConfig: adddata.AlarmConfig || '',
    };
    ofbiz.createEquipment(createData).then(data => {
      // 构造旧格式返回（下游 updateNetworkNode/saveResourcesData 期望 {RecId, Title}）
      var legacyData = { RecId: data && data.equipmentId, Title: adddata.Title, EquipmentType: adddata.EquipmentType };
        dispatch(updateNetworkNode({monitorId: legacyData.RecId, monitorName: legacyData.Title, Level: level}, function(res){
          dispatch(updateNetworkRelation({monitorId: legacyData.RecId, Level: level, checkedKeys, checkedKeys_old: []}, function(){
            dispatch(requestDataActions.setRequestSuccess());
            dispatch(setNavigateFromCreateMonitorViewFlag(true));
            dispatch(saveResourcesData(legacyData));
            if(adddata.EquipmentType == "SNMPUnix" || adddata.EquipmentType == "SNMPWindows"|| adddata.EquipmentType == "Unix" || adddata.EquipmentType == "Windows"
            || adddata.EquipmentType == "CheckPoint" || adddata.EquipmentType == "Netscreen" ||adddata.EquipmentType == "Network"
            || adddata.EquipmentType == "TOPSEC" || adddata.EquipmentType == "WirelessNetwork"){
                dispatch(setResourcesPropertyData(data));
                dispatch(setResourcesPropertyEdit(true));
                // dispatch(getEquipmentAccessoryInfos(data.RecId));
                if (res == 'success') {
                  Util.showMessageDialog("系统提示","资源增加成功。");
                } else {
                  Util.showMessageDialog("系统提示","资源增加成功，但其所属层级添加失败。");
                }
            }else if(adddata.EquipmentType == "SqlServer" || adddata.EquipmentType == "Mysql" || adddata.EquipmentType == "EMCStorage" || adddata.EquipmentType == "IBMStorage"
            || adddata.EquipmentType == "Emerson" || adddata.EquipmentType == "Raritan" || adddata.EquipmentType == "Santakups" || adddata.EquipmentType == "DME3000"
            || adddata.EquipmentType == "APEM6100" || adddata.EquipmentType == "LiebertCorp" || adddata.EquipmentType == "VMware" || adddata.EquipmentType == "Oracle"
            || adddata.EquipmentType == "Postgresql"){
                dispatch(setResourcesPropertyData(data));
                dispatch(setResourcesPropertyEdit(true));
                // dispatch(getEquipmentAccessoryInfos(data.RecId));
                if (res == 'success') {
                  Util.showMessageDialog("系统提示","资源增加成功。");
                } else {
                  Util.showMessageDialog("系统提示","资源增加成功，但其所属层级添加失败。");
                }
            }else{
              if (res == 'success') {
                Util.showMessageDialog("系统提示","资源增加成功。");
              } else {
                Util.showMessageDialog("系统提示","资源增加成功，但其所属层级添加失败。");
              }
            }
            dispatch(createOperationAudit({ ...auditData, OperationResults: 1 }));
            callback && callback(legacyData);
          }));
        }));
    }).catch(status => {
      if (status && status.code == '10037') {
        let _label = Util.NetEquipment.indexOf(adddata.EquipmentType) > -1 ? '网络设备监测授权' : '服务器与应用监测授权';
        let tipText = `您购买的${_label}点数已达最高点数`;
        Util.showMessageDialog('温馨提示', `${tipText}${Util.authenanceTip}`, 'warning');
        auditData.desc += "/原因：" + tipText
      } else {
        Util.showMessageDialog("系统提示","资源增加失败。");
      }
      dispatch(requestDataActions.setRequestFail());
      dispatch(createOperationAudit({ ...auditData, OperationResults: 0 }));
      callback && callback();
    });
  }
}

//更新资源属性数据
export function updateResourcesProperty(updata,callback) {
	return (dispatch,getState) => {
		dispatch(requestDataActions.setRequest());
    var state = getState();
    var level = updata.Level;
    var checkedKeys = updata.checkedKeys.slice(0);
    var checkedKeys_old = updata.checkedKeys_old.slice(0);
    delete updata.Level;
    delete updata.checkedKeys;
    delete updata.checkedKeys_old;
    const auditData = {
      type: 'edit_resource',
      // BoId: updata.RecId,
      BoId: 'resource',
      desc: updata.Title,
      OperationAssociation: updata.association
    }
    updata.hasOwnProperty('association') && delete updata.association;
    // === 已切换到 OFBiz 新接口 /equipment/update ===
    var updateData = {
      equipmentId: updata.RecId,
      fixedAssetName: updata.Title,
      classEnumId: equipmentTypeToClassEnum(updata.EquipmentType),
      // 设备型号码不可在编辑时更改：回显的 EquipmentType 是从 classEnumId 反推的大类
      //（如 DataBase），直接推导会覆盖真实型号（Equipment.Mysql→Equipment.DataBase），
      // 导致监测器模板按 MonitorRange 过滤时匹配不上。优先用设备真实 EQUIP_TYPE。
      EQUIP_TYPE: updata.equipType || getSelectedEquipmentEquipTypeFromState(getState()) || toEquipmentTypeCode(updata.EquipmentType),
      IP_ADDRESS: updata.ServerAddress || '',
      OS_TYPE: updata.OS || '',
      SSH_PORT: updata.Port || '',
      SSH_USER: updata.UserName || '',
      SSH_PWD: updata.Passwd || '',
      // 数据库设备：数据库名 / 连接数（老字段 DATABASE_NAME / KeepaLives）
      DATABASE_NAME: updata.DATABASE_NAME || '',
      KEEP_ALIVES: updata.KeepaLives || '',
      // 数据库设备扩展参数：类型 / schema / 驱动 / URL / 凭据 / 端口
      DB_TYPE: updata.DB_TYPE || '',
      DB_SCHEMA: updata.Schemas || updata.DB_SCHEMA || '',
      DB_DRIVER: updata.DB_DRIVER || '',
      DB_URL: updata.DB_URL || '',
      DB_USER: updata.DB_USER || '',
      DB_PASSWORD: updata.DB_PASSWORD || '',
      DB_PORT: updata.DB_PORT || '',
      SNMP_COMMUNITY: updata.Community || '',
      SNMP_VERSION: updata.Edition || '',
      SNMP_AUTH_PROTOCOL: updata.AuthenticationProtocol || '',
      SNMP_PRIV_PROTOCOL: updata.PrivacyProtocol || '',
      SNMP_PRIV_PWD: updata.PrivacyPwd || '',
      MODEL: updata.EquipmentModel || '',
      VENDOR: updata.VENDOR || '',
      MAC_ADDRESS: updata.MAC_ADDRESS || '',
      CONTACT: updata.CONTACT || '',
      DESCRIPTION: updata.Description || '',
      // 报警配置（/alarmRule/list 的 ruleId，空字符串表示 NULL）
      AlarmConfig: updata.AlarmConfig || '',
    };
    ofbiz.updateEquipment(updateData).then(data => {
        dispatch(updateNetworkNode({monitorId: updata.RecId, monitorName: updata.Title, Level: level}, function(res){
          dispatch(updateNetworkRelation({monitorId: updata.RecId, Level: level, checkedKeys, checkedKeys_old}, function(){
            if (res == 'success') {
              dispatch(requestDataActions.setRequestSuccess());
      				Util.showMessageDialog("系统提示","资源修改成功。");
            }
            else {
              dispatch(requestDataActions.setRequestFail());
      				Util.showMessageDialog("系统提示","资源修改成功，但其所属层级修改失败。");
            }
            dispatch(createOperationAudit({ ...auditData, OperationResults: 1 }));
            callback && callback();
          }));
        }));
    }).catch(err => {
			dispatch(requestDataActions.setRequestFail());
			Util.showMessageDialog("系统提示","资源修改失败。");
      dispatch(createOperationAudit({ ...auditData, OperationResults: 0 }));
      callback && callback();
		});
  }
}

//更新报警规则资源属性数据
export function updateResourcesPropertyAlarm(updata,callback) {
	return (dispatch,getState) => {
		dispatch(requestDataActions.setRequest());
    // === 已切换到 OFBiz 新接口 /equipment/update ===
    ofbiz.updateEquipment({
      equipmentId: updata.RecId,
      fixedAssetName: updata.Title,
    }).then(data => {
				dispatch(requestDataActions.setRequestSuccess());
      dispatch(setNavigateFromCreateMonitorViewFlag(true));
      dispatch(setEquipmentMonitorUrl("/equipmentManage/MonitorPage"));
      callback && callback();
		}).catch(err => {
			dispatch(requestDataActions.setRequestFail());
      dispatch(setNavigateFromCreateMonitorViewFlag(true));
      callback && callback();
		});
  }
}

export function getResourcesAlarmConfig(filter) {
	return dispatch => {
		dispatch(requestDataActions.setRequest());
    // === 已切换到 OFBiz 新接口 /alarmRule/list ===
    // 旧返回 {results:[{RecId, AlarmName}]}，新返回 {list:[{ruleId, ruleName}]}
    ofbiz.getAlarmRuleList({}, 1, 500).then(res => {
      var list = (res && res.list) || [];
      var finalResult = [];
      list.forEach(item => {
        var name = item.ruleName || item.workEffortName || '未命名';
        if (name == '默认报警') {
          finalResult.unshift({ name, recid: item.ruleId });
        } else {
          item.ruleId && finalResult.push({ name, recid: item.ruleId });
        }
      });
      finalResult.push({ name: 'NULL', recid: '' });
      dispatch(setResourcesAlarmConfig(finalResult));
      dispatch(setGetResourcesPropertyDataDoneFlag(true));
      dispatch(requestDataActions.setRequestSuccess());
    }).catch(err => {
      // 失败也提供 NULL 选项，不阻断编辑流程
      dispatch(setResourcesAlarmConfig([{ name: 'NULL', recid: '' }]));
      dispatch(setGetResourcesPropertyDataDoneFlag(true));
      dispatch(requestDataActions.setRequestSuccess());
    });
  }
}

//资源- 测试连接
export function equipmentTestConnection(filter, callback) {
	return dispatch => {
    const auditData = {
      type: 'test_resource',
      BoId: 'resource',
      desc: filter.name,
      OperationAssociation: filter.association
    }
    const createAudit = filter.hasOwnProperty('association') ? true : false;
    filter.hasOwnProperty('name') && delete filter.name;
    filter.hasOwnProperty('association') && delete filter.association;
    // === 已切换到 OFBiz 新接口 /collector/testConnection ===
    // 组件传的 filter 结构：{Type, EquipmentInfo:{ServerAddress,Community,Port,...}, RecId}
    // 后端参数：host(目标地址)、community(SNMP)、port(SNMP端口)、equipmentId(设备ID)
    var equipInfo = filter.EquipmentInfo || filter.equipmentInfo || filter;
    // 兼容大小写：表单字段 ServerAddress 经 parseObjectKeyToLowercase 后变为 serveraddress
    var host = equipInfo.ServerAddress || equipInfo.serverAddress || equipInfo.serveraddress || equipInfo.host || equipInfo.ipaddress || equipInfo.ip || '';
    var community = equipInfo.Community || equipInfo.community || 'public';
    var port = equipInfo.Port || equipInfo.port || '';
    // 编辑模式下用 RecId 作为 equipmentId（后端自动取 IP_ADDRESS）
    var equipmentId = filter.RecId || filter.recId || filter.equipmentId || '';
    // Windows 设备走 WMI 协议测试（排除 SNMPWindows 等含 win 字样类型）
    var eqType = (equipInfo.EquipmentType || equipInfo.equipmenttype || '') + '';
    var eqTypeShort = eqType.replace(/^Equipment\./i, '').toLowerCase();
    var testProtocol = '';
    if (eqTypeShort === 'windows') {
      testProtocol = 'IT_PROTO_WMI';
    }
    ofbiz.testConnection({
      host: host,
      equipmentId: equipmentId,
      community: community,
      port: port,
      protocol: testProtocol,
      user: equipInfo.UserName || equipInfo.username || '',
      password: equipInfo.Passwd || equipInfo.passwd || '',
    }).then(data => {
      // 新接口 data 含连接结果（reachable/snmpResult/sysDescr 等）
      var reachable = data && (data.reachable || data.success || data.code === 0);
      var _msg = '';
      if (reachable) {
        _msg = '连接成功';
        if (data.sysDescr || data.msg) {
          _msg += ':' + (data.sysDescr || data.msg);
        } else {
          _msg += '。';
        }
      } else {
        _msg = '连接失败';
        if (data && data.message) {
          _msg += ':' + data.message;
        } else {
          _msg += '。';
        }
      }
      Util.showMessageDialog("系统提示", _msg);
      createAudit && dispatch(createOperationAudit({ ...auditData, OperationResults: _msg.replace(/。$/, '') }));
      if (callback) {
        callback({flag: reachable, msg: _msg});
      }
      dispatch(setTestPropertyData(data));
    }).catch(err => {
      // 显示后端返回的具体错误信息（如 "host/serverAddress/equipmentId 不能为空"）
      var errMsg = (err && err.message) || '连接失败。';
      Util.showMessageDialog("系统提示", errMsg, 'error');
      createAudit && dispatch(createOperationAudit({ ...auditData, OperationResults: errMsg.replace(/。$/, '') }));
      if(callback) callback({flag: false, msg: errMsg});
    });
  }
}

//资源- 获取资源型号
export function getResourceEquipmentModel(filt) {
	return dispatch => {
    var filter = [{key:"MibType", value:filt.type},{key:"Vendor", value:filt.vendor}];
		oData.getResourceEquipmentModel(filter, function(data){
			if(!data.results){
				dispatch(requestDataActions.setRequestFail());
				return;
			}else{
        var results = data.results;
        var finalResult = [{id:0, name:'other'}];
        for(var i in results){
          finalResult.push({id:parseInt(i)+1, name:results[i].MibModel});
        }
  			dispatch(setResourceEquipmentModel(finalResult));
      }
			dispatch(requestDataActions.setRequestSuccess());
		});
  }
}

//资源- 获取资源型号 - 服务器
export function getResourceEquipmentModelServer(filt) {
	return dispatch => {
    var filter = [{key:"MibType", value:filt.type},{key:"MibSubType", value:filt.subtype}];
		oData.getResourceEquipmentModel(filter, function(data){
			if(!data.results){
				dispatch(requestDataActions.setRequestFail());
				return;
			}else{
        var results = data.results;
        var finalResult = [];
        for(var i in results){
          results[i].MibModel && finalResult.push({id:parseInt(i)+1, name:results[i].MibModel});
        }
        finalResult.push({id:0, name:'other'});
  			dispatch(setResourceEquipmentModel(finalResult));
      }
			dispatch(requestDataActions.setRequestSuccess());
		});
  }
}

export function getResourceModal(param, callback) {
  return (dispatch, getState) => {
    ServerEquipment.getResourceModal(param, function(data){
      if (data) {
        var success = 'IP：' + param.ServerAddress + '，型号：' + (data.MibModel || 'other');
        dispatch(setResourceModal(data.MibModel || 'other'));
        Util.showMessageDialog("系统提示", success, 'success');
      }
      callback && callback({
        resourceModal: getState().equipmentReducer.resourceModal
      });
    }, (res) => {
      dispatch(setResourceModal('other'));
      if (res.errmsg !== 'token invalid.' && !res.errmsg) {
        res.errmsg = "获取失败, 配置参数不正确。";
      }
      Util.showInterfaceErrorInfo(res);
      callback && callback();
    });
  }
}
//获取资源附属信息：磁盘监测器、接口监测器、接口速度、接口状态、进程监测器
export function getEquipmentAccessoryInfos(equipmentId) {
    return dispatch => {
        // ⚠️ 旧接口 /bods.svc/equipmentInIs 走旧鉴权会阻断。
        // 新后端可用 /metric/byEquipment（按设备查监测器读数）替代，但返回结构差异大，
        // 待设备详情功能迁移时对接。暂返回空不阻断。
        dispatch(setEquipmentAccessoryInfos([]));
        dispatch(requestDataActions.setRequestSuccess());
    }
}

export function operateMonitor(param) {
  return (dispatch, getState) => {
    var state = getState();
    var filter = [{key:"RecId",value:param.equipmentId},{key:"operate",value:param.operator},
    {key:"MonitorType",value:param.MonitorType},{key:"GroupId",value:param.GroupId}];
    oData.operateMonitor(filter, function(data){
      if(data.results.length == 0){
        dispatch(requestDataActions.setRequestFail());
        Util.showMessageDialog("提示","操作失败。");
        return;
      }else{
        if(data.results[0].Return == "true"){
          if(filter[1].value == "delete"){
            Util.showMessageDialog("提示","删除成功。");
          } else if(filter[1].value == "start"){
            Util.showMessageDialog("提示","启动成功。");
          } else if(filter[1].value == "disabled"){
            Util.showMessageDialog("提示","禁用成功。");
          }
          state = getState();
          if(param && param.callback) param.callback({
            operateMonitor: state.equipmentReducer.operateMonitor
          });
          dispatch(requestDataActions.setRequestSuccess());
        }
      }
    });
  }
}

//刷新监测器
export function refreshMonitor(param, callback, errorCallback, noTip) {
    return dispatch => {
        // === 已切换到 OFBiz 新接口 /monitor/refresh ===
        var monitorId = (param.ids && param.ids[0]) || param.monitorId || '';
        ofbiz.refreshMonitor(monitorId).then(data => {
            if(!noTip) {
                Util.showMessageDialog("系统提示","刷新监测器成功。");
            }
            // 适配旧返回格式（旧返回数组，每项含刷新结果）
            callback && callback([data || {}]);
        }).catch(err => {
            Util.showMessageDialog("系统提示","刷新监测器失败。", 'error');
            errorCallback && errorCallback(err);
        });
    }
}

//刷新资源监测器
var sout = null, time = 5, count = 0; //关闭倒计时
export function refreshResourceMonitors(monitors, callback, errorCallback, auditData) {
    return (dispatch, getState) => {
      count = 0;
      if (sout) {
        clearInterval(sout);
        time = 5;
        $('#refreshAutoClose').text(`关闭`);
      }
      dispatch(setRefreshResourceMonitors([]));
      if (monitors.length) {
        $('#PanelHeaderTitle').text(`正在刷新监测器(1/${monitors.length}): ${monitors[0].Title}`);
        dispatch(refreshMonitorByStep(monitors, () => {
          callback && callback();
          auditData && dispatch(createOperationAudit({ ...auditData, OperationResults: 1 }));
        }));
      } else {
        callback && callback();
      }
    }
}

export function refreshMonitorByStep(monitors, callback) {
    return (dispatch, getState) => {
      if (!$('#PanelHeaderTitle').length) {
        return;
      }
      // === 已切换到 OFBiz 新接口 /monitor/refresh ===
      var monitorId = monitors[count].RecId;
      var curMonitor = monitors[count];
      ofbiz.refreshMonitor(monitorId).then(data => {
        const {refreshResourceMonitors} = getState().equipmentReducer;
        if (count < monitors.length - 1) {
          var nextItem = monitors[count + 1];
          $('#PanelHeaderTitle').text(`正在刷新监测器(${count + 2}/${monitors.length}): ${nextItem.Title}`);
        }
        count ++;
        if (data) {
          // 适配旧 rest/refresh/monitor 返回结构 {refreshtime, monitor:{Title,MonitorStatus,MonitorValue...}}，
          // 新接口返回扁平 {status, costMs, collectTime, latestMetrics[]}，Title 等列表字段取自列表行数据
          var _metrics = (data.latestMetrics || []).map(function(m) {
            var _v = m.meterValue != null ? m.meterValue : (m.readingValue != null ? m.readingValue : '');
            return (m.productMeterTypeId || '') + '=' + _v;
          }).join(',');
          var _item = {
            refreshtime: data.costMs != null ? (data.costMs + 'ms') : '-',
            monitor: Object.assign({}, curMonitor, {
              MonitorStatus: data.status || curMonitor.MonitorStatus,
              MonitorValue: _metrics,
              LastCollectTime: data.collectTime
            })
          };
          dispatch(setRefreshResourceMonitors([...refreshResourceMonitors, _item]));
        }
        if (count < monitors.length) {
          dispatch(refreshMonitorByStep(monitors, callback));
        }
        else if (count == monitors.length) {
          $('#PanelHeaderTitle').text(`刷新完成(${count}个监测器)`);
          // 回调
          callback && callback();
          $('#refreshAutoClose').text(`关闭(${time})`);
          sout = setInterval(() => {
            time --;
            if (time == 0 || !getState().deviceMonitorTreeReducer.resourcePanelShow) {
              dispatch(openResourcePanel(''));
              clearInterval(sout);
              return;
            }
            $('#refreshAutoClose').text(`关闭(${time})`);
          }, 1000)
        }
      }).catch(err => {
        const {refreshResourceMonitors} = getState().equipmentReducer;
        dispatch(setRefreshResourceMonitors([...refreshResourceMonitors, {
          refreshtime: "-",
          monitor: { Title: monitors[count].Title}
        }]));
        count ++;
        if (count < monitors.length) {
          dispatch(refreshMonitorByStep(monitors, callback));
        } else if (count == monitors.length) {
          $('#PanelHeaderTitle').text(`刷新完成(${count}个监测器)`);
          callback && callback();
        }
      });
    }
}

//保存窗口编辑数据
export function insertEquipmentWindowStore(windowId, equipmentItem, callback) {
    return (dispatch, getState) => {
        var record = getState().equipmentReducer.equipmentWindowStore;
        record[windowId] = equipmentItem;
        dispatch(setEquipmentWindowStore(record));
        if (callback) callback(record);
    }
}

//获取窗口编辑数据
export function getEquipmentWindowStoreByWinId(windowId, callback) {
    return (dispatch, getState) => {
        if (callback) callback(getState().equipmentReducer.equipmentWindowStore[windowId]);
    }
}

//更新窗口编辑数据
export function updateEquipmentWindowStoreByWinId(windowId, items, callback) {
    return (dispatch, getState) => {
      var equipmentWindowStore = getState().equipmentReducer.equipmentWindowStore;
      var record = equipmentWindowStore[windowId];
      items.map((item)=>{
        record[item.key] = item.value;
      });
      equipmentWindowStore[windowId] = record;
      dispatch(setEquipmentWindowStore(equipmentWindowStore));
      if (callback) callback(record);
    }
}

//删除窗口编辑数据
export function removeEquipmentWindowStoreByWinId(windowId, callback) {
    return (dispatch, getState) => {
      var record = getState().equipmentReducer.equipmentWindowStore;
      delete record[windowId];
      dispatch(setEquipmentWindowStore(record));
      if (callback) callback(true);
    }
}

// 获取监测器国际化
export function getMonitorLocale(filters, callback) {
    return (dispatch, getState) => {
      var _monitorLocale = filters.map((item) => {
        return { "monitorId": "", "monitorType": item.monitorType || '', "MonitorRange": item.resourceType || '', "key": item.key || '', "locale": "zh" }
      });
      ServerEquipment.getMonitorLocale(_monitorLocale, (result) => {
        if (result.errorCode) {
          callback && callback();
          return;
        }
        callback && callback(result);
      })
    }
}

// 获取状态报表数据
export function getStatusReportData(filters, callback) {
	return dispatch => {
    const query = normalizeStatusReportQuery(filters);
		ofbiz.getReportStatusReport(query).then((data) => {
      dispatch(setMonitorStatusReportData(normalizeStatusReportData(data, filters)));
      callback && callback(true);
		}).catch((res) => {
      if (res.errmsg !== 'token invalid.' && !res.errmsg) {
        res.errmsg = "获取状态报表数据失败。";
      }
      Util.showInterfaceErrorInfo(res);
      callback && callback(false);
    });
	}
}

// 批量获取状态报表数据
export function batchGetStatusReportData(filters, callback, skipTip) {
	return dispatch => {
    let count = 0;
    let failCount = 0;
    let batchMonitorStatusReportData = [];
    if (filters.length) {
      filters.forEach((filter) => {
        const query = normalizeStatusReportQuery(filter);
        ofbiz.getReportStatusReport(query).then((data) => {
          count++;
          batchMonitorStatusReportData.push(normalizeStatusReportData(data, filter));
          if (count === filters.length) {
            if (failCount) {
              Util.showMessageDialog("提示", `${count-failCount}个监测器状态获取成功, ${failCount}个监测器状态获取失败`, 'warning');
            }
            if (!skipTip) {
              dispatch(setBatchMonitorStatusReportData(batchMonitorStatusReportData));
            }
            callback && callback(true, batchMonitorStatusReportData);
          }
    		}).catch((res) => {
          count++;
          failCount++;
          batchMonitorStatusReportData.push({
            monitorId: filter.monitorId || filter.MonitorId,
            monitorName: filter.monitorName || filter.MonitorName,
            count: "",
            current_value: "",
            disabled: "",
            error: "",
            good: "",
            warning: "",
            percent_count: "0",
            percent_disabled: "0.0",
            percent_error: "0.0",
            percent_good: "0.0",
            percent_warning: "0.0",
            records: []
          });
          if (count === filters.length) {
            if (failCount) {
              if (failCount === count) {
                Util.showMessageDialog('提示', '获取状态报表数据失败');
              } else {
                Util.showMessageDialog("提示", `${count-failCount}个监测器状态获取成功, ${failCount}个监测器状态获取失败`, 'warning');
              }
            }
            if (res.errmsg !== 'token invalid.' && !res.errmsg) {
              res.errmsg = "获取状态报表数据失败。";
            }
            if (!skipTip) {
              dispatch(setBatchMonitorStatusReportData(batchMonitorStatusReportData));
            }
            Util.showInterfaceErrorInfo(res);
            callback && callback(false, batchMonitorStatusReportData);
          }
        });
      });
    } else {
      dispatch(setBatchMonitorStatusReportData(batchMonitorStatusReportData));
      callback && callback(true, batchMonitorStatusReportData);
    }
	}
}

function normalizeStatusReportQuery(filters = {}) {
  return {
    monitorId: filters.monitorId || filters.MonitorId,
    startTime: filters.startTime,
    endTime: filters.endTime,
  };
}

function normalizeStatusReportData(data = {}, filters = {}) {
  const source = data.state || data;
  const records = (source.records || source.recored || []).slice().reverse();
  return {
    ...source,
    monitorId: filters.monitorId || filters.MonitorId || source.monitorId,
    monitorName: filters.monitorName || filters.MonitorName || source.monitorName,
    records,
  };
}

// 获取安全群组
export function getSafeGroupList(callback) {
	return dispatch => {
    // === 已切换到 OFBiz 新接口 /dict/securityGroups ===
    // 旧接口返回 { groups: [{Id, Name}] }，新接口返回 list: [{groupId, groupName, description}]
    // 映射成组件期望的 {Id, Name} 结构。注意：新接口 groupName 可能为空，
    // 此时用 description 兜底作为显示名（如 IT_ADMIN -> "超级管理员（全部模块权限）"）
    ofbiz.getSecurityGroups().then(list => {
      const mapped = (list || []).map(item => ({
        Id: item.groupId,
        Name: item.groupName || item.description || item.groupId,
        Description: item.description,
      }));
      dispatch(setSafeGroupList(mapped));
      callback && callback();
    }).catch(err => {
      dispatch(setSafeGroupList([]));
      callback && callback();
    });
	}
}

// 获取任务计划
export function getTaskScheduler(callback) {
	return dispatch => {
		// 已切换到 OFBiz 新接口 /monitor/taskplan/list（Cookie 鉴权）。
		// 后端内置默认两条（7*24 / 5*8，与老库 ecctaskplan 初始化数据一致），
		// 返回字段保持旧 PascalCase 契约：RecId / TaskName / Instruction / Model / Status，
		// 任务计划列表页与新增监测器表单的任务计划下拉直接消费。
		ofbiz.getTaskPlanList().then(list => {
			dispatch(setTaskSchedulerList(list || []));
			callback && callback(1);
		}).catch(err => {
			dispatch(setTaskSchedulerList([]));
			callback && callback(1);
		});
	}
}

export function addTaskScheduler(param, callback) {
  return dispatch => {
    // === EccTaskPlan 旧接口已下线，无对应新接口（doc/07 collector 为固定频率语义，不匹配排程时刻表）===
    // 不再调用旧接口（避免 "token invalid." 误跳登录页），提示功能暂不可用。
    Util.showMessageDialog("系统提示","任务计划自定义功能暂不可用（旧接口 EccTaskPlan 已下线，新接口待后端提供）。");
    callback && callback();
  }
}

export function updateTaskScheduler(param, callback) {
  return dispatch => {
    // === 同上：EccTaskPlan 旧接口已下线 ===
    Util.showMessageDialog("系统提示","任务计划自定义功能暂不可用（旧接口 EccTaskPlan 已下线，新接口待后端提供）。");
    callback && callback();
  }
}

export function deleteTaskSchedulers(params, callback) {
  return dispatch => {
    const _tasks = params.map(item => item.TaskName);;
    let auditData = {
      type: 'delete_taskplan',
      BoId: 'setting',
      desc: _tasks.join(','),
      OperationAssociation: '系统设置/资源监测设置/任务计划'
    }
    // callback && callback();
    // return;
    // === EccTaskPlan 旧接口已下线，无对应新接口 ===
    // 删除任务计划功能暂不可用，不再调用旧接口（避免 "token invalid." 误跳登录页）
    Util.showMessageDialog("系统提示","任务计划自定义功能暂不可用（旧接口 EccTaskPlan 已下线，新接口待后端提供）。");
    callback && callback();
  }
}

//获取资源3D层级数据
export function getNetworkNodeType(callback){
  return dispatch => {
    // ⚠️ 后端 OFBiz 新接口无 NetWorkNodeType（拓扑节点类型字典）直接对应。
    // 旧接口 /bods.svc/NetWorkNodeType 走旧鉴权会阻断页面。
    // 14 个设备创建表单（createResourceWindow_*）的 componentDidMount 都依赖
    // networkNodeType，按 TypePosition 过滤取默认 Level（RecId）。
    // TypePosition 含义：'1'=网络设备层、'2'=服务器层、'3'=应用层。
    // 这里返回三种 Position 的默认值兜底，等后端补 /topo/nodeTypes 后再对接真实数据。
    const defaultNodeTypes = [
      { RecId: 'level_network', TypePosition: '1', TypeName: '网络设备' },
      { RecId: 'level_server',  TypePosition: '2', TypeName: '服务器' },
      { RecId: 'level_app',     TypePosition: '3', TypeName: '应用系统' },
    ];
    dispatch(setNetworkNodeType(defaultNodeTypes));
    callback && callback(defaultNodeTypes);
  }
}

//获取资源所属层级
export function getNodeType(monitorId, callback){
  return dispatch => {
    // ⚠️ 旧接口 /bods.svc/NetWorkNode（按设备ID查拓扑节点）已废弃。
    // 新接口 /topo/getNodes 需要 mapId，编辑资源时没有拓扑图上下文。
    // 拓扑层级是 3D 视图的附加功能，不影响设备属性编辑。
    // 返回空数组，组件据此显示"无层级"。
    dispatch(setEquipmentNodeType({type: ''}));
    callback && callback([]);
  }
}

//更新NetWorkNode表
export function updateNetworkNode(params, callback) {
  return dispatch => {
    // ⚠️ 旧接口 /bods.svc/NetWorkNode（全局拓扑节点表）已废弃。
    // 新接口 /topo/nodeCreate 需要 mapId（所属拓扑图 ID），创建设备时没有这个上下文。
    // 拓扑节点是 3D 视图的附加功能，不影响设备数据本身。
    // 这里直接放行（callback success），设备创建流程能正常完成。
    // 拓扑节点管理等拓扑页专项迁移时（有 mapId 上下文）再走 /topo/nodeCreate、/topo/nodeUpdate。
    callback && callback('success');
  }
}

//获取资源3D节点关联关系
export function getNetworkRelation(monitorId, callback){
  return dispatch => {
    // ⚠️ 旧接口 /bods.svc/NetWorkRelation（按设备ID查拓扑连线）已废弃。
    // 新接口 /topo/getEdges 需要 mapId，编辑资源时没有拓扑图上下文。
    // 返回空数组，组件 componentWillReceiveProps 的 networkRelations.map 不会报错，
    // "关联关系"面板显示为空（无勾选的关联设备）。
    dispatch(setNetworkRelations([]));
    callback && callback([]);
  }
}

//更新NetWorkRelation表
export function updateNetworkRelation(params, callback) {
  return (dispatch,getState) => {
    // ⚠️ 旧接口 /bods.svc/NetWorkRelation（全局拓扑连线表）已废弃。
    // 新接口 /topo/edgeCreate 需要 mapId（拓扑图 ID），创建设备时没有这个上下文。
    // 拓扑连线是 3D 视图的附加功能，不影响设备数据本身。
    // 这里直接放行，设备创建/编辑流程能正常完成。
    // 等拓扑页专项迁移时（有 mapId 上下文）再走 /topo/edgeCreate、/topo/edgeDelete。
    callback && callback();
  }
}

//获取设备维护信息   mib表
export function getEquipmentInfoMaintenanceData(callback){
  return dispatch => {
    oData.getEquipmentInfoMaintenanceData(function(data){
      dispatch(setEquipmentInfoMaintenanceData(data));
      callback && callback(true);
    }, function(status) {
      dispatch(setEquipmentInfoMaintenanceData([]));
      callback && callback(false);
    });
  }
}

//添加设备维护信息
export function addEquipmentMaintenanceInfo(params, callback){
  return dispatch => {
    let auditData = {
      type: 'add_equipment_info_maintenance',
      BoId: 'setting',
      OperationAssociation: '系统设置/设备信息维护'
    };
    if (params.hasOwnProperty('SysOID')) {
      auditData.desc = '/添加设备信息库/' + params.Vendor + '/' + params.MibType + '/' + params.MibSubType;
    } else {
      auditData.desc = '/添加厂商/' + params.Vendor;
    }
    oData.addEquipmentMaintenanceInfo(params, function(data){
      Util.showMessageDialog('提示', '添加成功');
      dispatch(createOperationAudit({ ...auditData, OperationResults: 1 }));
      callback && callback(true);
    }, function(status) {
      Util.showMessageDialog('提示', '添加失败');
      dispatch(createOperationAudit({ ...auditData, OperationResults: 0 }));
      callback && callback(false);
    });
  }
}

//修改设备维护信息
export function updateEquipmentMaintenanceInfo(params, callback){
  return dispatch => {
    let auditData = {
      type: 'update_equipment_info_maintenance',
      BoId: 'setting',
      desc: '/更新设备信息库/' + params.Vendor,
      OperationAssociation: '系统设置/设备信息维护'
    };
    oData.updateEquipmentMaintenanceInfo(params, function(data){
      Util.showMessageDialog('提示', '修改成功');
      dispatch(createOperationAudit({ ...auditData, OperationResults: 1 }));
      callback && callback(true);
    }, function(status) {
      Util.showMessageDialog('提示', '修改失败');
      dispatch(createOperationAudit({ ...auditData, OperationResults: 0 }));
      callback && callback(false);
    });
  }
}

//删除设备维护信息
export function deleteEquipmentMaintenanceInfo(params, callback){
  return dispatch => {
    let count = 0, failCount = 0;
    let auditData = {
      type: 'delete_equipment_info_maintenance',
      BoId: 'setting',
      desc: '/删除设备信息库/',
      OperationAssociation: '系统设置/设备信息维护'
    };
    params.forEach((RecID) => {
      oData.deleteEquipmentMaintenanceInfo(RecID, function(data){
        count++;
        if (count == params.length) {
          if (failCount) {
            Util.showMessageDialog('提示', failCount + '条删除失败,' + (count - failCount) + '删除成功', 'warning');
            auditData.desc += `共${count},${failCount}条设备信息删除失败`;
            dispatch(createOperationAudit({ ...auditData, OperationResults: 0 }));
            callback && callback(false);
          } else {
            Util.showMessageDialog('提示', '删除成功');
            auditData.desc += `共删除${count}条设备信息`;
            dispatch(createOperationAudit({ ...auditData, OperationResults: 1 }));
            callback && callback(true);
          }
        }
      }, function(status) {
        count++;
        failCount++;
        if (count == params.length) {
          if (failCount == count) {
            Util.showMessageDialog('提示', '删除失败');
            auditData.desc += `删除失败`;
          } else {
            Util.showMessageDialog('提示', failCount + '条删除失败,' + (count - failCount) + '删除成功', 'warning');
            auditData.desc += `共${count},${failCount}条设备信息删除失败`;
          }
          dispatch(createOperationAudit({ ...auditData, OperationResults: 0 }));
          callback && callback(false);
        }
      });
    });
  }
}
